{
  "translation": {
    "ADD_COMPANY.CODE.LABEL": "Kod firmy",
    "ADD_COMPANY.COUNTRY.LABEL": "Kraj",
    "ADD_COMPANY.COUNTRY.PLACEHOLDER": "Wybierz kraj",
    "ADD_COMPANY.CURRENCY.LABEL": "Waluta",
    "ADD_COMPANY.CURRENCY.PLACEHOLDER": "Wybierz walutę",
    "ADD_COMPANY.LANGUAGE.LABEL": "Język",
    "ADD_COMPANY.LOGO.LABEL": "Wybierz logo",
    "ADD_COMPANY.MEASUREMENT_TYPE.LABEL": "Typ pomiaru",
    "ADD_COMPANY.MEASUREMENT_TYPE.PLACEHOLDER": "Wybierz typ pomiaru",
    "ADD_COMPANY.NAME.LABEL": "Nazwa",
    "ADD_COMPANY.PARTNER.LABEL": "Partner",
    "ADD_COMPANY.PARTNER.PLACEHOLDER": "Wybór partnera",
    "ADD_COMPANY.RESPONSE.SUCCESS": "Spółka została pomyślnie utworzona",
    "ADD_COMPANY.SUBMIT": "Dodaj nową firmę",
    "ADD_COMPANY.TITLE": "Dodaj nową firmę",
    "ADD_COMPANY.VALIDATION.CODE": "Wymagany jest kod firmy",
    "ADD_COMPANY.VALIDATION.COUNTRY": "Wymagany jest kraj",
    "ADD_COMPANY.VALIDATION.CURRENCY": "Wymagana jest waluta",
    "ADD_COMPANY.VALIDATION.IMAGE": "Wymagane jest logo firmy",
    "ADD_COMPANY.VALIDATION.LANGUAGE": "Wymagany jest język",
    "ADD_COMPANY.VALIDATION.MEASUREMENT_TYPE": "Wymagany jest typ pomiaru",
    "ADD_COMPANY.VALIDATION.NAME": "Nazwa jest wymagana",
    "ADD_COMPANY.VALIDATION.PARTNER": "Wymagany jest partner",
    "ADD_FLOW_DATA.BTN.FLOW_DATA": "Dodaj dane przepływu",
    "ADD_FLOW_DATA.BTN.SUBMIT": "Prześlij",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.LABEL": "Data i godzina przepływu danych",
    "ADD_FLOW_DATA.INPUT.DATE_TIME.PLACEHOLDER": "Kliknij tutaj, aby wybrać datę i godzinę",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.LABEL": "Wartość",
    "ADD_FLOW_DATA.INPUT.FLOW_DATA.PLACEHOLDER": "Wartość danych przepływu",
    "ADD_FLOW_DATA.MODAL.ERROR.DESC": "Spróbuj ponownie, dane przepływu nie zostały zaktualizowane",
    "ADD_FLOW_DATA.MODAL.ERROR.TITLE": "Spróbuj ponownie!",
    "ADD_FLOW_DATA.MODAL.SUCCESS.DESC": "Dane dotyczące przepływu zostały zaktualizowane",
    "ADD_FLOW_DATA.MODAL.SUCCESS.TITLE": "Niesamowite!",
    "ADD_PARTNER.ADDRESS.LABEL": "Adres",
    "ADD_PARTNER.CODE.LABEL": "Kod",
    "ADD_PARTNER.COUNTRY.LABEL": "Kraj",
    "ADD_PARTNER.COUNTRY.PLACEHOLDER": "Wybierz kraj",
    "ADD_PARTNER.CURRENCY.LABEL": "Waluta",
    "ADD_PARTNER.CURRENCY.PLACEHOLDER": "Wybierz walutę",
    "ADD_PARTNER.LOGO.LABEL": "Wybierz logo",
    "ADD_PARTNER.NAME.LABEL": "Nazwa",
    "ADD_PARTNER.RESPONSE.SUCCESS": "Partner został pomyślnie utworzony",
    "ADD_PARTNER.SUBMIT": "Dodaj nowego partnera",
    "ADD_PARTNER.TITLE": "Dodaj nowego partnera",
    "ADD_PARTNER.VALIDATION.ADDRESS": "Adres jest wymagany",
    "ADD_PARTNER.VALIDATION.CODE": "Wymagany jest kod",
    "ADD_PARTNER.VALIDATION.COUNTRY": "Wymagany jest kraj",
    "ADD_PARTNER.VALIDATION.CURRENCY": "Wymagana jest waluta",
    "ADD_PARTNER.VALIDATION.IMAGE": "Wymagany jest wizerunek partnera",
    "ADD_PARTNER.VALIDATION.NAME": "Nazwa jest wymagana",
    "ADD_PROJECT.COMPANY.LABEL": "Firma",
    "ADD_PROJECT.COMPANY.PLACEHOLDER": "Wybór firmy",
    "ADD_PROJECT.COST_PER_KM.LABEL": "Koszt na KM (USD)",
    "ADD_PROJECT.CURRENCY.LABEL": "Waluta",
    "ADD_PROJECT.CURRENCY.PLACEHOLDER": "Wybierz walutę",
    "ADD_PROJECT.DMAS.LABEL": "DMA",
    "ADD_PROJECT.DMAS.NO_MATCHING": "Brak pasujących DMA",
    "ADD_PROJECT.DMAS.PLACEHOLDER": "Wybór DMA",
    "ADD_PROJECT.END_DATE.LABEL": "Data zakończenia",
    "ADD_PROJECT.MEASUREMENT_TYPE.LABEL": "Typ pomiaru",
    "ADD_PROJECT.MEASUREMENT_TYPE.PLACEHOLDER": "Wybierz typ pomiaru",
    "ADD_PROJECT.NAME.LABEL": "Dodaj nowy projekt",
    "ADD_PROJECT.RESPONSE.SUCCESS": "Projekt został pomyślnie utworzony",
    "ADD_PROJECT.START_DATE.LABEL": "Data rozpoczęcia",
    "ADD_PROJECT.SUBMIT": "Utwórz nowy projekt",
    "ADD_PROJECT.TITLE": "Dodaj nowy projekt",
    "ADD_PROJECT.VALIDATION.COMPANY": "Firma jest wymagana",
    "ADD_PROJECT.VALIDATION.COST_PER_KM": "Wymagany jest koszt na KM",
    "ADD_PROJECT.VALIDATION.CURRENCY": "Wymagana jest waluta",
    "ADD_PROJECT.VALIDATION.END_DATE": "Wymagana jest data zakończenia",
    "ADD_PROJECT.VALIDATION.MEASUREMENT_TYPE": "Wymagany jest typ pomiaru",
    "ADD_PROJECT.VALIDATION.NAME": "Nazwa jest wymagana",
    "ADD_PROJECT.VALIDATION.START_DATE": "Wymagana jest data rozpoczęcia",
    "ADD_USER.MODAL.BTN.CLOSE": "Zamknij okno modalne",
    "ADD_USER.RESPONSE.SUCCESS": "Użytkownik został pomyślnie utworzony",
    "ADD_USER.SUBMIT": "Dodaj nowego użytkownika",
    "ADD_USER.TITLE": "Dodaj nowego użytkownika",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_ID": "Identyfikator aktywów",
    "ASSET_TOOLTIP.DESC_TITLE.ASSET_TYPE": "Standardowy typ aktywów",
    "ASSET_TOOLTIP.ERROR": "Nie można pobrać informacji o zasobach",
    "ASSET_TOOLTIP.NO_DATA": "Brak dostępnych informacji o sesji",
    "ASSET_TOOLTIP.TABLE.HEADER.1": "Identyfikator sesji",
    "ASSET_TOOLTIP.TABLE.HEADER.2": "Identyfikator błędu",
    "ASSET_TOOLTIP.TABLE.HEADER.3": "Znacznik czasu",
    "ASSET_TOOLTIP.TABLE.HEADER.4": "Wynik",
    "ASSET_TOOLTIP.TITLE.ASSET": "Informacje o aktywach",
    "ASSET_TOOLTIP.TITLE.SESSION": "Informacje o sesji",
    "BREADCRUMB.FILTERS.COMPANY": "Firma",
    "BREADCRUMB.FILTERS.DATE_FROM": "Data od",
    "BREADCRUMB.FILTERS.DATE_TO": "Data do",
    "BREADCRUMB.FILTERS.DATEFROM": "Data od",
    "BREADCRUMB.FILTERS.DATETO": "Data do",
    "BREADCRUMB.FILTERS.DAY": "Dzień",
    "BREADCRUMB.FILTERS.ENGINEER": "Inżynier",
    "BREADCRUMB.FILTERS.PARTNER": "Partner",
    "BREADCRUMB.FILTERS.PROJECT": "Projekt",
    "BROWSE_HOME_PAGE.TITLE": "Wybierz typ danych, aby rozpocząć przeglądanie.",
    "BROWSE_VIEW.BACK_TO_LIST": "Powrót do listy",
    "BROWSE_VIEW.MEDIA_SECTION.EMPTY_MSG": "Brak multimediów dla tego punktu kontrolnego",
    "BROWSE_VIEW.MEDIA_SECTION.LABEL": "Głoska bezdźwięczna",
    "BROWSE_VIEW.RELAY.ADDRESS": "Adres",
    "BROWSE_VIEW.RELAY.DEPLOYED_BY": "Wdrożony przez",
    "BROWSE_VIEW.RELAY.LAST_CONTACT": "Ostatni kontakt",
    "BROWSE_VIEW.RELAY.LAST_UPLOADED": "Ostatnio przesłane",
    "BROWSE_VIEW.RELAY.NO_NAME_PLACEHOLDER": "Przekaźnik",
    "BROWSE_VIEW.RELAY.SESSION": "Sesja",
    "BROWSE_VIEW.RELAY.UPDATED": "Zaktualizowano",
    "BROWSE_VIEW.RELAY.W3W": "Jakie 3 słowa",
    "BROWSE_VIEW.SENSOR.BATTERY_VOLTAGE": "Napięcie akumulatora",
    "BROWSE_VIEW.SENSOR.COLLECTED_BY": "Zebrane przez",
    "BROWSE_VIEW.SENSOR.DEPLOYED_BY": "Wdrożony przez",
    "BROWSE_VIEW.SENSOR.END_TIME": "Czas końcowy",
    "BROWSE_VIEW.SENSOR.FIRMWARE_VERSION": "Wersja",
    "BROWSE_VIEW.SENSOR.LAST_UPLOADED": "Ostatnio przesłane",
    "BROWSE_VIEW.SENSOR.LATEST_SESSION": "Najnowsza sesja",
    "BROWSE_VIEW.SENSOR.SESSION": "Sesja",
    "BROWSE_VIEW.SENSOR.SESSION_TYPE": "Typ sesji",
    "BROWSE_VIEW.SENSOR.START_TIME": "Czas rozpoczęcia",
    "BROWSE_VIEW.SESSION.LAST_UPLOADED": "Ostatnio przesłane",
    "BROWSE_VIEW.WAYPOINT.ADD_JOB": "Dodaj zadanie",
    "BROWSE_VIEW.WAYPOINT.ADDRESS": "Adres",
    "BROWSE_VIEW.WAYPOINT.CREATED": "Stworzony",
    "BROWSE_VIEW.WAYPOINT.DIAMETER": "Średnica",
    "BROWSE_VIEW.WAYPOINT.ENG_NOTES": "Notatki inżynierskie",
    "BROWSE_VIEW.WAYPOINT.ENGINEER": "Przypisany inżynier",
    "BROWSE_VIEW.WAYPOINT.ENV_NOTES": "Notatki środowiskowe",
    "BROWSE_VIEW.WAYPOINT.MATERIAL": "Materiał rury",
    "BROWSE_VIEW.WAYPOINT.MERGE_WP": "Połącz punkty kontrolne",
    "BROWSE_VIEW.WAYPOINT.NO_NAME_PLACEHOLDER": "Nienazwany punkt orientacyjny",
    "BROWSE_VIEW.WAYPOINT.SECTION.ACTIVITIES": "Działania",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES": "Profile konsumpcji",
    "BROWSE_VIEW.WAYPOINT.SECTION.CONSUMPTION_PROFILES_EMTPY": "Brak profili zużycia dla tego punktu trasy",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS": "Korelacje",
    "BROWSE_VIEW.WAYPOINT.SECTION.CORRELATIONS_EMPTY": "Brak korelacji dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY": "Historia",
    "BROWSE_VIEW.WAYPOINT.SECTION.HISTORY_EMPTY": "Brak historii dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS": "Praca",
    "BROWSE_VIEW.WAYPOINT.SECTION.JOBS_EMPTY": "Brak zadań dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES": "Notatki",
    "BROWSE_VIEW.WAYPOINT.SECTION.NOTES_EMPTY": "Brak notatek dla tego punktu orientacyjnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS": "Sesje",
    "BROWSE_VIEW.WAYPOINT.SECTION.SESSIONS_EMPTY": "Brak sesji dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS": "Sondowania",
    "BROWSE_VIEW.WAYPOINT.SECTION.SOUNDINGS_EMPTY": "Brak sondowań dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS": "Najlepsze sondowania",
    "BROWSE_VIEW.WAYPOINT.SECTION.TOP_SOUNDINGS_EMPTY": "Brak sondowań dla tego punktu orientacyjnego",
    "BROWSE_VIEW.WAYPOINT.UPDATED": "Zaktualizowano",
    "BROWSE_VIEW.WAYPOINT.W3W": "Jakie 3 słowa",
    "BROWSE.FILTERS.COLLECTED_BY": "Zebrane przez",
    "BROWSE.FILTERS.COLLECTED_BY_PLACEHOLDER": "Wybierz zebrane przez użytkownika",
    "BROWSE.FILTERS.COMPANY": "Firma",
    "BROWSE.FILTERS.COMPANY_NAME": "Nazwa firmy",
    "BROWSE.FILTERS.COMPANY_PLACEHOLDER": "Wybierz firmy",
    "BROWSE.FILTERS.DEPLOYED_BY": "Wdrożony przez",
    "BROWSE.FILTERS.DEPLOYED_BY_PLACEHOLDER": "Wybierz wdrożone przez użytkownika",
    "BROWSE.FILTERS.DMA": "DMA",
    "BROWSE.FILTERS.DMA_KEY": "Klucz DMA",
    "BROWSE.FILTERS.DMA_PLACEHOLDER": "Wybierz DMA",
    "BROWSE.FILTERS.FILTER": "Filtr",
    "BROWSE.FILTERS.FROM": "Z",
    "BROWSE.FILTERS.ID": "ID",
    "BROWSE.FILTERS.JOB_TYPE": "Rodzaj pracy",
    "BROWSE.FILTERS.JOB_TYPE_PLACEHOLDER": "Wybierz kody typów zadań",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER": "Ostatni zaplanowany inżynier",
    "BROWSE.FILTERS.LAST_SCHEDULED_ENGINEER_PLACEHOLDER": "Wybierz ostatnio zaplanowanych inżynierów",
    "BROWSE.FILTERS.LEAK_RESULTS": "Wyniki wycieku",
    "BROWSE.FILTERS.LEAK_RESULTS_PLACEHOLDER": "Wybierz wyniki wycieku",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION": "Ostatni autor modyfikacji",
    "BROWSE.FILTERS.MOST_RECENT_AUTHOR_OF_MODIFICATION_PLACEHOLDER": "Wybierz użytkowników, którzy wykonali ostatnią akcję",
    "BROWSE.FILTERS.NAME": "Nazwa",
    "BROWSE.FILTERS.OTHERS": "Inni",
    "BROWSE.FILTERS.PARTNER": "Partner",
    "BROWSE.FILTERS.PARTNER_NAME": "Nazwa partnera",
    "BROWSE.FILTERS.PARTNER_PLACEHOLDER": "Wybierz partnerów",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE": "Przewidywany typ wycieku",
    "BROWSE.FILTERS.PREDICTED_LEAK_TYPE_PLACEHOLDER": "Wybierz przewidywane typy wycieków",
    "BROWSE.FILTERS.PREDICTED_SIZE": "Przewidywany rozmiar",
    "BROWSE.FILTERS.PREDICTED_SIZE_PLACEHOLDER": "Wybierz przewidywane rozmiary",
    "BROWSE.FILTERS.PREDICTED_SIZE.CORRELATION": "Korelacja",
    "BROWSE.FILTERS.PREDICTED_SIZE.ERROR": "Błąd",
    "BROWSE.FILTERS.PREDICTED_SIZE.LARGE": "Duży",
    "BROWSE.FILTERS.PREDICTED_SIZE.MEDIUM": "Średni",
    "BROWSE.FILTERS.PREDICTED_SIZE.NA": "Nie dotyczy",
    "BROWSE.FILTERS.PREDICTED_SIZE.NOT_ENOUGH_FILES": "Za mało plików",
    "BROWSE.FILTERS.PREDICTED_SIZE.SMALL": "Mały",
    "BROWSE.FILTERS.PROJECT": "Projekt",
    "BROWSE.FILTERS.PROJECT_PLACEHOLDER": "Wybierz projekty",
    "BROWSE.FILTERS.RELAY_CONNECTED": "Przekaźnik podłączony",
    "BROWSE.FILTERS.RELAYS": "Przekaźniki",
    "BROWSE.FILTERS.SELECT_FIELD": "Wybierz pole",
    "BROWSE.FILTERS.SENSORS": "Czujniki",
    "BROWSE.FILTERS.SESSION_STATUS.AWAITING_UPLOAD": "Oczekiwanie na przesłanie",
    "BROWSE.FILTERS.SESSION_STATUS.COMPLETED": "Zakończony",
    "BROWSE.FILTERS.SESSION_STATUS.DELETED": "Usunięto",
    "BROWSE.FILTERS.SESSION_STATUS.IN_PROGRESS": "W toku",
    "BROWSE.FILTERS.SESSION_TYPE.CONTINUOUS": "Ciągły",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION": "Korelacja",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_1_MIN_DELAY": "Korelacja: opóźnienie 1 minuty",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_12_MIN_DELAY": "Korelacja: opóźnienie 12 minut",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_15_MIN_DELAY": "Korelacja: opóźnienie 15 minut",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_5_MIN_DELAY": "Korelacja: opóźnienie 5 minut",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_8_MIN_DELAY": "Korelacja: opóźnienie 8 minut",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_CHILD": "Korelacja Dziecko",
    "BROWSE.FILTERS.SESSION_TYPE.CORRELATION_PARENT": "Korelacja Rodzic",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_DAY": "FCC: 3-minutowy dzień",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_3_MIN_NIGHT": "FCC: 3 minuty w nocy",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_DAY": "FCC: 5-minutowy dzień",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_5_MIN_NIGHT": "FCC: 5 minut w nocy",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_DAY": "FCC: 8-minutowy dzień",
    "BROWSE.FILTERS.SESSION_TYPE.FCC_8_MIN_NIGHT": "FCC: 8 minut w nocy",
    "BROWSE.FILTERS.SESSION_TYPE.FIVE_MINUTES": "5 minut",
    "BROWSE.FILTERS.SESSION_TYPE.ONE_HOUR": "1 godzina",
    "BROWSE.FILTERS.SESSION_TYPE.OVERNIGHT": "Nocny",
    "BROWSE.FILTERS.SESSION_TYPE.RELAY": "Przekaźnik",
    "BROWSE.FILTERS.SESSION_TYPE.SYSTEM_MODE": "Tryb systemu",
    "BROWSE.FILTERS.SESSION_TYPE.TEST": "Test",
    "BROWSE.FILTERS.SESSION_TYPE.THIRTY_MINUTES": "30 minut",
    "BROWSE.FILTERS.SESSION_TYPE.TWENTY_FOUR_HOURS": "24 godziny",
    "BROWSE.FILTERS.SESSION_TYPE.TYPE": "Typ",
    "BROWSE.FILTERS.SESSION_TYPES": "Typy sesji",
    "BROWSE.FILTERS.SESSION_TYPES_PLACEHOLDER": "Wybierz typy sesji",
    "BROWSE.FILTERS.SESSIONS": "Sesje",
    "BROWSE.FILTERS.SORTING": "Sortowanie",
    "BROWSE.FILTERS.STATUS": "Status",
    "BROWSE.FILTERS.STATUS_PLACEHOLDER": "Wybierz statusy",
    "BROWSE.FILTERS.STATUS.MAINTENANCE_ALERT": "Alert konserwacyjny",
    "BROWSE.FILTERS.STATUS.OFFLINE": "Niedostępny",
    "BROWSE.FILTERS.STATUS.OK": "OK",
    "BROWSE.FILTERS.STATUS.ONLINE": "W sieci",
    "BROWSE.FILTERS.STATUS.WARNING": "Ostrzeżenie",
    "BROWSE.FILTERS.TO": "Do",
    "BROWSE.FILTERS.TYPES": "Typy",
    "BROWSE.FILTERS.TYPES_PLACEHOLDER": "Wybierz typy sesji",
    "BROWSE.FILTERS.WAYPOINTS": "Punkty orientacyjne",
    "BROWSE.LABELS.TYPE": "Typ",
    "BROWSE.LAYOUT.LOADING_MAP": "Ładowanie mapy",
    "BROWSE.LAYOUT.LOADING_MAP_DESCRIPTION": "Proszę czekać, aż zainicjujemy mapę interaktywną...",
    "BROWSE.LAYOUT.LOADING_PREVIEW": "Ładowanie podglądu",
    "BROWSE.LAYOUT.LOADING_PREVIEW_DESCRIPTION": "Poczekaj, aż załadujemy udostępniony podgląd...",
    "BROWSE.LIST.BACK_TO_LIST": "Powrót do listy",
    "BROWSE.LIST.JOBS_VIEW_ACTIVE": "Oferty pracy Zobacz aktywne",
    "BROWSE.LIST.JOBS_VIEW_DESCRIPTION": "Dane dotyczące zadania wyświetlane są na mapie",
    "BROWSE.PANEL.COLLAPSE": "Zwiń panel",
    "BROWSE.PANEL.EXPAND": "Rozwiń panel",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_FOUND_LAST_7_DAYS": "Wycieki wykryte w ciągu ostatnich 7 dni",
    "BROWSE.PREDEFINED_VIEWS.LEAKS_MARKED_UP_LAST_7_DAYS": "Wycieki odnotowane w ciągu ostatnich 7 dni",
    "BROWSE.PREDEFINED_VIEWS.RELAY_NEEDS_MAINTENANCE": "Przekaźnik wymaga konserwacji",
    "BROWSE.PREDEFINED_VIEWS.RELAY_WARNINGS_LAST_7_DAYS": "Ostrzeżenia przekaźnikowe w ciągu ostatnich 7 dni",
    "BROWSE.PREVIEW.CHANGE_WAYPOINT": "zmień punkt kontrolny",
    "BROWSE.SHARE.ADD_EMAIL": "Dodaj adres e-mail",
    "BROWSE.SHARE.ADD_MESSAGE": "Dodaj wiadomość",
    "BROWSE.SHARE.COPY_LINK": "Kopiuj link",
    "BROWSE.SHARE.ERROR.COPY_CLIPBOARD_FAILED": "Nie udało się skopiować linku do schowka",
    "BROWSE.SHARE.ERROR.GENERATE_LINK_FAILED": "Nie udało się wygenerować linku do udostępniania",
    "BROWSE.SHARE.REMOVE_EMAIL": "Usunąć %1$s",
    "BROWSE.SHARE.SEND": "Wysłać",
    "BROWSE.SHARE.SUCCESS.EMAIL_SENT_AND_LINK_COPIED": "E-mail został wysłany, a link skopiowany do schowka!",
    "BROWSE.SHARE.SUCCESS.LINK_COPIED": "Link skopiowany do schowka!",
    "BROWSE.TABLE.COLUMNS.ADDRESS": "Adres",
    "BROWSE.TABLE.COLUMNS.ASSET": "Zaleta",
    "BROWSE.TABLE.COLUMNS.BATTERY_VOLTAGE": "Napięcie akumulatora",
    "BROWSE.TABLE.COLUMNS.COLLECTED_BY": "Zebrane przez",
    "BROWSE.TABLE.COLUMNS.COMMENT": "Komentarz",
    "BROWSE.TABLE.COLUMNS.COMPANY": "Firma",
    "BROWSE.TABLE.COLUMNS.COMPANY_NAME": "Nazwa firmy",
    "BROWSE.TABLE.COLUMNS.CREATED_AT": "Utworzono w",
    "BROWSE.TABLE.COLUMNS.CREATED_DATE": "Data utworzenia",
    "BROWSE.TABLE.COLUMNS.DEPLOYED_BY": "Wdrożony przez",
    "BROWSE.TABLE.COLUMNS.DMA": "DMA",
    "BROWSE.TABLE.COLUMNS.END_DATE": "Data zakończenia",
    "BROWSE.TABLE.COLUMNS.END_TIME": "Czas końcowy",
    "BROWSE.TABLE.COLUMNS.ENVIRONMENTAL_NOTES": "Notatki środowiskowe",
    "BROWSE.TABLE.COLUMNS.EST_SIZE_ENG": "Szacunkowy rozmiar (ang.)",
    "BROWSE.TABLE.COLUMNS.EXPECTED_FINISH": "Oczekiwany termin zakończenia",
    "BROWSE.TABLE.COLUMNS.FIRMWARE": "Oprogramowanie układowe",
    "BROWSE.TABLE.COLUMNS.FLOW_REDUCTION": "Redukcja przepływu",
    "BROWSE.TABLE.COLUMNS.ID": "ID",
    "BROWSE.TABLE.COLUMNS.JOB_COUNT": "Liczba zadań",
    "BROWSE.TABLE.COLUMNS.JOB_TYPE_CODE": "Kod typu pracy",
    "BROWSE.TABLE.COLUMNS.JOBS": "Praca",
    "BROWSE.TABLE.COLUMNS.LAST_ACTION_BY": "Ostatnia akcja przez",
    "BROWSE.TABLE.COLUMNS.LAST_CONTACT": "Ostatni kontakt",
    "BROWSE.TABLE.COLUMNS.LAST_SCHEDULED_ENGINEER": "Ostatni zaplanowany inżynier",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATE": "Ostatnia aktualizacja",
    "BROWSE.TABLE.COLUMNS.LAST_UPDATED": "Ostatnia aktualizacja",
    "BROWSE.TABLE.COLUMNS.LATITUDE": "Szerokość",
    "BROWSE.TABLE.COLUMNS.LEAK_RESULT": "Wynik wycieku",
    "BROWSE.TABLE.COLUMNS.LEAK_SIZE": "Rozmiar wycieku",
    "BROWSE.TABLE.COLUMNS.LONGITUDE": "Długość geograficzna",
    "BROWSE.TABLE.COLUMNS.MAC_ADDRESS": "Adres MAC",
    "BROWSE.TABLE.COLUMNS.NAME": "Nazwa",
    "BROWSE.TABLE.COLUMNS.PARTNER": "Partner",
    "BROWSE.TABLE.COLUMNS.PARTNER_NAME": "Nazwa partnera",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER": "Średnica rury",
    "BROWSE.TABLE.COLUMNS.PIPE_DIAMETER_UNITS": "Jednostki średnicy rury",
    "BROWSE.TABLE.COLUMNS.PIPE_MATERIAL": "Materiał rury",
    "BROWSE.TABLE.COLUMNS.PREDICTED_LEAK_TYPE": "Przewidywany typ wycieku",
    "BROWSE.TABLE.COLUMNS.PREDICTED_SIZE": "Przewidywany rozmiar",
    "BROWSE.TABLE.COLUMNS.PROJECT": "Projekt",
    "BROWSE.TABLE.COLUMNS.RELAY_CONNECTED": "Przekaźnik podłączony",
    "BROWSE.TABLE.COLUMNS.RELAY_ID": "Identyfikator przekaźnika",
    "BROWSE.TABLE.COLUMNS.RELAY_NAME": "Nazwa przekaźnika",
    "BROWSE.TABLE.COLUMNS.SENSOR_ID": "ID czujnika",
    "BROWSE.TABLE.COLUMNS.SENSOR_MAC": "Czujnik MAC",
    "BROWSE.TABLE.COLUMNS.SENSOR_NAME": "Nazwa czujnika",
    "BROWSE.TABLE.COLUMNS.SESSION": "Sesja",
    "BROWSE.TABLE.COLUMNS.SESSION_COUNT": "Liczba sesji",
    "BROWSE.TABLE.COLUMNS.SESSION_ID": "Identyfikator sesji",
    "BROWSE.TABLE.COLUMNS.SESSION_TYPE": "Typ sesji",
    "BROWSE.TABLE.COLUMNS.SESSIONS": "Sesje",
    "BROWSE.TABLE.COLUMNS.SIZE": "Rozmiar",
    "BROWSE.TABLE.COLUMNS.START_DATE": "Data rozpoczęcia",
    "BROWSE.TABLE.COLUMNS.START_TIME": "Czas rozpoczęcia",
    "BROWSE.TABLE.COLUMNS.STATUS": "Status",
    "BROWSE.TABLE.COLUMNS.SURFACE_TYPE": "Rodzaj powierzchni",
    "BROWSE.TABLE.COLUMNS.UPDATE_DATE": "Data aktualizacji",
    "BROWSE.TABLE.COLUMNS.WAYPOINT_NAME": "Nazwa punktu trasy",
    "BROWSE.TABLE.COLUMNS.WHAT3WORDS": "What3Words",
    "BROWSE.TABLE.ID_PREFIX": "ID:",
    "BROWSE.TABLE.SORT_BY": "Sortuj według %1$s",
    "BROWSE.TABS.RELAYS": "Przekaźniki",
    "BROWSE.TABS.SENSORS": "Czujniki",
    "BROWSE.TABS.SESSIONS": "Sesje",
    "BROWSE.TABS.WAYPOINTS": "Punkty orientacyjne",
    "BROWSE.VIEWS.CREATED_SUCCESS": "Widok niestandardowy został pomyślnie utworzony",
    "BROWSE.VIEWS.DELETE_CONFIRM": "Usunąć zapisany widok?",
    "BROWSE.VIEWS.DELETE_DESCRIPTION": "Spowoduje to trwałe usunięcie „%1$s\".",
    "BROWSE.VIEWS.EMPTY": "Brak zapisanych widoków",
    "BROWSE.VIEWS.LOAD_ERROR": "Nie udało się załadować widoków",
    "BROWSE.VIEWS.LOADING": "Ładowanie widoków...",
    "BROWSE.VIEWS.POPOVER_DESCRIPTION": "Możesz zapisać swoje ulubione filtry i uzyskać do nich dostęp jednym kliknięciem tutaj",
    "BROWSE.VIEWS.SAVE_BUTTON": "Zapisz widok",
    "BROWSE.VIEWS.SAVE_DESCRIPTION": "Podaj nazwę swojego widoku niestandardowego, aby zapisać bieżące filtry.",
    "BROWSE.VIEWS.SAVE_TITLE": "Zapisz widok niestandardowy",
    "BROWSE.VIEWS.VIEW_NAME_LABEL": "Wyświetl nazwę",
    "BROWSE.VIEWS.VIEW_NAME_PLACEHOLDER": "Wprowadź nazwę widoku",
    "BROWSE.VIEWS.YOUR_SAVED_VIEWS": "Twoje zapisane widoki",
    "BROWSE.VIEWS.YOUR_VIEWS_SHORT": "Twoje poglądy",
    "CHANGE_LOG.ACTIONS.CREATE_BRANCH": "Utwórz projekt",
    "CHANGE_LOG.ACTIONS.CREATE_COMPANY": "Utwórz firmę",
    "CHANGE_LOG.ACTIONS.CREATE_USER": "Tworzenie zaproszenia użytkownika",
    "CHANGE_LOG.ACTIONS.DELETE_BRANCH": "Usuń projekt",
    "CHANGE_LOG.ACTIONS.DELETE_COMPANY": "Usuń firmę",
    "CHANGE_LOG.ACTIONS.DELETE_USER": "Usuń użytkownika",
    "CHANGE_LOG.ACTIONS.EDIT_COMPANY": "Edytuj firmę",
    "CHANGE_LOG.ACTIONS.FORGOT_PASSWORD": "Wyślij wiadomość e-mail z linkiem do odzyskiwania",
    "CHANGE_LOG.ACTIONS.GET_COMPANY": "Uzyskaj firmę",
    "CHANGE_LOG.ACTIONS.LOGIN": "Logowanie",
    "CHANGE_LOG.ACTIONS.SET_PASSWORD": "Ustawianie hasła profilu",
    "CHANGE_LOG.ACTIONS.TOKEN_DECODE": "Dekodowanie tokenu e-mail",
    "CHANGE_LOG.ACTIONS.UPDATE_BRANCH": "Projekt został zaktualizowany",
    "CHANGE_LOG.ACTIONS.UPDATE_USER": "Profil użytkownika został zaktualizowany",
    "CHANGE_LOG.FILTERS.ACTION.LABEL": "Działanie",
    "CHANGE_LOG.FILTERS.ACTION.PLACEHOLDER": "Wybierz działanie",
    "CHANGE_LOG.FILTERS.BRANCH.LABEL": "Projekt",
    "CHANGE_LOG.FILTERS.BRANCH.PLACEHOLDER": "Wybierz projekt",
    "CHANGE_LOG.FILTERS.CLEAR": "Odrzucenie",
    "CHANGE_LOG.FILTERS.COMPANY.LABEL": "Firma",
    "CHANGE_LOG.FILTERS.COMPANY.PLACEHOLDER": "Wybór firmy",
    "CHANGE_LOG.FILTERS.DATE.LABEL": "Data",
    "CHANGE_LOG.FILTERS.DATE.PLACEHOLDER": "Wybierz datę",
    "CHANGE_LOG.FILTERS.EMAIL.LABEL": "E-mail",
    "CHANGE_LOG.FILTERS.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "CHANGE_LOG.FILTERS.ERASE": "Wyczyść",
    "CHANGE_LOG.FILTERS.STATUS.LABEL": "Status",
    "CHANGE_LOG.FILTERS.STATUS.PLACEHOLDER": "Wybierz status",
    "CHANGE_LOG.FILTERS.SUBMIT": "Filtr",
    "CHANGE_LOG.FILTERS.TITLE": "Filtry",
    "CHANGE_LOG.STATUSES.FAILURE": "Awaria",
    "CHANGE_LOG.STATUSES.SUCCESS": "Sukces",
    "CHANGE_LOG.TABLE.ACTION": "Działanie",
    "CHANGE_LOG.TABLE.BRANCH": "Projekt",
    "CHANGE_LOG.TABLE.COMPANY": "Firma",
    "CHANGE_LOG.TABLE.DATE": "Data",
    "CHANGE_LOG.TABLE.EMAIL": "E-mail",
    "CHANGE_LOG.TABLE.NAME": "Nazwa",
    "CHANGE_LOG.TABLE.NUMBER": "№",
    "CHANGE_LOG.TABLE.ROLE": "Rola",
    "CHANGE_LOG.TABLE.STATUS": "Status",
    "CHANGE_LOG.TABLE.TIME": "Czas",
    "CHANGE_LOG.TITLE.NO_LOGS": "Nie ma dzienników",
    "CHANGE_LOG.TITLE.TOTAL_COUNT": "Łączna liczba dzienników:",
    "CHATBOT.DEFAULT_ASSISTANT_MSG": "Jak mogę ci pomóc?",
    "CHATBOT.INPUT.PLACEHOLDER": "Napisz wiadomość",
    "CHATBOT.OFFLINE_MSG": "askFIDO jest obecnie niedostępne. Spróbuj ponownie później.",
    "CHATBOT.RATING.RESPONSE": "Dziękujemy za opinię",
    "CHATBOT.SUBHEADING": "Online",
    "CHATBOT.SUBHEADING_ERROR": "Offline",
    "CHATBOT.YOU": "Ty",
    "COMMON.ACTION.CANCEL": "Anulować",
    "COMMON.ACTION.CLEAR": "Jasne",
    "COMMON.ACTION.CLEAR_SEARCH": "Wyczyść wyszukiwanie",
    "COMMON.ACTION.CLOSE": "Zamknąć",
    "COMMON.ACTION.COPY_COORDINATES": "Kopiuj współrzędne",
    "COMMON.ACTION.COPY_COORDINATES_TO_CLIPBOARD": "Kopiuj współrzędne do schowka",
    "COMMON.ACTION.DELETE": "Usuwać",
    "COMMON.ACTION.LOAD_MORE": "Załaduj więcej",
    "COMMON.ACTION.RESET": "Nastawić",
    "COMMON.ACTION.SAVING": "Oszczędność...",
    "COMMON.ACTION.SEARCH": "Szukaj",
    "COMMON.ACTION.SHARE": "Udział",
    "COMMON.BOOLEAN.NO": "NIE",
    "COMMON.BOOLEAN.YES": "Tak",
    "COMMON.BUTTON.EDIT": "redagować",
    "COMMON.BUTTON.OPEN": "Otwarte",
    "COMMON.BUTTON.SHARE": "udział",
    "COMMON.DATE.PLACEHOLDER.DDMMYYYY": "dd/mm/rrrr",
    "COMMON.EMPTY.ADJUST_FILTERS_OR_SEARCH": "Spróbuj dostosować filtry lub kryteria wyszukiwania",
    "COMMON.EMPTY.ADJUST_SEARCH_TERMS": "Spróbuj dostosować warunki wyszukiwania lub sprawdź, czy nie ma literówek",
    "COMMON.EMPTY.NO_DATA": "Brak danych.",
    "COMMON.EMPTY.NO_RESULTS_FOUND": "Nie znaleziono wyników",
    "COMMON.ERROR.FAILED_TO_LOAD_DATA": "Nie udało się załadować danych",
    "COMMON.ERROR.GENERIC_TRY_AGAIN_LATER": "Wystąpił błąd podczas pobierania danych. Spróbuj ponownie później.",
    "COMMON.ERROR.SUGGESTIONS_FETCH": "Wystąpił błąd podczas pobierania sugestii. Spróbuj ponownie później.",
    "COMMON.FILTERS.APPLY_FILTERS": "Zastosuj filtry",
    "COMMON.FILTERS.EMAILS_PLACEHOLDER": "Filtruj wiadomości e-mail...",
    "COMMON.FILTERS.SAVE_FILTERS": "Zapisz filtry",
    "COMMON.FILTERS.TOGGLE_FILTERS": "przełącz filtry",
    "COMMON.FORM.PLACEHOLDER.ZERO": "0",
    "COMMON.LOADING.GENERIC": "Załadunek...",
    "COMMON.LOADING.SUGGESTIONS": "Ładowanie sugestii...",
    "COMMON.MEDIA.PAUSE_VIDEO": "Wstrzymaj wideo",
    "COMMON.MEDIA.PLAY_AUDIO": "Odtwórz dźwięk",
    "COMMON.MEDIA.PLAY_VIDEO": "Odtwórz wideo",
    "COMMON.MEDIA.UPLOAD_ALT": "Przesłane media",
    "COMMON.MEDIA.VIDEO_LOAD_ERROR": "Wystąpił błąd podczas ładowania filmu. Spróbuj ponownie później.",
    "COMMON.PAGINATION.NEXT_PAGE": "Przejdź do następnej strony",
    "COMMON.PAGINATION.OF": "z",
    "COMMON.PAGINATION.PAGE_TITLE": "Strona %1$s",
    "COMMON.PAGINATION.PREVIOUS_PAGE": "Przejdź do poprzedniej strony",
    "COMMON.PAGINATION.ROWS_PER_PAGE": "Wierszy na stronę",
    "COMMON.SEARCH.RESULTS": "Wyniki",
    "COMMON.SEARCH.SUGGESTIONS": "Sugestie",
    "COMMON.SEARCH.WAITING_FOR_TYPING": "Czekam, aż skończysz pisać...",
    "COMMON.SORT.ASC": "Rosnąco",
    "COMMON.SORT.DESC": "Zstępujący",
    "COMMON.TABLE.COLUMNS_SETTINGS": "Ustawienia kolumn",
    "COMMON.TABLE.CUSTOMIZE_TABLE": "Dostosuj tabelę",
    "COMMON.TABLE.CUSTOMIZE_TABLE_DESCRIPTION": "Zmień kolejność, przypnij i przełącz widoczność kolumn",
    "COMMON.TABLE.DRAG_TO_PIN": "Przeciągnij kolumny tutaj, aby je przypiąć",
    "COMMON.TABLE.DRAG_TO_REORDER": "Przeciągnij, aby zmienić kolejność",
    "COMMON.TABLE.DRAG_TO_UNPIN": "Przeciągnij kolumny tutaj, aby je odpiąć",
    "COMMON.TABLE.MANAGE_COLUMNS": "Zarządzaj kolumnami",
    "COMMON.TABLE.MAX_PINNED_COLUMNS_REACHED": "Osiągnięto maksymalną liczbę przypiętych kolumn",
    "COMMON.TABLE.OTHER_COLUMNS": "Inne kolumny",
    "COMMON.TABLE.PIN_COLUMN": "Kolumna szpilkowa",
    "COMMON.TABLE.PINNED_COLUMNS": "Przypięte kolumny",
    "COMMON.TABLE.PINNED_COLUMNS_COUNT": "Przypięte kolumny (%1$s/%1$s)",
    "COMMON.TABLE.UNPIN_COLUMN": "Odepnij kolumnę",
    "COMMON.UPLOAD.CHOOSE_FILE": "Wybierz plik",
    "COMMON.VALIDATION.INVALID_EMAIL": "Nieprawidłowy adres e-mail",
    "COMMON.VIEW.CLASSIC_VIEW": "Widok klasyczny",
    "COMMON.VIEW.LIST_VIEW": "Widok listy",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.COMPANIES": "Firmy",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.DEFAULT_TITLE": "Wybór partnera lub firmy",
    "COMPANIES_PAGE.ACCOUNT_SWITCHER.PARTNERS": "Partnerzy",
    "COMPANIES_PAGE.ADD_COMPANY.BUTTON": "Nowa firma",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.LABEL": "Adres firmy",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.ADDRESS.PLACEHOLDER": "Wprowadź adres",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.LABEL": "Nazwa firmy",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.NAME.PLACEHOLDER": "Wprowadź nazwę",
    "COMPANIES_PAGE.ADD_COMPANY.FORM.SUBMIT": "Dodaj",
    "COMPANIES_PAGE.ADD_COMPANY.TITLE": "Dodaj nową firmę",
    "COMPANIES_PAGE.CRUMB": "Firmy",
    "COMPANIES_PAGE.DELETE_COMPANY.TITLE": "Czy na pewno chcesz usunąć tę firmę?",
    "COMPANIES_PAGE.SUBTITLE": "Inne ważne informacje znajdują się tutaj",
    "COMPANIES_PAGE.TABLE.ACTIONS": "Działania",
    "COMPANIES_PAGE.TABLE.ADDRESS": "Adres",
    "COMPANIES_PAGE.TABLE.BRANCHES": "Projekty",
    "COMPANIES_PAGE.TABLE.ID": "ID",
    "COMPANIES_PAGE.TABLE.INDEX": "№",
    "COMPANIES_PAGE.TABLE.NAME": "Nazwa",
    "COMPANIES_PAGE.TABLE.REPORTS": "Łączna liczba raportów niestandardowych",
    "COMPANIES_PAGE.TABLE.USERS": "Całkowita liczba użytkowników",
    "COMPANIES_PAGE.TITLE.NO_COMPANIES": "Nie ma żadnych firm",
    "COMPANIES_PAGE.TITLE.TOTAL_COUNT": "Total Companies:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ALLOCATE_LE": "Przydziel LE",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_ERROR": "Błąd, spróbuj ponownie",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.API_SUCCESS": "Sukces, punkty trasy zostały przydzielone",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.ASSIGN_WAYPOINTS": "Przypisywanie wybranych punktów trasy do Leak Engineer",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CHANGE": "Zmiana",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.CLOSE": "Zamknij",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.NO_WAYPOINTS": "Nie wybrano żadnych punktów trasy",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.OPTION_ENGINEER": "Inżynier:",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.REMOVE": "usunąć",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SEARCH.PLACEHOLDER": "Szukaj inżyniera",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SELECTING_ERROR": "Wybierz inżyniera i punkty trasy",
    "COMPONENTS.ALLOCATE_LEAK_ENGINEER.SUBMIT_BTN": "Przypisywanie punktów trasy",
    "COMPONENTS.COMPANY_SELECT.CHOOSE_COMPANY": "Wybór firmy/partnera",
    "COMPONENTS.COMPANY_SELECT.COMPANY": "Projekt",
    "COMPONENTS.COMPANY_SELECT.ERROR": "Ups! Coś poszło nie tak. Odśwież stronę i spróbuj ponownie.",
    "COMPONENTS.COMPANY_SELECT.FORM.SEARCH.PLACEHOLDER": "Wyszukaj firmę, partnera lub projekt",
    "COMPONENTS.COMPANY_SELECT.FORM.SELECT.PLACEHOLDER": "Wybierz typ danych",
    "COMPONENTS.COMPANY_SELECT.NO_DATA": "Nie ma dostępnych projektów",
    "COMPONENTS.COMPANY_SELECT.NO_RESULTS": "Nie znaleziono wyników",
    "COMPONENTS.COMPANY_SELECT.PARTNER": "Firma/Partner",
    "COMPONENTS.COMPANY_SELECT.VIEW": "Pogląd",
    "COMPONENTS.DATE_VIEWER.END_DATE": "Data zakończenia",
    "COMPONENTS.DATE_VIEWER.START_DATE": "Data rozpoczęcia",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.COMPANIES": "Firmy",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.ENGINEERS": "Inżynierowie",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PARTNERS": "Partnerzy",
    "COMPONENTS.DELIVERY_PERFORMANCE_FITLERS.PLACEHOLDERS.PROJECTS": "Projekty",
    "COMPONENTS.ERROR_BOUNDARY.MESSAGE": "Wystąpił nieoczekiwany błąd",
    "COMPONENTS.ERROR_BOUNDARY.RELOAD": "Odśwież stronę",
    "COMPONENTS.ERROR_BOUNDARY.SHOW_STACK": "Pokaż stos błędów (rozwój)",
    "COMPONENTS.ERROR_BOUNDARY.TITLE": "Ups! Coś poszło nie tak",
    "COMPONENTS.FILE_UPLOAD.BROWSE": "Przeglądaj plik",
    "COMPONENTS.FILE_UPLOAD.DRAG_TEXT": "Przeciągnij i upuść",
    "COMPONENTS.FILE_UPLOAD.ERROR": "Plik jest wymagany",
    "COMPONENTS.FILE_UPLOAD.FILES": "Pliki",
    "COMPONENTS.FILE_UPLOAD.OR": "Lub",
    "COMPONENTS.FILE_UPLOAD.SUPPORTED": "Wsparcie: ",
    "COMPONENTS.FILTER.CLOSE": "Zamknij",
    "COMPONENTS.FILTER.SELECT_A_DMA": "Wybierz DMA",
    "COMPONENTS.FILTER.SELECT_A_PROJECT": "Wybierz projekt",
    "COMPONENTS.FILTER.SELECT_A_SIZE": "Wybierz rozmiar",
    "COMPONENTS.FILTER.SELECT_A_STATUS": "Wybierz status",
    "COMPONENTS.FILTER.SELECT_DMA": "Wybierz DMA",
    "COMPONENTS.FILTER.SELECT_PROJECT": "Wybierz projekt",
    "COMPONENTS.FILTER.SELECT_SIZE": "Wybierz rozmiar",
    "COMPONENTS.FILTER.SELECT_STATUS": "Wybierz status",
    "COMPONENTS.FUNNEL_CHART.ERROR_MSG": "Brak danych",
    "COMPONENTS.GRAPH_TOGGLE.SPECTRAL_PROFILE": "Profil widmowy",
    "COMPONENTS.HISTORY_CONTAINER.ACTION": "Działanie",
    "COMPONENTS.HISTORY_CONTAINER.DATETIME": "Data i godzina",
    "COMPONENTS.HISTORY_CONTAINER.ID": "ID",
    "COMPONENTS.HISTORY_CONTAINER.NOTES": "notatki",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT": "referencyjny punkt trasy",
    "COMPONENTS.HISTORY_CONTAINER.REFERENCE_WAYPOINT_ID": "identyfikator referencyjnego punktu trasy",
    "COMPONENTS.HISTORY_CONTAINER.SCHEDULED_DATE": "planowana data",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_CHANGED_FROM_ID": "status zmieniony z id",
    "COMPONENTS.HISTORY_CONTAINER.STATUS_NAME": "zmieniono na nazwę statusu",
    "COMPONENTS.HISTORY_CONTAINER.TIME_ELAPSED": "Upływający czas",
    "COMPONENTS.HISTORY_CONTAINER.TITLE": "Historia z dzienników punktów trasy",
    "COMPONENTS.HISTORY_CONTAINER.USER_ID": "identyfikator użytkownika",
    "COMPONENTS.HISTORY_CONTAINER.USER_NAME": "Autor modyfikacji",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_ID": "identyfikator punktu trasy",
    "COMPONENTS.HISTORY_CONTAINER.WAYPOINT_NAME": "nazwa punktu trasy",
    "COMPONENTS.ICON_INSIGHT.ALT": "Ikona informacji",
    "COMPONENTS.IMAGE_UPLOAD_BOX.BUTTON_TEXT": "Przeglądaj zdjęcia",
    "COMPONENTS.IMAGE_UPLOAD_BOX.DRAG_TEXT": "Przeciągnij i upuść",
    "COMPONENTS.IMAGE_UPLOAD_BOX.IMAGE_TYPE": "Obsługiwane formaty: *.png, *.jpg i *.jpeg",
    "COMPONENTS.IMAGE_UPLOAD_BOX.OR": "LUB",
    "COMPONENTS.INSERT_DATE.ADD.END_DATE": "Dodaj datę końcową",
    "COMPONENTS.INSERT_DATE.ADD.START_DATE": "Dodaj datę rozpoczęcia",
    "COMPONENTS.INSERT_DATE.DATE.LABEL": "Data",
    "COMPONENTS.INSERT_DATE.DATE.PLACEHOLDER": "Wybierz datę",
    "COMPONENTS.INSERT_DATE.EDIT.END_DATE": "Edytuj datę końcową",
    "COMPONENTS.INSERT_DATE.EDIT.START_DATE": "Edytuj datę rozpoczęcia",
    "COMPONENTS.INSERT_DATE.FAILURE_DESC": "Spróbuj ponownie, aktualizacja nie powiodła się",
    "COMPONENTS.INSERT_DATE.FAILURE_TITLE": "Spróbuj ponownie!",
    "COMPONENTS.INSERT_DATE.OK": "OK",
    "COMPONENTS.INSERT_DATE.SUBMIT": "Prześlij",
    "COMPONENTS.INSERT_DATE.SUCCESS_DESC": "Data została zaktualizowana",
    "COMPONENTS.INSERT_DATE.SUCCESS_TITLE": "Niesamowite!",
    "COMPONENTS.LEAK_SIZE_FUNNEL.LARGE": "Duży wyciek",
    "COMPONENTS.LEAK_SIZE_FUNNEL.MEDIUM": "Średni wyciek",
    "COMPONENTS.LEAK_SIZE_FUNNEL.SMALL": "Mały wyciek",
    "COMPONENTS.PAGINATION.PAGE_OF": "{{page}} z {{total}}",
    "COMPONENTS.PAGINATION.ROWS_PER_PAGE": "Wierszy na stronę",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_DESC": "Spróbuj ponownie, raport nie powiódł się",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.FAILURE_TITLE": "Spróbuj ponownie!",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.OK": "OK",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.POST_PROJECT_DESC": "Raport ten zostanie wysłany pocztą elektroniczną po jego przesłaniu.",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SELECT_FORMAT": "Wybierz format",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_DESC": "Twój raport został utworzony. Sprawdź szczegóły w wiadomości e-mail",
    "COMPONENTS.POST_PROJECT_REPORT_BUTTON.SUCCESS_TITLE": "Niesamowite!",
    "COMPONENTS.PROGRESS_BAR.END_DATE": "Data zakończenia",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_A": "Wdrożony rurociąg",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_B": "Pobrany rurociąg",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_C": "Docelowy postęp",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_D": "Przesłano do FIDO AI",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_E": "Wdrożony",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_F": "Zatwierdzony",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_G": "Oznaczone do naprawy",
    "COMPONENTS.PROGRESS_BAR.KEY.ITEM_H": "Zidentyfikowany przez FIDO AI",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_REDUCTION": "Woda zaoszczędzona z przewidywanych wycieków, zaznaczonych wycieków do naprawy i zatwierdzonych wycieków, pokazana w stosunku do celu redukcji.",
    "COMPONENTS.PROGRESS_BAR.LEAKAGE_TITLE": "Redukcja wycieków",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_COVERAGE": "Pokrycie rurociągu Wskazuje ułamek całkowitego rurociągu, który został pokryty, pokazany w procentach.",
    "COMPONENTS.PROGRESS_BAR.PIPELINE_TITLE": "Pokrycie rurociągu",
    "COMPONENTS.PROGRESS_BAR.SESSIONS": "Sesje",
    "COMPONENTS.PROGRESS_BAR.START_DATE": "Data rozpoczęcia",
    "COMPONENTS.PROGRESS_BAR.TARGET_LEAKAGE.ERROR_MSG": "Określ cel redukcji wycieków, aby aktywować wyświetlanie postępu.",
    "COMPONENTS.PROGRESS_BAR.TARGET_PIPELINE.ERROR_MSG": "Określ docelową odległość zasięgu rurociągu, aby aktywować wyświetlanie postępu.",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_RESULTS": "Wyniki dotyczące rozmiaru wycieku",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.LARGE": "duży",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.MEDIUM": "średni",
    "COMPONENTS.PROPORTIONAL_BAR.LEAK_SIZE.SMALL": "mały",
    "COMPONENTS.PROPORTIONAL_BAR.NO_LEAKS": "Nie wykryto żadnych wycieków.",
    "COMPONENTS.PROPORTIONAL_BAR.TITLE": "Procent lub liczba wycieków",
    "COMPONENTS.SEARCH_BAR.GENERIC": "Wyszukiwanie",
    "COMPONENTS.SEARCH_BAR.SEARCH_COMPANIES": "Wyszukiwanie firm",
    "COMPONENTS.SEARCH_BAR.SEARCH_PROJECTS": "Wyszukiwanie projektów",
    "COMPONENTS.SEARCH_BAR.SEARCH.DISABLED_TOOLTIP": "Przed skorzystaniem z wyszukiwania wybierz partnera lub firmę",
    "COMPONENTS.SEARCH.IMG.ALT": "Ikona wyszukiwania",
    "COMPONENTS.SELECT.DESELECT_ALL": "Odznacz wszystko",
    "COMPONENTS.SELECT.SELECT_ALL": "Zaznacz wszystko",
    "COMPONENTS.SESSION_INFORMATION.CONFIRMED_LEAKS": "Potwierdzone przecieki",
    "COMPONENTS.SESSION_INFORMATION.NAME": "Nazwa",
    "COMPONENTS.SESSION_INFORMATION.REGION": "Region",
    "COMPONENTS.SESSION_INFORMATION.TITLE": "Informacje o identyfikatorze DMA",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CANCEL": "Anuluj",
    "COMPONENTS.SESSION_RELOCATION.BUTTON_CONFIRM": "Potwierdzenie",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_A": "Czy na pewno chcesz otrzymać ten identyfikator sesji?",
    "COMPONENTS.SESSION_RELOCATION.PARAGRAPH_B": "do umieszczenia na tym kluczu zasobów",
    "COMPONENTS.SESSION_RELOCATION.SUCCESS.REQUEST": "Sesja została pomyślnie przeniesiona",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.ERROR": "Ikona błędu",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.SUCCESS": "Ikona sukcesu",
    "COMPONENTS.STATUS_MESSAGE.ICON.ALT.WARNING": "Ikona ostrzeżenia",
    "COMPONENTS.STATUS_MODAL.ICON.NEGATIVE.ALT": "Krzyżyk wskazujący awarię",
    "COMPONENTS.STATUS_MODAL.ICON.POSITIVE.ALT": "Tik oznaczający sukces",
    "COMPONENTS.STATUS_MODAL.OK": "OK",
    "COMPONENTS.WAYPOINT_HEADINGS.CONSUMPTION_PROFILE": "Profil zużycia",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION": "Korelacja",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.CONTENT": "Wyświetla listę korelacji z odpowiadającymi im sesjami w następującym formacie:\\n{identyfikator korelacji}: {identyfikator sesji A} - {identyfikator sesji B}.",
    "COMPONENTS.WAYPOINT_HEADINGS.CORRELATION_TOOLTIP.TITLE": "Rozwijana lista korelacji",
    "COMPONENTS.WAYPOINT_HEADINGS.JOB": "Praca",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.CONTENT": "Ta lista rozwijana przedstawia identyfikatory sesji z odpowiadającym im statusem i czasem ostatniej aktualizacji w formacie:\\n{identyfikator sesji} : {Status} : {Czas ostatniej aktualizacji}",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION_TOOLTIP.TITLE": "Menu rozwijane sesji",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.ID": "Identyfikator sesji",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.LAST_UPDATE": "Czas zakończenia",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.STATUS": "Status",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSION.DROPDOWN.TYPE": "Typ",
    "COMPONENTS.WAYPOINT_HEADINGS.SESSIONS": "Sesje",
    "COMPONENTS.WAYPOINT_HEADINGS.TOP_SOUND": "Top Sound",
    "COMPONENTS.WAYPOINT_HEADINGS.WAYPOINT_LINK": "Powrót do punktu trasy",
    "COMPONENTS.WAYPOINT_KEY.LARGEST": "Największy punkt trasy",
    "COMPONENTS.WAYPOINT_KEY.LATEST": "Najnowszy punkt trasy",
    "COMPONENTS.WAYPOINT_TABLE.NUMBER_ROWS": "Wiersze na stronę",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FIVE": "Data aktualizacji",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_FOUR": "Nazwa inżyniera",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_ONE": "Nazwa",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SEVEN": "Wybierz punkt trasy",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_SIX": "Data utworzenia",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_THREE": "Status",
    "COMPONENTS.WAYPOINT_TABLE.TITLE.ROW_TWO": "Rozmiar",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.CORRELATION": "Korelacja",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.MARKED_UP": "Oznaczone",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.OVERNIGHT_SESSION": "Nocna sesja",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIR_SCHEDULED": "Zaplanowana naprawa",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.REPAIRED": "Naprawiono",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.SCHEDULED": "Zaplanowane",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TITLE": "Aktualny status",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.TOP_SOUND": "Najlepszy dźwięk",
    "COMPONENTS.WAYPOINT_TICKBOX_CONTAINER.VALIDATED": "Zatwierdzony",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "CONFIRM_ACCOUNT_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.LABEL": "Hasło",
    "CONFIRM_ACCOUNT_PAGE.FORM.PASSWORD.PLACEHOLDER": "Wprowadź hasło",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Powtórz hasło",
    "CONFIRM_ACCOUNT_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Powtórz hasło",
    "CONFIRM_ACCOUNT_PAGE.FORM.SUBMIT": "Potwierdzenie",
    "CONFIRM_ACCOUNT_PAGE.SUBTITLE": "Potwierdź konto poniżej",
    "CONFIRM_ACCOUNT_PAGE.TITLE": "Potwierdź konto",
    "CONSUMPTION_PROFILE_PAGE.CHART_LOAD_FAILED": "Nie udało się załadować danych z wykresu zużycia. Spróbuj odświeżyć stronę lub skontaktuj się z pomocą techniczną, jeśli problem będzie się powtarzał.",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_INFO_TITLE": "Informacje o zużyciu",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.CONSUMPTION_PROFILING": "Identyfikator profilowania zużycia",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.DATE_TITLE": "Data Godziny",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.END_TIME": "Czas zakończenia",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.EXPECTED_SAMPLES": "Oczekiwane próbki",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.START_TIME": "Godzina rozpoczęcia",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.TITLE": "Informacje o profilu zużycia",
    "CONSUMPTION_PROFILE_PAGE.CONSUMPTION_INFO.UPLOADED_SAMPLES": "Przesłane próbki",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.EXPORT": "Eksport danych z wyświetlanego zakresu",
    "CONSUMPTION_PROFILE_PAGE.LINE_GRAPH.TITLE": "Profil zużycia",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COLLECTED_ENGINEER": "Collected Engineer",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.COMPANY": "Firma",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.DEPLOYED_ENGINEER": "Wdrożony inżynier",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LAST_UPDATED": "Dni od ostatniej aktualizacji",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.LOCATION": "Lokalizacja",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.POSTCODE": "Kod pocztowy",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.TITLE": "Dane lokalizacji",
    "CONSUMPTION_PROFILE_PAGE.LOCATION_INFO.WHAT3WORDS": "What3Words",
    "CONSUMPTION_PROFILE_PAGE.NO_DATA": "Brak danych w wyświetlanym zakresie, spróbuj użyć innego zakresu.",
    "CORRELATION_GRAPHS.CORRELATION_IMG_ALT": "Obraz korelacji",
    "CORRELATION_GRAPHS.NO_RESULTS": "Brak dźwięku lub wykresów dostępnych dla sesji Id:",
    "CORRELATION_GRAPHS.PAGE_TITLE": "Profil widmowy",
    "CORRELATION_GRAPHS.PSD_IMG_ALT": "PSD dla sesji",
    "CORRELATION_GRAPHS.SESSION_ID": "Id sesji",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.DETAILS_TITLE": "Szczegóły korelacji",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.LEAK_DISTANCE": "Odległość wycieku",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_A": "Lokalizacja punktu A",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.POINT_B": "Lokalizacja punktu B",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.SPEED_OF_SOUND": "Prędkość dźwięku",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TIMESTAMP": "Znacznik czasu",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TITLE": "Informacje o korelacji",
    "CORRELATION_INFO_PAGE.CORRELATION_INFO.TOTAL_LENGTH": "Całkowita długość",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.COMPANY": "Firma",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.ENGINEER": "Inżynier",
    "CORRELATION_INFO_PAGE.ENGINEER_INFO.TITLE": "Informacje o inżynierze",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.DIAMETER": "Średnica",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.LENGTH": "Długość",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.MILLIMETERS": "mm",
    "CORRELATION_INFO_PAGE.MATERIAL_INFO.TITLE": "Szczegóły materiałowe",
    "CORRELATION_INFO_PAGE.STATUS.CENTRAL": "Podejrzenie pozycji środkowej należy sprawdzić ręcznie",
    "CORRELATION_INFO_PAGE.STATUS.DETECTED": "Korelacja okazała się skuteczna",
    "CORRELATION_INFO_PAGE.STATUS.INCONCLUSIVE": "Niejednoznaczna korelacja",
    "CORRELATION_INFO_PAGE.STATUS.NOT_FOUND": "Nie znaleziono korelacji",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.DESCRIPTION": "Wyniki korelacji wskazują na brak wycieku.",
    "CORRELATION_INFO_PAGE.STATUS.SUCCESS.TITLE": "Świetna wiadomość!",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_A": "Podejrzane informacje o rurze lub poza nawiasem w kierunku punktu A",
    "CORRELATION_INFO_PAGE.STATUS.SUSPICIOUS_B": "Podejrzane informacje o rurze lub poza nawiasem w kierunku punktu B",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.DESCRIPTION": "Wyniki korelacji wskazują na obecność wycieku.",
    "CORRELATION_INFO_PAGE.STATUS.WARNING.TITLE": "Ostrzeżenie!",
    "CURRENCY.EUR": "Euro",
    "CURRENCY.GBP": "Funt szterling",
    "CURRENCY.USD": "Dolar amerykański",
    "DASHBOARD_PAGE.CO2.LABEL": "Oszczędności CO2",
    "DASHBOARD_PAGE.LEAKS.LABEL": "Liczba wycieków",
    "DASHBOARD_PAGE.LEAKS.LEGEND.LARGE": "Duży",
    "DASHBOARD_PAGE.LEAKS.LEGEND.MEDIUM": "Średni",
    "DASHBOARD_PAGE.LEAKS.LEGEND.SMALL": "Mały",
    "DASHBOARD_PAGE.LEAKS.SUBTITLE": "Liczba wykrytych wycieków",
    "DASHBOARD_PAGE.LEAKS.TITLE": "Rozmiar nieszczelności",
    "DASHBOARD_PAGE.SUBTITLE": "Inne ważne informacje znajdują się tutaj",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.SUBTITLE": "Problemy",
    "DASHBOARD_PAGE.SUMMARY.EXCEPTIONS.TITLE": "Alerty o wyjątkach",
    "DASHBOARD_PAGE.SUMMARY.FIDO_FUNNEL": "Fido Funnel",
    "DASHBOARD_PAGE.SUMMARY.FIDO_SCORE": "Wynik Fido",
    "DASHBOARD_PAGE.SUMMARY.LEAK_TITLE": "Informacje o wycieku",
    "DASHBOARD_PAGE.SUMMARY.LEAKS_IDENTIFIED": "Wycieki przewidywane przez sztuczną inteligencję FIDO",
    "DASHBOARD_PAGE.SUMMARY.LOCATE_DMA_BUTTON": "Lokalizacja DMA na mapie",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_REPAIRED": "Liczba oznaczona do naprawy",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_SCHEDULED": "Zaplanowana liczba",
    "DASHBOARD_PAGE.SUMMARY.NUMBER_VERIFIED_REPAIRED": "Liczba napraw zweryfikowanych przez FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.DELIVERY": "Wydajność dostaw",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.HEALTH_CHECK": "Raport z kontroli stanu zdrowia",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.POST_PROJECT": "Raport po zakończeniu projektu",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.PROJECT": "Status projektu",
    "DASHBOARD_PAGE.SUMMARY.REPORTS.TITLE": "Raporty",
    "DASHBOARD_PAGE.SUMMARY.SESSIONS_ANALISED": "Pliki analizowane przez FIDO AI",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.COMPANY": "Oś czasu firmy",
    "DASHBOARD_PAGE.SUMMARY.TIMELINE.PROJECT": "Oś czasu projektu",
    "DASHBOARD_PAGE.TIME_RANGE.ALL_TIME": "Cały czas",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_30_DAYS": "Ostatnie 30 dni",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_7_DAYS": "Ostatnie 7 dni",
    "DASHBOARD_PAGE.TIME_RANGE.LAST_YEAR": "Ostatni rok",
    "DASHBOARD_PAGE.TIME_RANGE.TODAY": "Dzisiaj",
    "DASHBOARD_PAGE.TITLE": "Pulpit nawigacyjny",
    "DASHBOARD_PAGE.TOTAL_LEAKAGE_DETECTED": "Całkowity wykryty wyciek",
    "DASHBOARD_PAGE.VIEW_ALL_BTN": "Zobacz wszystkie projekty",
    "DASHBOARD_PAGE.VOLUMETRICS.SUBTITLE": "Wolumetria wycieków",
    "DASHBOARD_PAGE.WATER.ANALYSED_BY": "Sesje analizowane przez FIDO AI",
    "DASHBOARD_PAGE.WATER.COST": "Koszt utraconej wody",
    "DASHBOARD_PAGE.WATER.COST_PER_YEAR": "USD rocznie",
    "DASHBOARD_PAGE.WATER.FIDO_AI": "FIDO AI",
    "DASHBOARD_PAGE.WELCOME": "Witamy",
    "DASHBOARD_PAGE.WELCOME_DESCRIPTION": "Tutaj możesz uzyskać dostęp do kluczowych danych, takich jak zasięg, redukcja wycieków, koszty utraty wody i śledzenie postępów.",
    "DELETE_USER.BTN.CANCEL": "Anuluj",
    "DELETE_USER.BTN.CLOSE": "Zamknij okno dialogowe",
    "DELETE_USER.BTN.SUBMIT": "Usuń",
    "DELETE_USER.DESC": "Usunięcie tego profilu spowoduje usunięcie wszystkich danych osobowych",
    "DELETE_USER.SUCCESS.MSG": "Użytkownik usunięty pomyślnie",
    "DELETE_USER.TITLE": "Usunąć profil?",
    "DELETE_USER.VALIDATION.ERROR": "Nie można usunąć użytkownika, spróbuj ponownie",
    "DELIVERY_PERFORMANCE_PAGE.COLLECTIONS": "Kolekcje",
    "DELIVERY_PERFORMANCE_PAGE.CONVERSION_RATE": "Współczynnik konwersji",
    "DELIVERY_PERFORMANCE_PAGE.COVERED": "Pokonany dystans",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENT_ACCURACY": "Dokładność wdrożenia",
    "DELIVERY_PERFORMANCE_PAGE.DEPLOYMENTS": "Wdrożenia",
    "DELIVERY_PERFORMANCE_PAGE.END_DATE": "Data zakończenia",
    "DELIVERY_PERFORMANCE_PAGE.HOURS_WORKED": "Przepracowane godziny",
    "DELIVERY_PERFORMANCE_PAGE.IN_PROGRESS_WAYPOINTS": "Punkty trasy w toku",
    "DELIVERY_PERFORMANCE_PAGE.KM_COVERED": "Pokryty km",
    "DELIVERY_PERFORMANCE_PAGE.LEAKS_MARKED_UP": "Nieszczelności oznaczone",
    "DELIVERY_PERFORMANCE_PAGE.NAME": "Nazwa",
    "DELIVERY_PERFORMANCE_PAGE.NON_LEAKS_MARKED_UP": "Brak wycieków Oznaczone",
    "DELIVERY_PERFORMANCE_PAGE.NOT_FOUND_WAYPOINTS": "nie znaleziono punktów trasy",
    "DELIVERY_PERFORMANCE_PAGE.START_DATE": "data rozpoczęcia",
    "DELIVERY_PERFORMANCE_PAGE.WAYPOINTS_INVESTIGATED": "zbadane punkty trasy",
    "DETAIL_WIDGET.TITLE_A": "Sesje",
    "DETAIL_WIDGET.TITLE_B": "Identyfikacja wolumetryczna FIDO AI",
    "DETAIL_WIDGET.TITLE_C": "Koszt strat wody w czasie pracy",
    "DIALOG.CONFIRM_DELETE.DESCRIPTION": "Czy na pewno chcesz usunąć tę kolumnę?",
    "DIALOG.CONFIRM_DELETE.TITLE": "Potwierdzać",
    "DIALOG.FORGOT_PASSWORD.CLOSE": "Zamknąć",
    "DIALOG.FORGOT_PASSWORD.DESCRIPTION": "Link umożliwiający odzyskanie hasła zostanie wysłany na adres e-mail użytkownika.",
    "DIALOG.FORGOT_PASSWORD.SUBMIT": "Zresetuj hasło",
    "DIALOG.FORGOT_PASSWORD.TITLE": "Zresetuj hasło",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.BUTTON": "Nowy projekt",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.LABEL": "Nazwa projektu",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.NAME.PLACEHOLDER": "Wprowadź nazwę projektu",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.FORM.SUBMIT": "Dodaj projekt",
    "EDIT_COMPANY_PAGE.ADD_BRANCH.TITLE": "Dodaj projekt",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.BUTTON": "Nowy pracownik",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.LABEL": "Projekt",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.BRANCH.PLACEHOLDER": "Wybierz projekt",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.LABEL": "Firma",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.COMPANY.PLACEHOLDER": "Wybierz firmę",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.LABEL": "Adres e-mail",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.LABEL": "Imię",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.FIRST_NAME.PLACEHOLDER": "Wprowadź imię",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.LABEL": "Nazwisko",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.LAST_NAME.PLACEHOLDER": "Wpisz nazwisko",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.LABEL": "Rola",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.ROLE.PLACEHOLDER": "Wybierz rolę",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.FORM.SUBMIT": "Dodaj pracownika",
    "EDIT_COMPANY_PAGE.ADD_EMPLOYEE.TITLE": "Dodaj pracownika",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ACTIONS": "Działania",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADD": "Dodaj",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.ADDRESS": "Adres",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.BRANCHES": "Projekty ({{ count }})",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NAME": "Nazwa projektu",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.NO_BRANCHES": "Brak projektów",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_REPORTS": "Raporty ogółem",
    "EDIT_COMPANY_PAGE.BRANCHES_TABLE.TOTAL_USERS": "Całkowita liczba użytkowników",
    "EDIT_COMPANY_PAGE.CRUMB": "Zarządzanie firmą",
    "EDIT_COMPANY_PAGE.DELETE_BRANCH.TITLE": "Czy na pewno chcesz usunąć ten projekt?",
    "EDIT_COMPANY_PAGE.DELETE_COMPANY.TITLE": "Czy na pewno chcesz usunąć tę firmę?",
    "EDIT_COMPANY_PAGE.DELETE_EMPLOYEE.TITLE": "Czy na pewno chcesz usunąć tego pracownika?",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.BUTTON": "Edytuj projekt",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.NAME.PLACEHOLDER": "Wprowadź nazwę projektu",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.FORM.SUBMIT": "Aktualizacja projektu",
    "EDIT_COMPANY_PAGE.EDIT_BRANCH.TITLE": "Edytuj projekt",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ACTIONS": "Działania",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ADD": "Dodaj",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.BRANCH": "Projekt",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMAIL": "E-mail",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.EMPLOYEES": "Pracownicy ({{ count }})",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.INDEX": "№",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NAME": "Nazwa użytkownika",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.NO_EMPLOYEES": "Brak pracowników",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.ROLE": "Rola",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.STATUS": "Status",
    "EDIT_COMPANY_PAGE.EMPLOYEES_TABLE.TOTAL_REPORTS": "Łączna liczba raportów niestandardowych",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.LABEL": "Adres",
    "EDIT_COMPANY_PAGE.FORM.ADDRESS.PLACEHOLDER": "Wprowadź adres",
    "EDIT_COMPANY_PAGE.FORM.DELETE": "Usuń",
    "EDIT_COMPANY_PAGE.FORM.DISCARD": "Odrzucenie",
    "EDIT_COMPANY_PAGE.FORM.EDIT": "Edytuj",
    "EDIT_COMPANY_PAGE.FORM.NAME.LABEL": "Nazwa",
    "EDIT_COMPANY_PAGE.FORM.NAME.PLACEHOLDER": "Wprowadź nazwę",
    "EDIT_COMPANY_PAGE.FORM.NO_CHANGES": "Bez zmian",
    "EDIT_COMPANY_PAGE.FORM.SUBMIT": "Zapisz",
    "EDIT_COMPANY_PAGE.TITLE": "Edytuj firmę",
    "EDIT_PARTNER.COUNTRY": "Kraj",
    "EDIT_PARTNER.PARTNER_CODE": "Kod partnera",
    "EDIT_PARTNER.PARTNER_NAME": "Nazwa partnera",
    "EDIT_PARTNER.TITLE": "Edytuj partnera",
    "EDIT_PROJECT.COMPANY.LABEL": "Firma",
    "EDIT_PROJECT.COMPANY.PLACEHOLDER": "Wybór firmy",
    "EDIT_PROJECT.COMPANY.VALIDATION": "Wymagana jest spółka",
    "EDIT_PROJECT.COST_PER_DISTANCE.LABEL": "Koszt na odległość",
    "EDIT_PROJECT.COST_PER_DISTANCE.PLACEHOLDER": "Koszt na odległość",
    "EDIT_PROJECT.COST_PER_DISTANCE.VALIDATION": "Wymagany jest koszt za odległość",
    "EDIT_PROJECT.DISCARD": "Odrzucenie",
    "EDIT_PROJECT.DMAS.LABEL": "DMA",
    "EDIT_PROJECT.DMAS.NO_MATCHING": "Brak pasujących DMA",
    "EDIT_PROJECT.DMAS.PLACEHOLDER": "Wybór DMA",
    "EDIT_PROJECT.END_DATE.LABEL": "Data zakończenia",
    "EDIT_PROJECT.END_DATE.PLACEHOLDER": "Wybierz datę zakończenia",
    "EDIT_PROJECT.END_DATE.VALIDATION": "Data końcowa musi być późniejsza niż data początkowa",
    "EDIT_PROJECT.NAME.LABEL": "Nazwa projektu",
    "EDIT_PROJECT.NAME.PLACEHOLDER": "Wprowadź nazwę projektu",
    "EDIT_PROJECT.NAME.VALIDATION": "Nazwa projektu jest wymagana",
    "EDIT_PROJECT.NO_CHANGES": "Żadne informacje o projekcie nie uległy zmianie.",
    "EDIT_PROJECT.START_DATE.LABEL": "Data rozpoczęcia",
    "EDIT_PROJECT.START_DATE.PLACEHOLDER": "Wybierz datę rozpoczęcia",
    "EDIT_PROJECT.START_DATE.VALIDATION": "Data rozpoczęcia musi być wcześniejsza niż data zakończenia",
    "EDIT_PROJECT.SUBMIT": "Prześlij",
    "EDIT_PROJECT.TARGET_DISTANCE.LABEL": "Odległość docelowa",
    "EDIT_PROJECT.TARGET_DISTANCE.PLACEHOLDER": "Wprowadź odległość docelową",
    "EDIT_PROJECT.TARGET_DISTANCE.VALIDATION": "Wymagana jest odległość docelowa",
    "EDIT_PROJECT.TARGET_LEAKAGE.LABEL": "Wyciek docelowy",
    "EDIT_PROJECT.TARGET_LEAKAGE.PLACEHOLDER": "Wprowadź wyciek docelowy",
    "EDIT_PROJECT.TARGET_LEAKAGE.VALIDATION": "Wymagany jest wyciek docelowy",
    "EDIT_PROJECT.TITLE": "Edytuj projekt",
    "EDIT_USER.PAGE_TITLE": "Edytuj użytkownika",
    "EDIT_USER.RETURN_BTN": "Odrzucenie",
    "EDIT_USER.SUBMIT_BTN": "Zapisz użytkownika",
    "ERROR.DUPLICATE_EMAIL": "Wprowadzony adres e-mail już istnieje",
    "ERROR.DUPLICATE_PROJECT": "Nazwa projektu już istnieje",
    "ERROR.NO_DATA": "Dane tego użytkownika są obecnie niedostępne",
    "ERROR.REPORT.NO_DATA": "Raport nie zawiera zwróconych danych. Spróbuj zmienić zakres dat",
    "ERROR.REQUEST": "Wystąpił błąd podczas przetwarzania żądania. Spróbuj odświeżyć stronę.",
    "ERROR.SESSION_EXPIRED": "Sesja wygasła, zaloguj się ponownie",
    "EXPORT_BUTTON.ALL": "Eksportuj wszystko",
    "EXPORT_BUTTON.ALL_CSV": "Eksportuj wszystko (CSV)",
    "EXPORT_BUTTON.ALL_EXCEL": "Eksportuj wszystko (Excel)",
    "EXPORT_BUTTON.ALL_JSON": "Eksportuj wszystko (JSON)",
    "EXPORT_BUTTON.ERROR.REQUEST": "Błąd podczas eksportowania danych",
    "EXPORT_BUTTON.EXPORT": "Eksport",
    "EXPORT_BUTTON.FILTERED": "Eksportuj filtrowane",
    "EXPORT_BUTTON.FILTERED_CSV": "Eksportuj filtrowany (CSV)",
    "EXPORT_BUTTON.FILTERED_EXCEL": "Eksportuj filtrowane (Excel)",
    "EXPORT_BUTTON.FILTERED_JSON": "Eksportuj filtrowane (JSON)",
    "EXPORT_BUTTON.SUCCESS.REQUEST": "Wkrótce powinieneś otrzymać e-mail z eksportem",
    "FILTERS.DATE_RANGE.TITLE": "Zakres dat",
    "FILTERS.DIALOG.SUBTITLE.CHANGE": "Wszystkie filtry zostaną usunięte?",
    "FILTERS.DIALOG.SUBTITLE.CLOSE": "Czy zmiany zostaną usunięte?",
    "FILTERS.DIALOG.TITLE.CHANGE": "Czy na pewno chcesz zmienić źródło danych?",
    "FILTERS.DIALOG.TITLE.CLOSE": "Czy na pewno chcesz zamknąć ustawienia?",
    "FILTERS.FORM.COLUMN.LABEL": "Kolumna",
    "FILTERS.FORM.COLUMN.PLACEHOLDER": "Wybierz kolumnę",
    "FILTERS.FORM.SOURCE.LABEL": "Źródło danych",
    "FILTERS.FORM.SOURCE.PLACEHOLDER": "Wybierz źródło danych",
    "FILTERS.FORM.TYPE.LABEL": "Typ",
    "FILTERS.FORM.TYPE.PLACEHOLDER": "Wybierz typ",
    "FILTERS.FORM.VALUE.LABEL": "Wartość",
    "FILTERS.FORM.VALUE.PLACEHOLDER": "Wybierz wartość",
    "FILTERS.MODAL_TITLE": "Ustawienia",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "FORGOT_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź swój adres e-mail",
    "FORGOT_PASSWORD_PAGE.FORM.SUBMIT": "Wyślij link resetowania",
    "FORGOT_PASSWORD_PAGE.RECOVERY_SUCCESS": "Link do odzyskiwania został pomyślnie wysłany na twój adres e-mail",
    "FORGOT_PASSWORD_PAGE.SUBTITLE": "Wpisz swój adres e-mail poniżej",
    "FORGOT_PASSWORD_PAGE.TITLE": "Nie pamiętam hasła",
    "FORM.LABEL.COMPANY": "Firma",
    "FORM.LABEL.COUNTRY": "Kraj",
    "FORM.LABEL.CURRENCY": "Waluta",
    "FORM.LABEL.DIAMETER_UNIT": "Średnica",
    "FORM.LABEL.EMAIL": "E-mail",
    "FORM.LABEL.FIRST_NAME": "Imię",
    "FORM.LABEL.FLOW_RATE_UNIT": "Przepływ",
    "FORM.LABEL.LAST_NAME": "Nazwisko",
    "FORM.LABEL.LONG_DISTANCE_UNIT": "Długodystansowy",
    "FORM.LABEL.MEASUREMENT_SYSTEM": "System pomiarowy",
    "FORM.LABEL.PARTNER": "Partner",
    "FORM.LABEL.PHONE": "Telefon",
    "FORM.LABEL.ROLE": "Rola",
    "FORM.LABEL.SHORT_DISTANCE_UNIT": "Krótki dystans",
    "FORM.LABEL.VOLUME_UNIT": "Tom",
    "FORM.LABEL.WEIGHT_UNIT": "Waga",
    "FORM.PLACEHOLDER.COMPANY": "Wybór firmy",
    "FORM.PLACEHOLDER.COUNTRY": "Wybierz kraj",
    "FORM.PLACEHOLDER.CURRENCY": "Wybierz walutę",
    "FORM.PLACEHOLDER.DIAMETER_UNIT": "Wybierz średnicę",
    "FORM.PLACEHOLDER.FLOW_RATE_UNIT": "Wybierz natężenie przepływu",
    "FORM.PLACEHOLDER.LONG_DISTANCE_UNIT": "Wybierz połączenie międzymiastowe",
    "FORM.PLACEHOLDER.MEASUREMENT_SYSTEM": "Wybierz system pomiarowy",
    "FORM.PLACEHOLDER.PARTNER": "Wybór partnera",
    "FORM.PLACEHOLDER.PHONE": "Wybierz telefon",
    "FORM.PLACEHOLDER.ROLE": "Wybierz rolę",
    "FORM.PLACEHOLDER.SHORT_DISTANCE_UNIT": "Wybierz krótki dystans",
    "FORM.PLACEHOLDER.VOLUME_UNIT": "Wybierz głośność",
    "FORM.PLACEHOLDER.WEIGHT_UNIT": "Wybierz wagę",
    "FORM.VALIDATION.COMPANY": "Firma jest wymagana",
    "FORM.VALIDATION.COUNTRY": "Kraj jest wymagany",
    "FORM.VALIDATION.CURRENCY": "Wymagana jest waluta",
    "FORM.VALIDATION.EMAIL": "Wymagany jest adres e-mail",
    "FORM.VALIDATION.FIRST_NAME": "Imię jest wymagane",
    "FORM.VALIDATION.LAST_NAME": "Nazwisko jest wymagane",
    "FORM.VALIDATION.MEASUREMENT_SYSTEM": "Wymagany jest system pomiarowy",
    "FORM.VALIDATION.PARTNER": "Wymagany jest partner",
    "FORM.VALIDATION.PHONE": "Wymagany jest telefon",
    "FORM.VALIDATION.ROLE": "Rola jest wymagana",
    "GIS_ADMIN.ACTION.SELECT": "Wybierać",
    "GIS_ADMIN.DELETE_MODAL.BTN.CANCEL": "Anulować",
    "GIS_ADMIN.DELETE_MODAL.BTN.REMOVE": "Usunąć",
    "GIS_ADMIN.DELETE_MODAL.ERROR_MSG": "Nie udało się usunąć przesłanego pliku GIS",
    "GIS_ADMIN.DELETE_MODAL.TITLE": "Potwierdź usunięcie przesłania GIS",
    "GIS_ADMIN.PREVIEW_MODAL.BTN.CLOSE": "Zamknij podgląd",
    "GIS_ADMIN.PREVIEW_MODAL.ERROR_MSG": "Nie udało się załadować podglądu",
    "GIS_ADMIN.PREVIEW_MODAL.NO_DATA": "Brak danych do wyświetlenia",
    "GIS_ADMIN.PREVIEW_MODAL.TITLE": "Podgląd GIS",
    "GIS_ADMIN.SEARCH.PLACEHOLDER": "Szukaj",
    "GIS_ADMIN.SEARCH.TEXT": "Szukaj",
    "GIS_ADMIN.TABLE.HEADERS.A": "Nazwa firmy",
    "GIS_ADMIN.TABLE.HEADERS.B": "Data przesłania",
    "GIS_ADMIN.TABLE.HEADERS.C": "Przesłane przez",
    "GIS_ADMIN.TABLE.HEADERS.D": "Działanie",
    "GIS_ADMIN.TABLE.TITLE": "Lista przesłanych plików GIS",
    "GIS_ADMIN.TITLE": "Administrator GIS",
    "GIS_UPLOAD.API.GENERIC_ERROR": "Żądanie nie powiodło się, sprawdź format pliku",
    "GIS_UPLOAD.ASSETS.COLUMN.CREATED_DATE.DESCRIPTION": "Data zainstalowania zasobu",
    "GIS_UPLOAD.ASSETS.COLUMN.DIAMETER.DESCRIPTION": "Średnica zasobu",
    "GIS_UPLOAD.ASSETS.COLUMN.DMA_KEY.DESCRIPTION": "Odniesienie do klucza obszaru, którego częścią jest zasób",
    "GIS_UPLOAD.ASSETS.COLUMN.KEY.DESCRIPTION": "Unikalny identyfikator dla każdego zasobu w sieci",
    "GIS_UPLOAD.ASSETS.COLUMN.SUBTYPE.DESCRIPTION": "Dalsza klasyfikacja szczegółowo opisująca specyficzne cechy danego zasobu",
    "GIS_UPLOAD.ASSETS.COLUMN.TYPE.DESCRIPTION": "Klasyfikacja aktywów na podstawie funkcji",
    "GIS_UPLOAD.BUTTON.DISCARD": "Odrzucić",
    "GIS_UPLOAD.BUTTON.NEXT": "Następny",
    "GIS_UPLOAD.DMA.COLUMN.KEY.DESCRIPTION": "Unikalny identyfikator dla każdego obszaru",
    "GIS_UPLOAD.DMA.COLUMN.NAME.DESCRIPTION": "Opisowa nazwa obszaru",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_A": "pokazujący na ekranie proces mapowania kolumn",
    "GIS_UPLOAD.ERROR_MODAL.ALT.GIF_B": "pokazujący na ekranie proces mapowania pól systemowych",
    "GIS_UPLOAD.ERROR_MODAL.BUTTON.CLOSE": "Zamknij",
    "GIS_UPLOAD.ERROR_MODAL.DESC.A": "Zamapuj wymagane kolumny, jak pokazano poniżej",
    "GIS_UPLOAD.ERROR_MODAL.DESC.B": "Zamapuj pola systemowe, jak pokazano poniżej",
    "GIS_UPLOAD.ERROR_MODAL.DESC.C": "RÓWNIEŻ",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.A": "Ups! Coś poszło nie tak po naszej stronie.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.B": "Wygląda na to, że nasz system ma obecnie problemy. Spróbuj ponownie później.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.C": "Jeśli problem nie ustąpi, skontaktuj się z naszym zespołem pomocy technicznej.",
    "GIS_UPLOAD.ERROR_MODAL.TITLE.D": "Wystąpił błąd",
    "GIS_UPLOAD.ERROR.INVALID_FILE": "Nieprawidłowy plik",
    "GIS_UPLOAD.ERROR.MISSING_FILE": "Brakujący plik",
    "GIS_UPLOAD.FILE_HEADER.BTN.BACK_TO_PROJECT": "Powrót do tworzenia projektu",
    "GIS_UPLOAD.FILE_HEADER.BTN.CLOSE_MODAL": "Zamknij okno modalne",
    "GIS_UPLOAD.FILE_HEADER.BTN.GIS_ADMIN": "Wyświetlanie administratora GIS",
    "GIS_UPLOAD.FILE_HEADER.BTN.LINK.GIS_ADMIN": "Wyświetl administratora GIS",
    "GIS_UPLOAD.FILE_HEADER.BTN.UPLOAD": "Wgrywać",
    "GIS_UPLOAD.FILE_HEADER.COUNTER": "Plik",
    "GIS_UPLOAD.FILE_HEADER.DISCARD": "Odrzuć plik",
    "GIS_UPLOAD.FILE_HEADER.ERROR.PARAGRAPH": "Nie udało się przesłać pliku GIS. Spróbuj ponownie.",
    "GIS_UPLOAD.FILE_HEADER.FINAL_STEP": "Ostatni krok",
    "GIS_UPLOAD.FILE_HEADER.LOADING.TEXT": "Ładowanie",
    "GIS_UPLOAD.FILE_HEADER.MODAL.UPLOAD_TXT": "Przesyłanie zakończone! Sprawdź szczegóły na stronie administratora poniżej",
    "GIS_UPLOAD.FILE_HEADER.NEXT": "Następny",
    "GIS_UPLOAD.FILE_HEADER.NO_FILE": "Brak plików do wybrania",
    "GIS_UPLOAD.FILE_HEADER.PREVIOUS": "Poprzedni",
    "GIS_UPLOAD.FILE_HEADER.RESET": "Powrót do przesyłania plików",
    "GIS_UPLOAD.FILE_HEADER.SUCCESS.PARAGRAPH": "GIS przesłany pomyślnie",
    "GIS_UPLOAD.FILE_HEADER.TEXT.PARAGRAPH": "Czy na pewno chcesz przesłać dane GIS?",
    "GIS_UPLOAD.FILE_HEADER.TEXT.UPLOAD_PARAGRAPH": "Czy na pewno chcesz przesłać dane GIS?",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAP_PREVIEW": "Podgląd mapy",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING": "Mapowanie kolumn",
    "GIS_UPLOAD.FILE_HEADER.TITLE.MAPPING_FOR": "dla",
    "GIS_UPLOAD.INPUT.COMPANY.LABEL": "Wybierz firmę",
    "GIS_UPLOAD.INPUT.COMPANY.PLACEHOLDER": "Wybierz firmę",
    "GIS_UPLOAD.LOADING": "Ładowanie...",
    "GIS_UPLOAD.MAP_PREVIEW.API.GENERAL_ERROR": "Błąd ładowania mapy",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.GIS_ADMIN": "Wyświetlanie administratora GIS",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.NEXT": "Następny",
    "GIS_UPLOAD.MAP_PREVIEW.BTN.PREVIOUS": "Poprzedni",
    "GIS_UPLOAD.MAP_PREVIEW.TITLE": "Podgląd mapy",
    "GIS_UPLOAD.MAP_PREVIEW.UPLOAD_FINISHED": "Przesyłanie zakończone! Sprawdź szczegóły na stronie administratora poniżej",
    "GIS_UPLOAD.PAGE_TITLE": "Prześlij GIS",
    "GIS_UPLOAD.PIPES.COLUMN.CREATED_DATE.DESCRIPTION": "Data utworzenia lub zainstalowania rekordu rurociągu",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER_UNITS.DESCRIPTION": "Jednostki miary średnicy rury",
    "GIS_UPLOAD.PIPES.COLUMN.DIAMETER.DESCRIPTION": "Średnica rury, jednostki określone osobno",
    "GIS_UPLOAD.PIPES.COLUMN.DMA_KEY.DESCRIPTION": "Odniesienie do klucza obszaru, którego częścią jest rura",
    "GIS_UPLOAD.PIPES.COLUMN.KEY.DESCRIPTION": "Inny identyfikator dla każdej rury w sieci",
    "GIS_UPLOAD.PIPES.COLUMN.MATERIAL.DESCRIPTION": "Podstawowy materiał konstrukcyjny rury",
    "GIS_UPLOAD.PIPES.COLUMN.STATUS.DESCRIPTION": "Czy rura jest w użyciu, porzucona, usunięta itp.",
    "GIS_UPLOAD.PIPES.COLUMN.SUBTYPE.DESCRIPTION": "Szczegółowa klasyfikacja rur na podstawie funkcji lub struktury",
    "GIS_UPLOAD.PIPES.COLUMN.TYPE.DESCRIPTION": "Jaką usługę wykonuje rurociąg: sieć rozdzielcza, linia serwisowa, magistrala główna itp.",
    "GIS_UPLOAD.ROUTES.STEP_FIVE": "Podgląd mapy",
    "GIS_UPLOAD.ROUTES.STEP_FOUR": "Aktywa procesowe",
    "GIS_UPLOAD.ROUTES.STEP_ONE": "Prześlij plik Shapefile",
    "GIS_UPLOAD.ROUTES.STEP_THREE": "Rury procesowe",
    "GIS_UPLOAD.ROUTES.STEP_TWO": "Proces DMA",
    "GIS_UPLOAD.STATUS.FILE_FETCHING": "Trwa pobieranie danych pliku...",
    "GIS_UPLOAD.STATUS.FILE_LOADING": "Trwa ładowanie danych pliku...",
    "GIS_UPLOAD.STATUS.FILE_UPLOADING": "Trwa przesyłanie pliku...",
    "GIS_UPLOAD.STATUS.LOADING_COMPANIES_DATA": "Ładowanie danych firm...",
    "GIS_UPLOAD.STATUS.UPLOADING_FILE": "Przesyłanie pliku...",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN": "Utwórz kolumnę",
    "GIS_UPLOAD.TABLE.CREATE_COLUMN_ERROR": "Coś poszło nie tak: nie można utworzyć kolumny",
    "GIS_UPLOAD.TABLE.INVALID_MAPPING": "Ta kolumna jest nieprawidłowa dla wybranego typu danych",
    "GIS_UPLOAD.TABLE.MAPPING_TITLE": "Mapowanie wybranych kolumn",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.DELETE": "Usuwać",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.SAVE": "Zapisz zmiany",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE": "Typ kolumny",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.TYPE.PLACEHOLDER": "Wybierz typ kolumny",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS": "Jednostki",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.UNITS.PLACEHOLDER": "Wybierz jednostki",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE": "Wartość",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL": "Wartość",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE_MANUAL.PLACEHOLDER": "Wprowadź wartość dla wszystkich komórek w kolumnie",
    "GIS_UPLOAD.TABLE.NEW_COLUMN.VALUE.PLACEHOLDER": "Wybierz wartość dla wszystkich komórek w kolumnie",
    "GIS_UPLOAD.TABLE.NO_MAPPING_OPTIONS": "Brak opcji mapowania",
    "GIS_UPLOAD.TABLE.SELECT_COLUMN": "Wybierz kolumnę",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN": "Aktualizuj kolumnę",
    "GIS_UPLOAD.TABLE.UPDATE_COLUMN_ERROR": "Coś poszło nie tak: nie można zaktualizować kolumny",
    "GIS_UPLOAD.UPLOAD.ERROR": "Wystąpił błąd przesyłania. Spróbuj ponownie.",
    "GIS_UPLOAD.UPLOAD.LABEL": "Prześlij plik Shapefile",
    "HEADER.BROWSE": "Przeglądać",
    "HEADER.COMPANIES": "Firmy",
    "HEADER.CONSUMPTION_PROFILE": "Profil zużycia",
    "HEADER.CORRELATION": "Korelacja",
    "HEADER.DASHBOARD": "Pulpit nawigacyjny",
    "HEADER.DPLE": "Wydajność dostaw Inżynier ds. nieszczelności",
    "HEADER.DPST": "Technik ds. czujników wydajności dostaw",
    "HEADER.GIS_ADMIN": "Administrator GIS",
    "HEADER.GIS_UPLOAD": "Przesyłanie GIS",
    "HEADER.HOME": "Dom",
    "HEADER.JOB_DETAILS": "Szczegóły pracy",
    "HEADER.LOGS": "Dzienniki zmian",
    "HEADER.PROFILE": "Profil",
    "HEADER.PROJECT_STATUS": "Status projektu",
    "HEADER.RELAY_MANAGEMENT": "Zarządzanie przekaźnikami",
    "HEADER.REPORTS": "Raporty",
    "HEADER.SENSOR_MANAGEMENT": "Zarządzanie czujnikami",
    "HEADER.SESSION": "Informacje o sesji",
    "HEADER.STOCK_MANAGEMENT": "Zarządzanie zapasami",
    "HEADER.TOP_SOUND": "Top Sound",
    "HEADER.USERS": "Zarządzanie użytkownikami",
    "HEADER.WAYPOINT": "Punkt orientacyjny",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_GRAPHS": "Brak dostępnych wykresów historycznych lub nocnych",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_HISTORICAL_GRAPHS": "Brak dostępnych wykresów historycznych",
    "HISTORY_AND_OVERNIGHT_GRAPHS.ERROR_TXT.NO_OVERNIGHT_GRAPHS": "Brak dostępnego wykresu nocnego",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.HISTORICAL": "Historyczny wykres sesji",
    "HISTORY_AND_OVERNIGHT_GRAPHS.IMG.ALT.OVERNIGHT": "Wykres sesji nocnej",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.HISTORY": "Historia",
    "HISTORY_AND_OVERNIGHT_GRAPHS.TITLES.OVERNIGHT": "Nocleg",
    "HOME_PAGE.DESCRIPTION": "Witamy w Centrum, gdzie możesz zarządzać zadaniami, wspierać użytkowników i przeglądać wszystkie dane z usługi FIDO Smart. W czym możemy Ci dziś pomóc?",
    "HOME_PAGE.HELLO": "Cześć, {{name}}",
    "HOME_PAGE.HERO_IMAGE_ALT": "Obraz bohatera",
    "HOME_PAGE.LOCATE_LEAKS.DESCRIPTION": "Przeglądaj punkty kontrolne według rozmiaru i monitoruj śledztwa",
    "HOME_PAGE.LOCATE_LEAKS.TITLE": "Zlokalizuj wycieki",
    "HOME_PAGE.MANAGE_PROJECTS.DESCRIPTION": "Monitoruj postęp projektu i przeglądaj poprzednie działania",
    "HOME_PAGE.MANAGE_PROJECTS.TITLE": "Zarządzaj projektami",
    "HOME_PAGE.MONITOR_NETWORK.DESCRIPTION": "Zarządzaj swoimi stałymi czujnikami i optymalizuj łączność",
    "HOME_PAGE.MONITOR_NETWORK.TITLE": "Monitoruj swoją sieć",
    "HOME_PAGE.NO_ACTIVITIES_FOUND": "Nie znaleziono żadnych aktywności",
    "HOME_PAGE.YOUR_DASHBOARDS.DESCRIPTION": "Analizuj i raportuj kluczowe dane dotyczące wydajności",
    "HOME_PAGE.YOUR_DASHBOARDS.TITLE": "Twoje pulpity nawigacyjne",
    "HOME_PAGE.YOUR_LATEST_ACTIVITIES": "Twoje najnowsze działania",
    "INVITATIONS.ACCEPT.CONTEXT.EMAIL": "E-mail",
    "INVITATIONS.ACCEPT.CONTEXT.NOT_PROVIDED": "Nie podano",
    "INVITATIONS.ACCEPT.CONTEXT.ORGANIZATION": "Organizacja",
    "INVITATIONS.ACCEPT.CONTEXT.ROLE": "Rola",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.DESCRIPTION": "Zaloguj się na istniejące konto, aby kontynuować.",
    "INVITATIONS.ACCEPT.ERROR.ALREADY_ACCEPTED.TITLE": "Zaproszenie już przyjęte",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.DESCRIPTION": "To zaproszenie nie jest już aktywne. Skontaktuj się z administratorem, jeśli nadal potrzebujesz dostępu.",
    "INVITATIONS.ACCEPT.ERROR.CANCELLED.TITLE": "Zaproszenie anulowane",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.DESCRIPTION": "Ten link z zaproszeniem jest już nieaktywny. Poproś administratora o nowe zaproszenie.",
    "INVITATIONS.ACCEPT.ERROR.EXPIRED.TITLE": "Zaproszenie wygasło",
    "INVITATIONS.ACCEPT.ERROR.INVALID.DESCRIPTION": "To zaproszenie jest nieważne lub wygasło. Poproś administratora o nowe zaproszenie.",
    "INVITATIONS.ACCEPT.ERROR.INVALID.TITLE": "Nieprawidłowe zaproszenie",
    "INVITATIONS.ACCEPT.ERROR.SUBMIT_FAILURE": "Nie udało się zaakceptować zaproszenia",
    "INVITATIONS.ACCEPT.FIELDS.CONFIRM_PASSWORD": "Potwierdź hasło",
    "INVITATIONS.ACCEPT.FIELDS.COUNTRY": "Kraj",
    "INVITATIONS.ACCEPT.FIELDS.CURRENCY": "Waluta",
    "INVITATIONS.ACCEPT.FIELDS.DIAMETER": "Średnica",
    "INVITATIONS.ACCEPT.FIELDS.FIRST_NAME": "Imię",
    "INVITATIONS.ACCEPT.FIELDS.FLOW_RATE": "Przepływ",
    "INVITATIONS.ACCEPT.FIELDS.LAST_NAME": "Nazwisko",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_ARIA": "Akceptuję politykę prywatności i regulamin",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_CONJUNCTION": "I",
    "INVITATIONS.ACCEPT.FIELDS.LEGAL_CHECKBOX_PREFIX": "Akceptuję",
    "INVITATIONS.ACCEPT.FIELDS.LONG_DISTANCE": "Długodystansowy",
    "INVITATIONS.ACCEPT.FIELDS.MEASUREMENT_SYSTEM": "System pomiarowy",
    "INVITATIONS.ACCEPT.FIELDS.PASSWORD": "Hasło",
    "INVITATIONS.ACCEPT.FIELDS.PHONE": "Telefon",
    "INVITATIONS.ACCEPT.FIELDS.SELECT_PLACEHOLDER": "Wybierać",
    "INVITATIONS.ACCEPT.FIELDS.SHORT_DISTANCE": "Krótki dystans",
    "INVITATIONS.ACCEPT.FIELDS.VOLUME": "Tom",
    "INVITATIONS.ACCEPT.FIELDS.WEIGHT": "Waga",
    "INVITATIONS.ACCEPT.FORM_ARIA_LABEL": "Zaakceptuj zaproszenie",
    "INVITATIONS.ACCEPT.LINKS.PRIVACY_POLICY": "Polityka prywatności",
    "INVITATIONS.ACCEPT.LINKS.TERMS_AND_CONDITIONS": "Warunki i zasady",
    "INVITATIONS.ACCEPT.LOADING": "Ładowanie zaproszenia",
    "INVITATIONS.ACCEPT.SUBMIT": "Utwórz konto",
    "INVITATIONS.ACCEPT.SUBMITTING": "Akceptowanie zaproszenia…",
    "INVITATIONS.ACCEPT.SUCCESS.DESCRIPTION": "Twoje konto jest gotowe. Zaloguj się, aby kontynuować.",
    "INVITATIONS.ACCEPT.SUCCESS.SIGN_IN_CTA": "Zalogować się",
    "INVITATIONS.ACCEPT.SUCCESS.TITLE": "Twoje konto jest gotowe",
    "INVITATIONS.ACCEPT.TITLE": "Zaakceptuj zaproszenie",
    "INVITATIONS.ACTION.CANCEL": "Anulować",
    "INVITATIONS.ACTION.SUBMIT": "Wyślij zaproszenie",
    "INVITATIONS.DIALOG.DESCRIPTION": "Zaproś użytkownika e-mailem. Pojawi się on na liście użytkowników po zaakceptowaniu zaproszenia.",
    "INVITATIONS.DIALOG.TITLE": "Zaproś użytkownika",
    "INVITATIONS.SUCCESS.SENT": "Zaproszenie zostało wysłane. Użytkownik pojawi się na liście użytkowników po zaakceptowaniu zaproszenia.",
    "INVITATIONS.VALIDATION.DIAMETER": "Jednostka średnicy jest wymagana",
    "INVITATIONS.VALIDATION.FLOW_RATE": "Wymagana jest jednostka natężenia przepływu",
    "INVITATIONS.VALIDATION.GENERIC": "Wystąpił problem z zaproszeniem tego użytkownika. Sprawdź informacje i spróbuj ponownie.",
    "INVITATIONS.VALIDATION.LEGAL_ACCEPTANCE": "Należy zaakceptować politykę prywatności i regulamin",
    "INVITATIONS.VALIDATION.LONG_DISTANCE": "Wymagana jest jednostka dalekobieżna",
    "INVITATIONS.VALIDATION.PASSWORD_COMPLEXITY": "Hasło musi zawierać co najmniej trzy z następujących znaków: małe litery, wielkie litery, cyfry i znaki specjalne",
    "INVITATIONS.VALIDATION.PASSWORD_MAX": "Hasło powinno mieć maksymalnie 64 znaki",
    "INVITATIONS.VALIDATION.SHORT_DISTANCE": "Wymagana jest jednostka krótkiego zasięgu",
    "INVITATIONS.VALIDATION.VOLUME": "Wymagana jest jednostka objętości",
    "INVITATIONS.VALIDATION.WEIGHT": "Wymagana jest jednostka wagi",
    "JOB_DETAILS.ADDRESS": "Adres wycieku",
    "JOB_DETAILS.AI_LEAK": "Przewidywany przez AI rozmiar wycieku",
    "JOB_DETAILS.BACK_BUTTON": "Powrót do punktu trasy",
    "JOB_DETAILS.CANCEL": "Anuluj",
    "JOB_DETAILS.COMMENTS": "Uwagi",
    "JOB_DETAILS.DATE_INFO_TITLE": "Informacje o dacie",
    "JOB_DETAILS.DATE_SECTION.CREATED": "Data utworzenia",
    "JOB_DETAILS.DATE_SECTION.REPAIR": "Data naprawy",
    "JOB_DETAILS.DATE_SECTION.TITLE": "Data Godziny",
    "JOB_DETAILS.DATE_SECTION.UPDATED": "Data aktualizacji",
    "JOB_DETAILS.DMA": "Referencja DMA",
    "JOB_DETAILS.EDIT": "Edytuj szczegóły zadania",
    "JOB_DETAILS.ENGINEER": "Przydzielony inżynier",
    "JOB_DETAILS.ENVIRONMENTAL_NOTE": "Uwaga dotycząca środowiska",
    "JOB_DETAILS.ERROR": "Nie udało się zaktualizować zadania",
    "JOB_DETAILS.FLOW": "Redukcja przepływu",
    "JOB_DETAILS.FLOW_REDUCTION": "Uzgodniona redukcja przepływu",
    "JOB_DETAILS.ID": "Job ID",
    "JOB_DETAILS.JOB_IMAGES_TITLE": "Job Images",
    "JOB_DETAILS.JOB_INFO_TITLE": "Informacje o pracy",
    "JOB_DETAILS.LEAK": "Szacunkowy rozmiar wycieku dla klienta",
    "JOB_DETAILS.LEAK_SIZE": "Szacowany rozmiar wycieku",
    "JOB_DETAILS.LEAK_TYPE": "Oszacowanie typu wycieku na miejscu",
    "JOB_DETAILS.LOCATION_INFO_TITLE": "Informacje o lokalizacji",
    "JOB_DETAILS.MATERIAL": "Materiał rury",
    "JOB_DETAILS.NO_IMAGES": "Brak obrazów",
    "JOB_DETAILS.NO_JOB": "Nie znaleziono zadania o identyfikatorze",
    "JOB_DETAILS.NOMINAL": "Szacunkowa wielkość wycieku/objętość nominalna klienta",
    "JOB_DETAILS.NOTES": "Uwagi dotyczące środowiska",
    "JOB_DETAILS.PROJECT": "Projekt",
    "JOB_DETAILS.ROAD_SPEED": "Prędkość drogowa",
    "JOB_DETAILS.SAVE": "Zapisz",
    "JOB_DETAILS.SIZE": "Rozmiar rury",
    "JOB_DETAILS.STATUS": "Status pracy",
    "JOB_DETAILS.SURFACE": "Typ powierzchni",
    "JOB_DETAILS.TITLE": "Szczegóły pracy",
    "JOB_DETAILS.TYPE": "Rodzaj pracy",
    "JOB_DETAILS.W3W": "What3Words",
    "JOB_DETAILS.WAYPOINT": "Identyfikator punktu trasy",
    "JOB_DETAILS.WAYPOINT_STATUS": "Status punktu trasy",
    "JOB_DETAILS.WORK_ORDER": "Numer referencyjny zlecenia pracy klienta/usługodawcy",
    "LANGUAGE.ENGLISH": "Angielski",
    "LANGUAGE.FRENCH": "francuski",
    "LANGUAGE.ITALIAN": "Włoski",
    "LANGUAGE.POLISH": "Polski",
    "LANGUAGE.SPANISH": "Hiszpański",
    "LIST_VIEW.CONSUMPTION_PROFILE": "Profilowanie konsumpcji",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_FROM": "Data od",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TO": "Data do",
    "LIST_VIEW.CONSUMPTION_PROFILE.DATE_TYPE": "Typ daty",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.awaiting_upload": "Oczekiwanie na przesłanie",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.completed": "Zakończony",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.deleted": "Usunięto",
    "LIST_VIEW.CONSUMPTION_PROFILE.DISTINCT.in_progress": "W toku",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.BUTTON_LABEL": "Dostosuj widok",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.DESCRIPTION": "Przeciągnij nagłówki kolumn, aby zmienić kolejność, zaznacz lub odznacz, aby pokazać lub ukryć kolumny tabeli.",
    "LIST_VIEW.CONSUMPTION_PROFILE.EDIT_VIEW.RESET_BUTTON_LABEL": "Przywróć widok domyślny",
    "LIST_VIEW.CONSUMPTION_PROFILE.FILTER_SECTION": "Filtr",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.address": "Adres",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.collected_by": "Zebrane przez",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.company": "Firma",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.deployed_by": "Wdrożony przez",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.dma_key": "DMA",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_date": "Data zakończenia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.end_time": "Czas zakończenia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.id": "ID",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.latitude": "Szerokość",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.longitude": "Długość geograficzna",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.partner": "Partner",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.project": "Projekt",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_date": "Data rozpoczęcia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.start_time": "Czas rozpoczęcia",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_id": "Identyfikator punktu trasy",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.waypoint_name": "Nazwa punktu trasy",
    "LIST_VIEW.CONSUMPTION_PROFILE.HEADERS.what3words": "What3Words",
    "LIST_VIEW.CONSUMPTION_PROFILE.NO_DATA": "Brak dostępnych danych",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.APPLY.FILTER": "Zastosuj filtry",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH_BAR.RESET": "Zresetuj wszystkie filtry",
    "LIST_VIEW.CONSUMPTION_PROFILE.SEARCH.PLACEHOLDER": "Szukaj...",
    "LIST_VIEW.CONSUMPTION_PROFILE.TITLE": "Przeglądaj wszystkie profile konsumpcji",
    "LIST_VIEW.JOBS": "Praca",
    "LIST_VIEW.JOBS.HEADERS.address": "Adres",
    "LIST_VIEW.JOBS.HEADERS.agreed_flow_reduction": "Uzgodniona redukcja przepływu",
    "LIST_VIEW.JOBS.HEADERS.branch_id": "Projekt",
    "LIST_VIEW.JOBS.HEADERS.client_leak_size_estimate": "Oszacowanie rozmiaru wycieku dla klienta",
    "LIST_VIEW.JOBS.HEADERS.comment": "Komentarz",
    "LIST_VIEW.JOBS.HEADERS.created_at": "Stworzony",
    "LIST_VIEW.JOBS.HEADERS.date_raised_externally": "Data podniesienia zewnętrznie",
    "LIST_VIEW.JOBS.HEADERS.date_raised_internally": "Data podniesiona wewnętrznie",
    "LIST_VIEW.JOBS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.JOBS.HEADERS.environmental_notes": "Notatki środowiskowe",
    "LIST_VIEW.JOBS.HEADERS.estimate_leak_size": "Szacowany rozmiar wycieku",
    "LIST_VIEW.JOBS.HEADERS.id": "ID",
    "LIST_VIEW.JOBS.HEADERS.job_status": "Status pracy",
    "LIST_VIEW.JOBS.HEADERS.last_scheduled_engineer_id": "Inżynier",
    "LIST_VIEW.JOBS.HEADERS.leak_type": "Kod pracy",
    "LIST_VIEW.JOBS.HEADERS.material": "Tworzywo",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter": "Rozmiar rury",
    "LIST_VIEW.JOBS.HEADERS.pipe_diameter_unit": "Jednostka rozmiaru rury",
    "LIST_VIEW.JOBS.HEADERS.repair_date": "Data naprawy",
    "LIST_VIEW.JOBS.HEADERS.road_speed": "Prędkość drogowa",
    "LIST_VIEW.JOBS.HEADERS.updated_at": "Zaktualizowano",
    "LIST_VIEW.JOBS.HEADERS.waypoint_id": "Punkt orientacyjny",
    "LIST_VIEW.JOBS.HEADERS.work_order": "Zlecenie pracy",
    "LIST_VIEW.JOBS.SUMMARY.JOB_TYPE": "Rodzaj pracy",
    "LIST_VIEW.JOBS.SUMMARY.SESSION_TYPE": "Typ sesji",
    "LIST_VIEW.JOBS.TITLE": "Przeglądaj wszystkie oferty pracy",
    "LIST_VIEW.RELAYS": "Urządzenia przekaźnikowe",
    "LIST_VIEW.RELAYS.HEADERS.address": "Adres",
    "LIST_VIEW.RELAYS.HEADERS.bug_id": "Adres MAC",
    "LIST_VIEW.RELAYS.HEADERS.bug_mac": "Adres MAC",
    "LIST_VIEW.RELAYS.HEADERS.company": "Firma",
    "LIST_VIEW.RELAYS.HEADERS.company_name": "Firma",
    "LIST_VIEW.RELAYS.HEADERS.create_time": "Czas utworzenia",
    "LIST_VIEW.RELAYS.HEADERS.dma_name": "DMA",
    "LIST_VIEW.RELAYS.HEADERS.last_contact": "Ostatni kontakt",
    "LIST_VIEW.RELAYS.HEADERS.last_update": "Ostatnie przesłanie",
    "LIST_VIEW.RELAYS.HEADERS.latitude": "Szerokość",
    "LIST_VIEW.RELAYS.HEADERS.longitude": "Długość geograficzna",
    "LIST_VIEW.RELAYS.HEADERS.partner": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.partner_name": "Partner",
    "LIST_VIEW.RELAYS.HEADERS.project": "Projekt",
    "LIST_VIEW.RELAYS.HEADERS.project_name": "Projekt",
    "LIST_VIEW.RELAYS.HEADERS.relay_id": "Identyfikator przekaźnika",
    "LIST_VIEW.RELAYS.HEADERS.relay_name": "Nazwa przekaźnika",
    "LIST_VIEW.RELAYS.HEADERS.relay_status": "Status przekaźnika",
    "LIST_VIEW.RELAYS.HEADERS.relay_uptime": "Czas sprawności przekaźnika",
    "LIST_VIEW.RELAYS.HEADERS.session_id": "Sesja",
    "LIST_VIEW.RELAYS.HEADERS.session_leak_size": "Przewidywany rozmiar sesji AI",
    "LIST_VIEW.RELAYS.HEADERS.update_time": "Czas aktualizacji",
    "LIST_VIEW.RELAYS.HEADERS.what3words": "What3Words",
    "LIST_VIEW.RELAYS.TITLE": "Przeglądaj wszystkie urządzenia przekaźnikowe",
    "LIST_VIEW.SELECT_DATA_TYPE.LABEL": "Typ danych",
    "LIST_VIEW.SELECT_DATA_TYPE.PLACEHOLDER": "Wybierz typ danych",
    "LIST_VIEW.SESSIONS": "Sesje",
    "LIST_VIEW.SESSIONS.DATE_FROM": "Data Od",
    "LIST_VIEW.SESSIONS.DATE_TO": "Data Do",
    "LIST_VIEW.SESSIONS.DATE_TYPE": "Data Typ",
    "LIST_VIEW.SESSIONS.DISTINCT.awaiting_upload": "Oczekiwanie na przesłanie",
    "LIST_VIEW.SESSIONS.DISTINCT.completed": "Zakończony",
    "LIST_VIEW.SESSIONS.DISTINCT.deleted": "Usunięto",
    "LIST_VIEW.SESSIONS.DISTINCT.in_progress": "W toku",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.BUTTON_LABEL": "Dostosuj widok",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.DESCRIPTION": "Przeciągnij nagłówki kolumn, aby zmienić kolejność, zaznacz/odznacz, aby pokazać/ukryć kolumny tabeli.",
    "LIST_VIEW.SESSIONS.EDIT_VIEW.RESET_BUTTON_LABEL": "Przywróć widok domyślny",
    "LIST_VIEW.SESSIONS.FILTER_SECTION": "Filtr",
    "LIST_VIEW.SESSIONS.HEADERS.address": "Adres",
    "LIST_VIEW.SESSIONS.HEADERS.asset_id": "Aktywa",
    "LIST_VIEW.SESSIONS.HEADERS.collected_by": "Zebrane przez",
    "LIST_VIEW.SESSIONS.HEADERS.company_id": "Firma",
    "LIST_VIEW.SESSIONS.HEADERS.created": "Data utworzenia",
    "LIST_VIEW.SESSIONS.HEADERS.deployed_by": "Wdrożony przez",
    "LIST_VIEW.SESSIONS.HEADERS.dma_id": "DMA",
    "LIST_VIEW.SESSIONS.HEADERS.end_time": "Data zakończenia",
    "LIST_VIEW.SESSIONS.HEADERS.expected_finish": "Oczekiwane zakończenie",
    "LIST_VIEW.SESSIONS.HEADERS.last_update": "Ostatnia aktualizacja",
    "LIST_VIEW.SESSIONS.HEADERS.latitude": "Szerokość",
    "LIST_VIEW.SESSIONS.HEADERS.leak_size": "Przewidywany rozmiar",
    "LIST_VIEW.SESSIONS.HEADERS.longitude": "Długość geograficzna",
    "LIST_VIEW.SESSIONS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.SESSIONS.HEADERS.project_id": "Projekt",
    "LIST_VIEW.SESSIONS.HEADERS.relay_connected": "Przekaźnik podłączony",
    "LIST_VIEW.SESSIONS.HEADERS.sensor-id": "Identyfikator czujnika",
    "LIST_VIEW.SESSIONS.HEADERS.session_id": "Nazwa sesji",
    "LIST_VIEW.SESSIONS.HEADERS.start_time": "Data rozpoczęcia",
    "LIST_VIEW.SESSIONS.HEADERS.status_id": "Status",
    "LIST_VIEW.SESSIONS.HEADERS.type": "Typ",
    "LIST_VIEW.SESSIONS.HEADERS.what3words": "W3W",
    "LIST_VIEW.SESSIONS.NO_DATA": "Brak dostępnych danych",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.APPLY.FILTER": "Zastosuj filtry",
    "LIST_VIEW.SESSIONS.SEARCH_BAR.RESET": "Zresetuj wszystkie filtry",
    "LIST_VIEW.SESSIONS.SEARCH.PLACEHOLDER": "Szukaj...",
    "LIST_VIEW.SESSIONS.SUMMARY.LEAK_SIZE": "Rozmiar wycieku",
    "LIST_VIEW.SESSIONS.SUMMARY.SESSION_TYPE": "Typ sesji",
    "LIST_VIEW.SESSIONS.SUMMARY.TITLE": "Podsumowanie",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.DESC": "Aby dostosować wyświetlane tutaj dane, użyj filtrów z powyższej tabeli.",
    "LIST_VIEW.SESSIONS.SUMMARY.TOOLTIP.TITLE": "Podsumowanie danych wynikowych",
    "LIST_VIEW.SESSIONS.SUMMARY.WAYPOINT_STATUS": "Status punktu kontrolnego",
    "LIST_VIEW.SESSIONS.TITLE": "Przeglądaj wszystkie sesje",
    "LIST_VIEW.WAYPOINT_LOGS": "Dzienniki punktów kontrolnych",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_from_status_name": "Poprzedni status",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.changed_to_status_name": "Aktualny status",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.company": "Firma",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.datetime": "Data aktualizacji",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.id": "ID",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.notes": "Notatki",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.partner": "Partner",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.project": "Projekt",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.user_name": "Nazwa użytkownika",
    "LIST_VIEW.WAYPOINT_LOGS.HEADERS.waypoint_id": "Punkt orientacyjny",
    "LIST_VIEW.WAYPOINT_LOGS.TITLE": "Przeglądaj wszystkie dzienniki punktów orientacyjnych",
    "LIST_VIEW.WAYPOINTS": "Punkty orientacyjne",
    "LIST_VIEW.WAYPOINTS.HEADERS.address": "Adres",
    "LIST_VIEW.WAYPOINTS.HEADERS.agreed_flow_reduction": "Uzgodniona redukcja przepływu",
    "LIST_VIEW.WAYPOINTS.HEADERS.branch_name": "Projekt",
    "LIST_VIEW.WAYPOINTS.HEADERS.comment": "Komentarz",
    "LIST_VIEW.WAYPOINTS.HEADERS.company_id": "Firma",
    "LIST_VIEW.WAYPOINTS.HEADERS.created_at": "Utworzono w",
    "LIST_VIEW.WAYPOINTS.HEADERS.date_time": "Data aktualizacji",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter": "Średnica",
    "LIST_VIEW.WAYPOINTS.HEADERS.diameter_unit": "Jednostka średnicy",
    "LIST_VIEW.WAYPOINTS.HEADERS.dma_key": "DMA",
    "LIST_VIEW.WAYPOINTS.HEADERS.environmental_notes": "Notatki środowiskowe",
    "LIST_VIEW.WAYPOINTS.HEADERS.estimated_size": "Szacowany rozmiar",
    "LIST_VIEW.WAYPOINTS.HEADERS.job_type_code": "Kod typu pracy",
    "LIST_VIEW.WAYPOINTS.HEADERS.jobs": "Praca",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_action_by": "Ostatnia akcja przez",
    "LIST_VIEW.WAYPOINTS.HEADERS.last_scheduled_engineer_id": "Ostatni zaplanowany inżynier",
    "LIST_VIEW.WAYPOINTS.HEADERS.latitude": "Szerokość",
    "LIST_VIEW.WAYPOINTS.HEADERS.longitude": "Długość geograficzna",
    "LIST_VIEW.WAYPOINTS.HEADERS.material": "Tworzywo",
    "LIST_VIEW.WAYPOINTS.HEADERS.name": "Nazwa",
    "LIST_VIEW.WAYPOINTS.HEADERS.partner_id": "Partner",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_leak_type_id": "Przewidywany typ wycieku",
    "LIST_VIEW.WAYPOINTS.HEADERS.predicted_size": "Przewidywany rozmiar",
    "LIST_VIEW.WAYPOINTS.HEADERS.sessions": "Sesje",
    "LIST_VIEW.WAYPOINTS.HEADERS.status_id": "Status",
    "LIST_VIEW.WAYPOINTS.HEADERS.surface_type": "Rodzaj powierzchni",
    "LIST_VIEW.WAYPOINTS.HEADERS.w3w": "What3Words",
    "LIST_VIEW.WAYPOINTS.TITLE": "Przeglądaj wszystkie punkty kontrolne",
    "LOGIN_PAGE.ENTRA_TITLE": "Zaloguj się do portalu",
    "LOGIN_PAGE.ERROR.MSG": "Nieprawidłowy adres e-mail lub hasło",
    "LOGIN_PAGE.FORGOT_PASSWORD": "Zapomniałeś hasła?",
    "LOGIN_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "LOGIN_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź swój adres e-mail",
    "LOGIN_PAGE.FORM.OKTA_SUBMIT": "Logowanie za pomocą Okta",
    "LOGIN_PAGE.FORM.PASSWORD.LABEL": "Hasło",
    "LOGIN_PAGE.FORM.PASSWORD.PLACEHOLDER": "Wprowadź hasło",
    "LOGIN_PAGE.FORM.SUBMIT": "Zaloguj się",
    "LOGIN_PAGE.SIGNING_IN": "Logowanie…",
    "LOGIN_PAGE.SIGNING_IN_SUBTITLE": "Jeśli w ciągu kilku sekund nie nastąpi automatyczne przekierowanie, odśwież stronę.",
    "LOGIN_PAGE.SUBTITLE": "Wprowadź swój adres e-mail i hasło poniżej",
    "LOGIN_PAGE.TITLE": "Zaloguj się do panelu administracyjnego",
    "LOGS.ACTION.ASSIGN_DMAs": "Przypisz DMA",
    "LOGS.ACTION.CHANGE DATES": "Zmień daty",
    "LOGS.ACTION.Change project 1 dates": "Zmień daty projektu 1",
    "LOGS.ACTION.CHANGE_DATES": "Zmień daty",
    "LOGS.ACTION.CHANGE_PASSWORD": "Zmień hasło",
    "LOGS.ACTION.CREATE PROJECT": "Utwórz projekt",
    "LOGS.ACTION.CREATE_BRANCH": "Utwórz gałąź",
    "LOGS.ACTION.CREATE_COMPANY": "Utwórz firmę",
    "LOGS.ACTION.CREATE_MULTI_USER": "Utwórz wielu użytkowników",
    "LOGS.ACTION.CREATE_PARTNER": "Utwórz partnera",
    "LOGS.ACTION.CREATE_PROJECT": "Utwórz projekt",
    "LOGS.ACTION.CREATE_USER": "Utwórz użytkownika",
    "LOGS.ACTION.DELETE_BRANCH": "Usuń gałąź",
    "LOGS.ACTION.DELETE_COMPANY": "Usuń firmę",
    "LOGS.ACTION.DELETE_DMAs": "Usuń DMA",
    "LOGS.ACTION.DELETE_PARTNER": "Usuń partnera",
    "LOGS.ACTION.DELETE_PROJECT": "Usuń projekt",
    "LOGS.ACTION.DELETE_USER": "Usuń użytkownika",
    "LOGS.ACTION.EDIT_COMPANY": "Edytuj firmę",
    "LOGS.ACTION.FORGOT_PASSWORD": "Zapomniałem hasła",
    "LOGS.ACTION.GET_COMPANY": "Uzyskaj firmę",
    "LOGS.ACTION.LOGIN": "Login",
    "LOGS.ACTION.MODIFY_COMPANY": "Modyfikuj firmę",
    "LOGS.ACTION.MODIFY_PARTNER": "Modyfikuj partnera",
    "LOGS.ACTION.MODIFY_USER": "Modyfikuj użytkownika",
    "LOGS.ACTION.REACTIVATE_COMPANY": "Reaktywacja firmy",
    "LOGS.ACTION.REACTIVATE_PARTNER": "Reaktywuj partnera",
    "LOGS.ACTION.RESTORE_COMPANY": "Firma Restore",
    "LOGS.ACTION.SET_PASSWORD": "Ustaw hasło",
    "LOGS.ACTION.TOGGLE OFF RELAY DEVICE": "Wyłącz urządzenie przekaźnikowe",
    "LOGS.ACTION.TRIGGER RELAY DEVICE": "Urządzenie przekaźnikowe wyzwalające",
    "LOGS.ACTION.UPDATE WAYPOINT": "Aktualizuj punkt trasy",
    "LOGS.ACTION.UPDATE_BRANCH": "Aktualizacja oddziału",
    "LOGS.ACTION.UPDATE_LOGGER_SESSION": "Aktualizacja sesji rejestratora",
    "LOGS.DESCRIPTION.ASSIGN_DMAs": "Przypisano klucze DMA {{dma_keys}} do {{project_name}}",
    "LOGS.DESCRIPTION.CHANGE_DATES": "Zmieniono daty dla {{project_name}}. Data rozpoczęcia: {{start_date}}. Data zakończenia: {{end_date}}",
    "LOGS.DESCRIPTION.COMMON.BY_USER_EMAIL": "przez {{by_email}}",
    "LOGS.DESCRIPTION.CREATE_BRANCH": "Utworzono projekt {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_COMPANY": "Utworzono firmę {{company_name}}",
    "LOGS.DESCRIPTION.CREATE_PROJECT": "Utworzono projekt {{project_name}}",
    "LOGS.DESCRIPTION.CREATE_USER": "Utworzono użytkownika {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.DELETE_PROJECT": "Usunięto projekt {{project_name}}",
    "LOGS.DESCRIPTION.DELETE_USER": "Usunięty użytkownik {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.MODIFY_COMPANY": "Zmodyfikowana firma {{company_name}}",
    "LOGS.DESCRIPTION.MODIFY_PARTNER": "Zmodyfikowany partner {{partner_name}}",
    "LOGS.DESCRIPTION.MODIFY_USER": "Zmodyfikowany użytkownik {{user_name}} : {{user_email}}",
    "LOGS.DESCRIPTION.UPDATE_LOGGER_SESSION": "Zaktualizowano sesję rejestratora {{session_id}}",
    "MAP_UNITS.TITLE.COLUMN": "Kolumna mapy",
    "MAP_UNITS.TITLE.UNITS": "Wartości jednostek mapy",
    "MAP_VIEW.DIALOG.SUBTITLE.CHANGE": "Wszystkie filtry zostaną usunięte?",
    "MAP_VIEW.DIALOG.SUBTITLE.CLOSE": "Czy zmiany zostaną usunięte?",
    "MAP_VIEW.DIALOG.TITLE.CHANGE": "Czy na pewno chcesz zmienić źródło danych?",
    "MAP_VIEW.DIALOG.TITLE.CLOSE": "Czy na pewno chcesz zamknąć ustawienia?",
    "MAP_VIEW.FILTERS.BUTTONTITLE": "Opcje mapy",
    "MAP_VIEW.FILTERS.SUBMIT": "Prześlij",
    "MAP_VIEW.FILTERS.TITLES.ASSETS": "Aktywa",
    "MAP_VIEW.FILTERS.TITLES.AWAITING_UPLOAD_SESSION": "Oczekiwanie na sesję przesyłania",
    "MAP_VIEW.FILTERS.TITLES.DELETED_SESSION": "Usunięta sesja",
    "MAP_VIEW.FILTERS.TITLES.DMAS": "DMA",
    "MAP_VIEW.FILTERS.TITLES.IN_PROGRESS_SESSION": "Sesja w toku",
    "MAP_VIEW.FILTERS.TITLES.INVESTIGATION_SESSION": "Sesja śledcza",
    "MAP_VIEW.FILTERS.TITLES.LARGE_LEAK_SESSION": "Sesja dużych wycieków",
    "MAP_VIEW.FILTERS.TITLES.MEDIUM_LEAK_SESSION": "Sesja średniego wycieku",
    "MAP_VIEW.FILTERS.TITLES.NON_LEAK_SESSION": "Sesja bez wycieków",
    "MAP_VIEW.FILTERS.TITLES.ODL": "ODL",
    "MAP_VIEW.FILTERS.TITLES.PIPES": "Rury",
    "MAP_VIEW.FILTERS.TITLES.SMALL_LEAK_SESSION": "Sesja małych wycieków",
    "MAP_VIEW.FILTERS.TITLES.WAYPOINTS": "Punkty trasy",
    "MAP_VIEW.FORM.SOURCE.LABEL": "Źródło danych",
    "MAP_VIEW.FORM.SOURCE.PLACEHOLDER": "Wybierz źródło danych",
    "MAP_VIEW.LOADING": "Ładowanie mapy",
    "MAP_VIEW.MODAL_TITLE": "Ustawienia",
    "MAP.HUD.FETCH_BOUNDARIES": "Pobierz granice",
    "MAP.HUD.LAT": "Szer. geogr.:",
    "MAP.HUD.LNG": "Długość:",
    "MAP.HUD.SOURCES": "Źródła:",
    "MAP.HUD.TOGGLE_FETCH_BOUNDARY_VISUALIZATION": "Przełącz wizualizację granic pobierania",
    "MAP.HUD.ZOOM_IN_TO_LOAD": "Powiększ, aby załadować",
    "MAP.STYLE.SATELLITE": "Widok satelitarny",
    "MAP.STYLE.STREET": "Widok ulicy",
    "MEASUREMENT_TYPE.IMPERIAL": "Imperial",
    "MEASUREMENT_TYPE.METRIC": "Metryczny",
    "MERGE_WAYPOINT.FORM.SUBMIT": "Prześlij",
    "MERGE_WAYPOINT.FORM.SUCCESS": "Pomyślnie połączono punkty kontrolne",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL": "Scal wybrany punkt trasy z bieżącym punktem trasy",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.LABEL_SHORT": "Punkt orientacyjny",
    "MERGE_WAYPOINT.INPUT.MERGE_DROPDOWN.PLACEHOLDER": "Wybierz punkt trasy",
    "MERGE_WAYPOINT.INPUT.NOTES.LABEL": "Uwagi",
    "MERGE_WAYPOINT.INPUT.NOTES.PLACEHOLDER": "Wprowadź uwagi",
    "MERGE_WAYPOINT.NO_DATA": "Brak dostępnych punktów trasy do scalenia",
    "METRIC_WIDGET.DESCRIPTION": "dziennie",
    "METRIC_WIDGET.TITLE_A": "Zidentyfikowana sztuczna inteligencja",
    "METRIC_WIDGET.TITLE_B": "Do naprawy",
    "METRIC_WIDGET.TITLE_C": "Dostarczone",
    "NOT_FOUND_PAGE.ACTION.GO_HOME": "Zabierz mnie do domu",
    "NOT_FOUND_PAGE.DESCRIPTION": "Ups! Strona, której szukasz, najwyraźniej zabłądziła w cyfrową pustkę. Nie martw się, zdarza się każdemu.",
    "NOT_FOUND_PAGE.TITLE": "Strona nie znaleziona",
    "PIE_CHART.SUMMARY_DETAILS": "Podsumowanie szczegółów",
    "PIE_CHART.SUMMARY_TOTAL": "Łączne wyniki",
    "PROCESS_FILES.BUTTON.DISCARD": "Odrzucenie",
    "PROCESS_FILES.BUTTON.NEXT": "Następny",
    "PROCESS_FILES.BUTTON.PREVIOUS": "Poprzedni",
    "PROCESS_FILES.BUTTON.RESET": "Reset",
    "PROCESS_FILES.COLUMNS_SELECT": "Wymagane kolumny pozostały do wybrania",
    "PROCESS_FILES.COLUMNS_SELECTED": "wybrane wszystkie kolumny",
    "PROCESS_FILES.DESC.DIAMETER": "Wybierz: jednostkę odpowiadającą wartościom średnicy LUB kolumnę, aby odwzorować wartości jednostek",
    "PROCESS_FILES.ERROR.INSUFFICIENT_COLUMNS": "Nie ma wystarczającej liczby kolumn do zmapowania podanych danych. Aby kontynuować, odrzuć lub prześlij nowy plik.",
    "PROCESS_FILES.ERROR.NO_FILE_TO_MAP": "Brak pliku do zmapowania dla {{type}} przejdź dalej klikając next",
    "PROCESS_FILES.ERROR.SELECT_ALL": "Wybierz wszystkie kolumny",
    "PROCESS_FILES.FILENAME": "Nazwa pliku",
    "PROCESS_FILES.INSTRUCTIONS": "Przypisz kolumny do nagłówków sugerowanych w listach rozwijanych. Tylko jedna kolumna może być przypisana do nagłówka.",
    "PROCESS_FILES.MAP_FIELD_TITLE": "Pole mapy {{title}}",
    "PROCESS_FILES.OPTION_COLUMNS_SELECT": "Opcjonalne kolumny, które należy jeszcze wybrać",
    "PROCESS_FILES.OPTIONAL_COLUMNS_SELECTED": "Wszystkie opcjonalne kolumny zostały wybrane",
    "PROCESS_FILES.TITLE.DIAMETER": "Pole średnicy mapy",
    "PROFILE_PAGE.BRANCH": "Projekt:",
    "PROFILE_PAGE.COMPANY": "Firma:",
    "PROFILE_PAGE.COMPANY_ADDRESS": "Adres:",
    "PROFILE_PAGE.COMPANY_NAME": "Imię i nazwisko:",
    "PROFILE_PAGE.DISCARD": "Odrzucenie",
    "PROFILE_PAGE.EDIT": "Edytuj",
    "PROFILE_PAGE.EMAIL": "E-mail:",
    "PROFILE_PAGE.ERROR.FAILED_LOADING_USER_DATA": "Nie udało się załadować danych użytkownika.",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.BAD_AUTH": "Wprowadzono nieprawidłowe hasło",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.ERROR": "Bieżące hasło jest nieprawidłowe",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.LOADING": "Ładowanie",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUBMIT": "Prześlij nowe hasło",
    "PROFILE_PAGE.FORM.CHANGE_PASSWORD.SUCCESS": "Sukces! Twoje hasło zostało zmienione.",
    "PROFILE_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "PROFILE_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "PROFILE_PAGE.FORM.FIRST_NAME.LABEL": "Imię",
    "PROFILE_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Wprowadź imię",
    "PROFILE_PAGE.FORM.LAST_NAME.LABEL": "Nazwisko",
    "PROFILE_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Wpisz nazwisko",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.LABEL": "Typ pomiaru",
    "PROFILE_PAGE.FORM.MEASUREMENT_TYPE.PLACEHOLDER": "Wybierz typ pomiaru",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.LABEL": "Nowe hasło",
    "PROFILE_PAGE.FORM.NEW_PASSWORD.PLACEHOLDER": "Wprowadź nowe hasło",
    "PROFILE_PAGE.FORM.PASSWORD.LABEL": "Hasło",
    "PROFILE_PAGE.FORM.PASSWORD.PLACEHOLDER": "Wprowadź hasło",
    "PROFILE_PAGE.ROLE": "Rola:",
    "PROFILE_PAGE.SUBMIT": "Zapisz",
    "PROFILE_PAGE.TABS.ACCOUNT_SETTINGS": "Ustawienia konta",
    "PROFILE_PAGE.TABS.CHANGE_PASSWORD": "Zmień hasło",
    "PROFILE_PAGE.TABS.COMPANY_SETTINGS": "Ustawienia firmy",
    "PROFILE_PAGE.TABS.DOCUMENTS": "Dokumenty",
    "PROFILE_PAGE.TITLE": "Edytuj profil",
    "PROJECT_ADMIN.TITLE": "Administrator projektu",
    "PROJECT_CREATE.ERROR.PROJECT_CREATION": "Coś poszło nie tak: nie można utworzyć projektu",
    "PROJECT_CREATE.FOOTER.CREATE_DRAFT": "Utwórz wersję roboczą",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_1": "Dostęp do niego można uzyskać w sekcji „Wyświetl projekty”.",
    "PROJECT_CREATE.SUCCESS.DESCRIPTION_2": "Przed wysłaniem wniosku do zatwierdzenia prosimy o dodanie wszystkich wymaganych szczegółów.",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECT": "Dodaj szczegóły",
    "PROJECT_CREATE.SUCCESS.LINK_PROJECTS": "Zobacz projekty",
    "PROJECT_CREATE.SUCCESS.TITLE": "Utworzono projekt roboczy",
    "PROJECT_STATUS.INCOMPLETE_PROJECT_SETUP": "Konfiguracja projektu jest niekompletna",
    "PROJECT_STATUS.SUMMARY.TITLES.CONFIRMEDLEAKS": "# Liczba potwierdzonych wycieków",
    "PROJECT_STATUS.SUMMARY.TITLES.LEAKSMARKEDUP": "# Liczba oznaczonych wycieków",
    "PROJECT_STATUS.SUMMARY.TITLES.SESSIONS": "# Liczba sesji",
    "PROJECT_STATUS.SUMMARY.TITLES.WAYPOINTS": "# Liczba punktów trasy",
    "PROJECT_STATUS.TITLE": "Status projektu",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CANCEL": "Anulować",
    "PROJECT_UPDATE.DELETE_DIALOG.BUTTON_CONFIRM": "Potwierdź usunięcie wersji roboczej",
    "PROJECT_UPDATE.DELETE_DIALOG.DESCRIPTION": "Czy na pewno chcesz usunąć ten szkic?",
    "PROJECT_UPDATE.DELETE_DIALOG.TITLE": "Usuń wersję roboczą",
    "PROJECT_UPDATE.DELETE_DRAFT": "Usuń wersję roboczą",
    "PROJECT_UPDATE.DELETE_PROJECT": "Usuń projekt",
    "PROJECT_UPDATE.ERROR.DELETE_DRAFT": "Coś poszło nie tak: nie można usunąć wersji roboczej",
    "PROJECT_UPDATE.ERROR.PROJECT_DRAFT": "Coś poszło nie tak: nie można zapisać wersji roboczej",
    "PROJECT_UPDATE.ERROR.PROJECT_STATUS_UPDATE": "Wystąpił błąd: nie można zaktualizować statusu projektu",
    "PROJECT_UPDATE.ERROR.PROJECT_UPDATE": "Coś poszło nie tak: nie można zaktualizować projektu",
    "PROJECT_UPDATE.FOOTER.CONTINUE": "Kontynuować",
    "PROJECT_UPDATE.FOOTER.DONE": "Zrobione",
    "PROJECT_UPDATE.FOOTER.PREVIOUS": "Poprzedni",
    "PROJECT_UPDATE.FOOTER.SAVE_DRAFT": "Zapisz wersję roboczą",
    "PROJECT_UPDATE.FOOTER.SUBMIT": "Składać",
    "PROJECT_UPDATE.SUCCESS.DRAFT_DELETED": "Projekt usunięty",
    "PROJECT_UPDATE.SUCCESS.PROJECT_DRAFT": "Zapisano wersję roboczą projektu",
    "PROJECT_UPDATE.SUCCESS.PROJECT_STATUS_UPDATE": "Zaktualizowano status projektu",
    "PROJECT_UPDATE.SUCCESS.PROJECT_UPDATE": "Projekt zaktualizowany",
    "PROJECT_UPDATE.TITLE_EDIT": "Edytuj projekt",
    "PROJECT_UPDATE.TITLE_VIEW": "Zobacz projekt",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_GENERAL": "Błąd ładowania mapy",
    "PROJECT.FORM.ERROR.MAP_PREVIEW_NO_GIS": "Nie znaleziono GIS.",
    "PROJECT.FORM.ERROR.ODL_LOADING": "Błąd ładowania plików ODL",
    "PROJECT.FORM.GIS_DATA.DESCRIPTION": "Prześlij nowe dane GIS lub wybierz istniejące",
    "PROJECT.FORM.GIS_DATA.EXISTING_GIS_UPLOADS": "Istniejące przesyłanie danych GIS",
    "PROJECT.FORM.GIS_DATA.TITLE": "Dane GIS",
    "PROJECT.FORM.GIS_DATA.UPLOAD_ALTERNATIVE": "lub wybierz istniejący",
    "PROJECT.FORM.GIS_DATA.UPLOAD_NEW_GIS": "Prześlij nowy GIS",
    "PROJECT.FORM.LABEL.COMPANY": "Firma",
    "PROJECT.FORM.LABEL.COST_PER_DISTANCE": "Koszt na dystans ($)",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY": "Gęstość rozmieszczenia",
    "PROJECT.FORM.LABEL.DEPLOYMENT_DENSITY_LEVEL": "Poziom {{level}}",
    "PROJECT.FORM.LABEL.DMA": "DMA",
    "PROJECT.FORM.LABEL.DMAS_LOADING": "Ładowanie DMA...",
    "PROJECT.FORM.LABEL.EMPTY_GIS_PREVIEW ": "Nie przesłano żadnego pliku GIS",
    "PROJECT.FORM.LABEL.END_DATE": "Data zakończenia",
    "PROJECT.FORM.LABEL.GIS_PREVIEW": "Podgląd GIS",
    "PROJECT.FORM.LABEL.LEAK_RADIUS": "Promień przecieku",
    "PROJECT.FORM.LABEL.LEAK_RADIUS_DESCRIPTION": "Dostosuj promień wycieku, aby kontrolować widoczność ODL na mapie. Zmiany zostaną zastosowane po zwolnieniu suwaka.",
    "PROJECT.FORM.LABEL.ODLS_GENERATING": "Generowanie ODL...",
    "PROJECT.FORM.LABEL.PARTNER_OR_SELF_SERVE": "Partner lub samoobsługa",
    "PROJECT.FORM.LABEL.PROJECT_NAME": "Nazwa projektu",
    "PROJECT.FORM.LABEL.SELF_SERVE_PROJECT": "Projekt samoobsługowy",
    "PROJECT.FORM.LABEL.START_DATE": "Data rozpoczęcia",
    "PROJECT.FORM.LABEL.TARGET_DISTANCE": "Odległość docelowa",
    "PROJECT.FORM.LABEL.TARGET_LEAKAGE": "Wyciek docelowy",
    "PROJECT.FORM.LABEL.WAITING_FOR_ODL": "Czekamy na generację ODL...",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_1": "Rozproszone rozmieszczenie: Może to być obszar z przewagą metalu lub niski budżet, gdzie nie trzeba pokrywać każdego centymetra,",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_2": "Standardowe wdrożenie: Jest to nasze standardowe zalecenie mające na celu zrównoważenie kosztów projektu i pokrycie obszaru, na którym znajdują się zarówno elementy metalowe, jak i plastikowe.",
    "PROJECT.FORM.OPTIONS.DEPLOYMENT_DENSITY_LEVEL_3": "Pełne pokrycie: Opcja ta może być używana w przypadku bardzo skomplikowanej sieci z tworzywa sztucznego z wieloma złączami, co gwarantuje pełne pokrycie przy dużym zużyciu energii przez czujnik.",
    "PROJECT.FORM.OPTIONS.NO_MATCHING": "Brak pasujących DMA",
    "PROJECT.FORM.PLACEHOLDER.DMA": "Wybierz DMA",
    "PROJECT.FORM.PLACEHOLDER.END_DATE": "Wybierz datę",
    "PROJECT.FORM.PLACEHOLDER.START_DATE": "Wybierz datę",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.DEFINITELY": "Odrzuć projekt definitywnie",
    "PROJECT.REJECT_DIALOG.BUTTON_REJECT.WITH_NOTES": "Odrzuć projekt z notatkami",
    "PROJECT.REJECT_DIALOG.DEFINITELY.DESCRIPTION": "Ta czynność spowoduje usunięcie projektu.",
    "PROJECT.REJECT_DIALOG.DEFINITELY.TITLE": "Odrzuć projekt definitywnie",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.LABEL": "Notatki",
    "PROJECT.REJECT_DIALOG.FORM.NOTES.PLACEHOLDER": "Dodaj swoje notatki",
    "PROJECT.REJECT_DIALOG.OR": "Lub",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.DESCRIPTION": "Projekt zostanie odesłany do użytkownika, który go przesłał. Będzie on mógł go edytować i przesłać ponownie lub usunąć.",
    "PROJECT.REJECT_DIALOG.WITH_NOTES.TITLE": "Odrzuć projekt z notatkami",
    "PROJECT.TOAST.DMA.ERROR": "Błąd ładowania danych DMA.",
    "PROJECT.TOAST.DMA.LOADING": "Ładowanie danych DMA...",
    "PROJECT.TOAST.DMA.SUCCESS": "Pomyślnie załadowano dane DMA.",
    "PROJECT.TOAST.ODL.ERROR": "Błąd generowania ODL.",
    "PROJECT.TOAST.ODL.LOADING": "Generowanie ODL...",
    "PROJECT.TOAST.ODL.PENDING": "Oczekiwanie na wygenerowanie ODL...",
    "PROJECT.TOAST.ODL.SUCCESS": "Pliki ODL wygenerowano pomyślnie.",
    "PROJECT.VIEW_REJECTION_NOTES.BUTTON_CLOSE": "Zrozumiałem",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.LABEL.NOTES": "Notatki administratora",
    "PROJECT.VIEW_REJECTION_NOTES.FORM.PLACEHOLDER.NOTES": "Notatki pozostawione przez administratora",
    "PROJECT.VIEW_REJECTION_NOTES.TITLE": "Projekt został odrzucony przez administratora",
    "PROJECTS.LOADING_PROJECT_INFO": "Ładowanie informacji o projekcie...",
    "RECOVERY_EXPIRED_PAGE.SUBTITLE": "Twój link nie jest już aktywny",
    "RECOVERY_EXPIRED_PAGE.TITLE": "Odzyskiwanie hasła",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.LABEL": "E-mail",
    "RECOVERY_PASSWORD_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź swój adres e-mail",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.LABEL": "Hasło",
    "RECOVERY_PASSWORD_PAGE.FORM.PASSWORD.PLACEHOLDER": "Wprowadź hasło",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.LABEL": "Powtórz hasło",
    "RECOVERY_PASSWORD_PAGE.FORM.REPEAT_PASSWORD.PLACEHOLDER": "Powtórz hasło",
    "RECOVERY_PASSWORD_PAGE.FORM.SUBMIT": "Odzyskaj",
    "RECOVERY_PASSWORD_PAGE.SUBTITLE": "Wprowadź hasło poniżej",
    "RECOVERY_PASSWORD_PAGE.TITLE": "Odzyskiwanie hasła",
    "REPORT_BUILDER.APPLY": "Zastosuj",
    "REPORT_BUILDER.BACK": "Powrót",
    "REPORT_BUILDER.EXPORT_TO_PDF": "Eksport do PDF",
    "REPORT_BUILDER.RUN": "Bieg",
    "REPORT_BUILDER.SAVE": "Zapisz",
    "REPORT_BUILDER.SORT_MODE": "Tryb sortowania",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.ASSET_LEAK": "Wyciek aktywów",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Licznik klienta/wyciek PRV",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.COMM_PIPE_LEAK": "Wyciek rury komunikacyjnej",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_METER_LEAK": "Wyciek licznika klienta",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Wyciek po stronie klienta",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.FERRULE_LEAK": "Wyciek z tulei",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.MAINS_LEAK": "Wyciek z sieci",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NA": "Nie dotyczy",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.NETWORK_MAINTENANCE": "Konserwacja sieci",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RENEW_STOP_TAP_MSM": "Odnów zawór Stop/MSM",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.REPAIR": "Naprawa",
    "REPORT.FILTERS.DROPDOWN.JOB_TYPE.RESOLVED_ONSITE": "Rozwiązano na miejscu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.ASSET_LEAK": "Wyciek aktywów",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Licznik klienta/wyciek PRV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMERCIAL_REPAIR": "Naprawa komercyjna",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.COMMUNICATION_PIPE": "Rura komunikacyjna",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CSL": "CSL",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_METER_LEAK": "Wyciek licznika klienta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Wyciek po stronie klienta",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.DECOMMISSION_FERRULE": "Tuleja do demontażu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Wykopanie otworu próbnego (pozwolenie)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Zewnętrzny miernik wycieku >40 mm z wyłączeniem",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Zewnętrzny miernik wycieku>40 mm Bez wyłączenia",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Zewnętrzny miernik wycieku <40 mm z wyłączeniem",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Zewnętrzny miernik wycieku <40 mm Bez wyłączenia",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE": "Okucie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FERRULE_EXCHANGE_NO_5": "Wymiana tulei nr 5",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H zatrzymany na miejscu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_HYDRANT": "Hydrant przeciwpożarowy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FIRE_MAIN": "Główna rura przeciwpożarowa",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Test przepływu na granicy bez wyłączenia",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Test przepływu na granicy z Exc",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM ma istnieć w kanale komunikacyjnym UnMtrd",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_FERRULE_ONLY": "Zainstaluj tylko tuleję",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_MSM_INC_METER": "Zainstaluj miernik MSM Inc.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SAMPLE_TAP": "Zainstaluj przykładowy kran",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_SLUICE_VALVE": "Zainstaluj zawór śluzowy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Montaż hydrantu spłukującego",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_FIXED_ONSITE": "Naprawa wycieku na miejscu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_FH": "Wyciek na F/H",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Wyciek na wrzecionie zaworu zwrotnego",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Wyciek na wrzecionie zaworu SV/kołnierza.",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS": "Sieć elektryczna",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_BURST": "Przerwa w dostawie prądu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.MAINS_LEAK": "Wyciek z sieci",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "N/A - W/O zatrzymany na miejscu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.NETWORK_MAINTENANCE": "Konserwacja sieci",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OSV_EXCHANGE": "Wymiana OSV",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.OTHER": "Inny",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_FH": "Przechodząc FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.PASSING_HYDRANT": "Przechodzący hydrant",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Prace naprawcze zewnętrzne",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Usuń zasuwę śluzy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Odnów rurę komunikacyjną wzdłuż boku",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Odnów rurę komunikacyjną po krótkiej stronie",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_COVER_AND_FRAME_STANDARD": "Odnów okładkę i ramkę (standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FERRULE_ONLY": "Odnów tylko tuleję",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT": "Odnów hydrant przeciwpożarowy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Odnów komorę hydrantową",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_AND_COVER": "Odnów ramę i osłonę hydrantu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Wymień nieszczelną rurę doprowadzającą >10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Wymień nieszczelną rurę doprowadzającą <10 m",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Wymień zespół MSM/zaworu odcinającego",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_SLUICE_VAVLE": "Odnów śluzę",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Odnów hydrant do płukania",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPACK_SLUICE_VALVE": "Zawór śluzowy do ponownego pakowania",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Napraw rurę komunikacyjną",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Naprawa zewnętrznego LSP – niekwalifikującego się",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Naprawa wewnętrznego wycieku (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Naprawa nieszczelnej rury doprowadzającej (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LOP": "Naprawa LOP",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Naprawa LSP - kwalifikuje się",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Naprawa głównego elementu kołkowego >=200mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Naprawa głównego kołka <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Naprawa główna [nie kołek] >=200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Naprawa główna [bez kołka] <200 mm",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_MAJOR_BURST": "Napraw poważny wybuch",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Naprawa zaworu zwrotnego",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Naprawa przepełnienia (Rech)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPAIR_SLUICE_VALVE": "Napraw zawór śluzy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Ponowne położenie zespołu MSM/zaworu odcinającego",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Reset Surface Box (standard)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SERVICE_LEAK": "Wyciek usługi",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE": "Zawór śluzowy",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.SLUICE_VALVE_VL": "Zawór śluzowy (VL)",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_EXCHANGE": "Stop Tap Exchange",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK": "Zatrzymaj wyciek z kranu",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.STOP_TAP_LEAK_NO_7": "Zatyczka do zaworu zwrotnego nr 7",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK_TYPE.WO_FH": "WO / FH",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.LEAK": "Przeciek",
    "REPORT.FILTERS.DROPDOWN.PREDICTED_LEAK.NO_LEAK": "Bez wycieków",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE": "Przewidywany rozmiar",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.LARGE": "Duży",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.MEDIUM": "Średni",
    "REPORT.FILTERS.DROPDOWN.PREDICTEDSIZE.SMALL": "Mały",
    "REPORT.FILTERS.DROPDOWN.STATUS": "Status",
    "REPORT.FILTERS.DROPDOWN.STATUS.1": "Breakout",
    "REPORT.FILTERS.DROPDOWN.STATUS.10": "Inprogress ST (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.11": "Znany wyciek",
    "REPORT.FILTERS.DROPDOWN.STATUS.12": "Wyciek zgłoszony klientowi",
    "REPORT.FILTERS.DROPDOWN.STATUS.13": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.14": "Proponowane",
    "REPORT.FILTERS.DROPDOWN.STATUS.15": "Zaplanowana naprawa",
    "REPORT.FILTERS.DROPDOWN.STATUS.16": "Naprawiono",
    "REPORT.FILTERS.DROPDOWN.STATUS.17": "Zaplanowane dni",
    "REPORT.FILTERS.DROPDOWN.STATUS.18": "Zaplanowane noce",
    "REPORT.FILTERS.DROPDOWN.STATUS.19": "Niepotwierdzone źródło hałasu",
    "REPORT.FILTERS.DROPDOWN.STATUS.2": "Potwierdzone źródło hałasu",
    "REPORT.FILTERS.DROPDOWN.STATUS.20": "Zatwierdzony",
    "REPORT.FILTERS.DROPDOWN.STATUS.3": "Gromadzenie danych",
    "REPORT.FILTERS.DROPDOWN.STATUS.4": "Usunięto",
    "REPORT.FILTERS.DROPDOWN.STATUS.5": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.6": "Edytowano",
    "REPORT.FILTERS.DROPDOWN.STATUS.7": "Wymagane dalsze prace",
    "REPORT.FILTERS.DROPDOWN.STATUS.8": "W toku",
    "REPORT.FILTERS.DROPDOWN.STATUS.9": "Inprogress LE (Breakout)",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITING_SCHEDULING": "Oczekiwanie na harmonogram",
    "REPORT.FILTERS.DROPDOWN.STATUS.AWAITINGSCHEDULING": "Oczekiwanie na harmonogram",
    "REPORT.FILTERS.DROPDOWN.STATUS.CLOSED": "Zamknięte",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMED_NOISE_SOURCE": "Potwierdzone źródło hałasu",
    "REPORT.FILTERS.DROPDOWN.STATUS.CONFIRMEDNOISESOURCE": "Potwierdzone źródło hałasu",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRY_DIG": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.DRYDIG": "Dry Dig",
    "REPORT.FILTERS.DROPDOWN.STATUS.EDITED": "Edytowano",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHER_WORK_REQUESTED": "Wymagane dalsze prace",
    "REPORT.FILTERS.DROPDOWN.STATUS.FURTHERWORKREQUESTED": "Wymagane dalsze prace",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAK_SUBMITTED_TO_CLIENT": "Wyciek zgłoszony klientowi",
    "REPORT.FILTERS.DROPDOWN.STATUS.LEAKSUBMITTEDTOCLIENT": "Wyciek zgłoszony klientowi",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKED_UP": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.MARKEDUP": "Marked Up",
    "REPORT.FILTERS.DROPDOWN.STATUS.PROPOSED": "Proponowane",
    "REPORT.FILTERS.DROPDOWN.STATUS.REPAIRED": "Naprawiono",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULED": "Zaplanowane",
    "REPORT.FILTERS.DROPDOWN.STATUS.SCHEDULING": "Harmonogram",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED": "Niepotwierdzone",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMED_NOISE_SOURCE": "Niepotwierdzone źródło hałasu",
    "REPORT.FILTERS.DROPDOWN.STATUS.UNCONFIRMEDNOISESOURCE": "Niepotwierdzone źródło hałasu",
    "REPORT.FILTERS.FILTER.BUTTON": "Filtry",
    "REPORT.FILTERS.SAVE.BUTTON": "Zapisz widok",
    "REPORTS_PAGE.CREATE_REPORT.BUTTON": "Utwórz raport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.CHOOSE_LAYOUT.LABEL": "Wybierz układ",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REDIRECT_TO_EDIT": "Edytuj raport",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.LABEL": "Nazwa raportu",
    "REPORTS_PAGE.CREATE_REPORT.FORM.REPORT_NAME.PLACEHOLDER": "Wprowadź nazwę raportu",
    "REPORTS_PAGE.CREATE_REPORT.FORM.SUBMIT": "Utwórz raport",
    "REPORTS_PAGE.CREATE_REPORT.TITLE": "Utwórz nowy raport",
    "REPORTS_PAGE.CRUMB": "Raporty",
    "REPORTS_PAGE.SUBTITLE": "Raporty z wyników FIDO Sweep",
    "REPORTS_PAGE.TABLE.ACTIONS": "Działania",
    "REPORTS_PAGE.TABLE.CREATED": "Utworzony",
    "REPORTS_PAGE.TABLE.NUMBER": "#",
    "REPORTS_PAGE.TABLE.REPORT_NAME": "Nazwa raportu",
    "REPORTS_PAGE.TITLE.NO_REPORTS": "Nie ma żadnych raportów",
    "REPORTS_PAGE.TITLE.TOTAL_COUNT": "Łączna liczba raportów:",
    "REQUEST.FAILED": "Nie powiodło się",
    "REQUEST.SUCCESS": "Sukces",
    "SERVER_ERRORS.-1": "Coś poszło nie tak",
    "SERVER_ERRORS.1": "Błąd połączenia z bazą danych",
    "SERVER_ERRORS.10": "Błąd pustego pliku",
    "SERVER_ERRORS.11": "Błąd uwierzytelniania",
    "SERVER_ERRORS.12": "Błąd uwierzytelniania",
    "SERVER_ERRORS.13": "Błąd uwierzytelniania",
    "SERVER_ERRORS.14": "Błąd uwierzytelniania",
    "SERVER_ERRORS.15": "Błąd uwierzytelniania",
    "SERVER_ERRORS.16": "Użytkownik z podanym adresem e-mail nie został znaleziony",
    "SERVER_ERRORS.17": "Adres e-mail lub hasło są nieprawidłowe",
    "SERVER_ERRORS.18": "Token adresu e-mail jest nieprawidłowy",
    "SERVER_ERRORS.19": "Odmowa zezwolenia",
    "SERVER_ERRORS.2": "Coś poszło nie tak",
    "SERVER_ERRORS.21": "Nie znaleziono użytkownika",
    "SERVER_ERRORS.22": "Nie znaleziono roli",
    "SERVER_ERRORS.23": "Nie znaleziono firmy",
    "SERVER_ERRORS.24": "Nie znaleziono projektu",
    "SERVER_ERRORS.25": "Odmowa zezwolenia",
    "SERVER_ERRORS.26": "Odmowa zezwolenia",
    "SERVER_ERRORS.27": "Nieprawidłowe dane pliku",
    "SERVER_ERRORS.28": "Ta wiadomość e-mail już istnieje",
    "SERVER_ERRORS.3": "Nieprawidłowe żądanie",
    "SERVER_ERRORS.31": "Nie znaleziono firmy",
    "SERVER_ERRORS.32": "Nazwa firmy jest nieprawidłowa lub już istnieje",
    "SERVER_ERRORS.4": "Nieprawidłowy format pliku",
    "SERVER_ERRORS.41": "Nie znaleziono firmy",
    "SERVER_ERRORS.5": "Nieautoryzowane",
    "SERVER_ERRORS.6": "Nie znaleziono zasobu",
    "SERVER_ERRORS.61": "Metoda niedozwolona",
    "SERVER_ERRORS.62": "Nieudane wywołanie API",
    "SERVER_ERRORS.63": "Nieprawidłowy typ geometrii",
    "SERVER_ERRORS.65": "Projekt pokrywa się z istniejącymi projektami {{ projectNames }} i DMA {{ dmaKeys }}",
    "SERVER_ERRORS.7": "Usługa niedostępna",
    "SERVER_ERRORS.8": "Błąd magazynu Azure",
    "SERVER_ERRORS.9": "Nieprawidłowy format geojson",
    "SERVER_SUCCESS.ADD_COMPANY": "Firma pomyślnie utworzona",
    "SERVER_SUCCESS.CREATE_BRANCH": "Projekt został pomyślnie utworzony",
    "SERVER_SUCCESS.CREATE_USER": "Użytkownik został pomyślnie utworzony",
    "SERVER_SUCCESS.EDIT_COMPANY": "Firma pomyślnie zaktualizowana",
    "SERVER_SUCCESS.EDIT_USER": "Użytkownik został pomyślnie zaktualizowany",
    "SERVER_SUCCESS.FORGOT_PASSWORD": "Link odzyskiwania został pomyślnie wysłany",
    "SERVER_SUCCESS.LOGIN": "Logowanie powiodło się",
    "SERVER_SUCCESS.LOGOUT": "Wylogowanie powiodło się",
    "SERVER_SUCCESS.RECOVERY": "Odzyskiwanie zakończyło się sukcesem",
    "SERVER_SUCCESS.UPDATE_BRANCH": "Projekt został pomyślnie zaktualizowany",
    "SERVER_SUCCESS.UPDATE_REPORT": "Raport został zaktualizowany",
    "SESSION_PAGE.ENGINEERING_DETAILS.3D_PLOT_TOGGLE_TITLE": "Oddzielne sesje nocne",
    "SESSION_PAGE.ENGINEERING_DETAILS.ADDRESS_TITLE": "Szczegóły adresu",
    "SESSION_PAGE.ENGINEERING_DETAILS.APPLY_DATES": "Zastosuj daty",
    "SESSION_PAGE.ENGINEERING_DETAILS.ASSET_TITLE": "Obrazy zasobów",
    "SESSION_PAGE.ENGINEERING_DETAILS.COLLECTED_ENGINEER": "Collected Engineer",
    "SESSION_PAGE.ENGINEERING_DETAILS.COMPANY": "Firma",
    "SESSION_PAGE.ENGINEERING_DETAILS.DATE_TITLE": "Data Godziny",
    "SESSION_PAGE.ENGINEERING_DETAILS.DEPLOYED_ENGINEER": "Wdrożony inżynier",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.ADDRESS": "Adres",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.COMPANY": "Firma",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.CREATED": "Utworzony",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.DMA_KEY": "Klucz DMA",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.END_TIME": "Czas zakończenia",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.FIDO_RESULT": "Wynik Fido",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LAST_UPDATE": "Ostatnia aktualizacja",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LEAK_SIZE": "Rozmiar wycieku",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.LOCATION": "Lokalizacja",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SENSOR_ID": "Identyfikator czujnika",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_ID": "Identyfikator sesji",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.SESSION_STATUS": "Status sesji",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.START_TIME": "Godzina rozpoczęcia",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.TYPE": "Typ",
    "SESSION_PAGE.ENGINEERING_DETAILS.DESC.WAYPOINT_NAME": "Nazwa punktu trasy",
    "SESSION_PAGE.ENGINEERING_DETAILS.ENGINEER_TITLE": "Inżynierowie",
    "SESSION_PAGE.ENGINEERING_DETAILS.GRAPH_TITLE": "Wykres pyłków",
    "SESSION_PAGE.ENGINEERING_DETAILS.ID_TITLE": "Lista identyfikatorów",
    "SESSION_PAGE.ENGINEERING_DETAILS.LAST_UPDATED": "Dni od ostatniej aktualizacji",
    "SESSION_PAGE.ENGINEERING_DETAILS.POSTCODE": "Kod pocztowy",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_ERROR": "Wystąpił błąd podczas przetwarzania danych przekaźnika",
    "SESSION_PAGE.ENGINEERING_DETAILS.RELAY_NO_DATA": "Brak obecnie dostępnych danych",
    "SESSION_PAGE.ENGINEERING_DETAILS.RESET_DATES": "Zresetuj daty",
    "SESSION_PAGE.ENGINEERING_DETAILS.SESSION_TITLE": "Szczegóły sesji",
    "SESSION_PAGE.ENGINEERING_DETAILS.TITLE": "Szczegóły techniczne FIDO",
    "SESSION_PAGE.ENGINEERING_DETAILS.WHAT3WORDS": "What3Words",
    "SESSION_PAGE.GET_AUDIO.BUTTON.CANCEL": "Anuluj odzyskiwanie",
    "SESSION_PAGE.GET_AUDIO.BUTTON.GET": "Retrieve Audio",
    "SESSION_PAGE.GET_AUDIO.BUTTON.NA": "Brak dostępnego urządzenia przekaźnikowego",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.CONTENT": "Aby pobrać dźwięk, do tej sesji musi być podłączone urządzenie przekaźnikowe. Jeśli nie ma podłączonego urządzenia przekaźnikowego, nie będzie można pobrać żadnego dźwięku za pośrednictwem portalu dla tej sesji, a przycisk zostanie wyłączony.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.AVAILABLE.HEADING": "Dostępność",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT1": "Niezależnie od tego, w jaki sposób urządzenie przekaźnikowe zostało wyzwolone, można je włączyć lub wyłączyć za pomocą powyższego przycisku. Możliwe ostatnie działania i odpowiadające im statusy to",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT2": "Włączenie przez użytkownika portalu - urządzenie przekaźnikowe pobierze dźwięk",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT3": "Wyzwalane WYŁ. przez użytkownika portalu - urządzenie przekaźnikowe nie będzie pobierać dźwięku.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT4": "Włączenie przez proces automatyczny - urządzenie przekaźnikowe pobierze dźwięk",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT5": "Wyzwalane WYŁ. przez automatyczny proces - urządzenie przekaźnikowe nie pobierze dźwięku",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.CONTENT6": "Nie dotyczy - urządzenie przekaźnikowe nie jest dostępne",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.FUNCTION.TITLE": "Funkcjonalność",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT1": "W tej sekcji założymy, że istnieje podłączone urządzenie przekaźnikowe.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT2": "Można przełączyć, czy urządzenie przekaźnikowe powinno próbować pobrać dane audio w ciągu następnych 24 godzin.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT3": "Po zakończeniu żądania dane na tej stronie zostaną zaktualizowane, a następnie pobieranie dźwięku zostanie automatycznie wyłączone.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.CONTENT4": "Istnieje również zautomatyzowany proces, który automatycznie pobierze dane audio dla wszystkich sesji, które mają podłączone urządzenie przekaźnikowe, biorąc pod uwagę, że nasz model wykrył problem.",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.PROCESS.HEADING": "Proces",
    "SESSION_PAGE.GET_AUDIO.DESCRIP.TITLE": "Objaśnienie urządzeń przekaźnikowych",
    "SESSION_PAGE.GET_AUDIO.ERROR": "Wystąpił błąd, odśwież stronę i spróbuj ponownie",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION": "Ostatnio podjęte działanie",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_OFF": "Wyzwalane WYŁ. przez zautomatyzowany proces",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.AUTO_ON": "Włączony przez zautomatyzowany proces",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.NA": "NIE DOTYCZY",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_OFF": "Wyzwalane WYŁ. przez użytkownika portalu",
    "SESSION_PAGE.GET_AUDIO.LAST_ACTION.USER_ON": "Włączane przez użytkownika portalu",
    "SESSION_PAGE.GET_AUDIO.STATUS": "Aktualny status",
    "SESSION_PAGE.GET_AUDIO.STATUS.GET": "Urządzenie przekaźnikowe pobierze dźwięk",
    "SESSION_PAGE.GET_AUDIO.STATUS.NA": "Urządzenie przekaźnikowe niedostępne",
    "SESSION_PAGE.GET_AUDIO.STATUS.NOT_GET": "Urządzenie przekaźnikowe nie pobiera dźwięku",
    "SESSION_PAGE.GET_AUDIO.TITLE": "Odzyskiwanie dźwięku",
    "SESSION_PAGE.RELAY_GRAPH.X": "Częstotliwość",
    "SESSION_PAGE.RELAY_GRAPH.Y": "Czas",
    "SESSION_PAGE.RELAY_GRAPH.Z": "Moc",
    "SESSION_PAGE.SESSION_INFORMATION.FIDO_RESULT": "Wynik FIDO",
    "SESSION_PAGE.SESSION_INFORMATION.LEAK_SIZE": "Rozmiar wycieku",
    "SESSION_PAGE.SESSION_INFORMATION.TITLE": "Informacje o sesji",
    "SESSION.LOADING_LEAK_MAPPER": "Ładowanie mapera wycieków...",
    "SESSIONS.STATUS.DELETED": "Usunięto",
    "SESSIONS.STATUS.ON_TRACK": "Na dobrej drodze",
    "SESSIONS.STATUS.UPLOADED": "Załadowany",
    "SESSIONS.STATUS.UPLOADING": "Oczekiwanie na przesłanie",
    "SIDEBAR.ADMIN": "Administrator",
    "SIDEBAR.BROWSE": "Przeglądaj",
    "SIDEBAR.COMPANIES": "Firmy",
    "SIDEBAR.COMPANY": "Moja firma",
    "SIDEBAR.DASHBOARD": "Pulpit nawigacyjny",
    "SIDEBAR.DELIVERY_PERFORMANCE": "Wydajność dostaw",
    "SIDEBAR.DELIVERY_PERFORMANCE_LE": "Inżynier ds. wycieków",
    "SIDEBAR.DELIVERY_PERFORMANCE_ST": "Technik czujników",
    "SIDEBAR.DMAPERFORMANCEREPORT": "Raport wydajności DMA",
    "SIDEBAR.FEEDBACK": "Przekazywanie informacji zwrotnych",
    "SIDEBAR.GIS": "GIS",
    "SIDEBAR.GIS_ADMIN": "Administrator GIS",
    "SIDEBAR.GIS_UPLOAD": "Przesyłanie GIS",
    "SIDEBAR.LOGOUT": "Wyloguj się",
    "SIDEBAR.LOGS": "Dzienniki zmian",
    "SIDEBAR.PROJECT_ADMIN": "Administrator projektu",
    "SIDEBAR.PROJECT_STATUS": "Status projektu",
    "SIDEBAR.PROJECTSTATUS": "Status projektu",
    "SIDEBAR.RELAY_MANAGEMENT": "Zarządzanie przekaźnikami",
    "SIDEBAR.REPORTS": "Raporty",
    "SIDEBAR.SENSOR_MANAGEMENT": "Zarządzanie czujnikami",
    "SIDEBAR.STOCK_MANAGEMENT": "Zarządzanie zapasami",
    "SIDEBAR.TITLE": "Panel administracyjny",
    "SIDEBAR.USERS": "Zarządzanie użytkownikami",
    "SIDEBAR.VERSION": "Wersja ",
    "STOCK_MANAGEMENT.DATES_BETWEEN": "Pokaż użycie pomiędzy",
    "STOCK_MANAGEMENT.DATES_BETWEEN.AND": "oraz",
    "STOCK_MANAGEMENT.DISTRIBUTION.CHART_TITLE": "Dystrybucja do klienta",
    "STOCK_MANAGEMENT.DISTRIBUTION.DATE_ERROR": "Data początkowa nie może być większa niż data końcowa",
    "STOCK_MANAGEMENT.DISTRIBUTION.FAULTY": "Wadliwe czujniki FIDO",
    "STOCK_MANAGEMENT.DISTRIBUTION.FILTER": "Filtr",
    "STOCK_MANAGEMENT.DISTRIBUTION.NO_DATA": "Brak danych dystrybucji zapasów dla wybranego zakresu dat",
    "STOCK_MANAGEMENT.DISTRIBUTION.REFURBED": "Odnowione czujniki FIDO",
    "STOCK_MANAGEMENT.DISTRIBUTION.RETURNED": "Zwrócone czujniki FIDO",
    "STOCK_MANAGEMENT.DISTRIBUTION.STOCKED": "Czujniki FIDO w magazynie",
    "STOCK_MANAGEMENT.DISTRIBUTION.TITLE": "Dystrybucja zapasów do klientów",
    "STOCK_MANAGEMENT.DISTRIBUTION.TOGGLE_ALL": "Przełącz wszystko",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.FAULTY": "Wadliwe przekaźniki FIDO",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.REFURBED": "Odnowione przekaźniki FIDO",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.RETURNED": "Zwrócone przekaźniki FIDO",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.STOCKED": "Przekaźniki FIDO w magazynie",
    "STOCK_MANAGEMENT.RELAY.DISTRIBUTION.TITLE": "Dystrybucja przekaźników do klientów",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.FAULTY": "Wadliwe czujniki FIDO",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.REFURBED": "Odnowione czujniki FIDO",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.RETURNED": "Zwrócone czujniki FIDO",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.STOCKED": "Czujniki FIDO w magazynie",
    "STOCK_MANAGEMENT.SENSOR.DISTRIBUTION.TITLE": "Dystrybucja czujników do klientów",
    "STOCK_MANAGEMENT.TABLE.BUG_NAME": "Nazwa czujnika",
    "STOCK_MANAGEMENT.TABLE.BUG_OWNER": "Właściciel czujnika",
    "STOCK_MANAGEMENT.TABLE.COMMENT": "Komentarz",
    "STOCK_MANAGEMENT.TABLE.CUSTOMER": "Klient",
    "STOCK_MANAGEMENT.TABLE.DATE": "Ostatnia data",
    "STOCK_MANAGEMENT.TABLE.DATE_FROM": "Od",
    "STOCK_MANAGEMENT.TABLE.DATE_TO": "Do",
    "STOCK_MANAGEMENT.TABLE.DEVICE_ID": "Identyfikator czujnika",
    "STOCK_MANAGEMENT.TABLE.EDIT_SECTION": "Edytuj akcje",
    "STOCK_MANAGEMENT.TABLE.EDIT.COMMENTS": "Komentarze",
    "STOCK_MANAGEMENT.TABLE.EDIT.CUSTOMER": "Klient",
    "STOCK_MANAGEMENT.TABLE.EDIT.DESELECT": "Odznacz wszystkie akcje",
    "STOCK_MANAGEMENT.TABLE.EDIT.DISCARD": "Anuluj",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_COMMENTS": "Wprowadź komentarz",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_CUSTOMER": "Wybierz klienta",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_OWNER": "Wybierz właściciela czujnika",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_STATUS": "Wybierz status",
    "STOCK_MANAGEMENT.TABLE.EDIT.NO_TIMESTAMP": "Wybierz znacznik czasu",
    "STOCK_MANAGEMENT.TABLE.EDIT.OWNER": "Właściciel czujnika",
    "STOCK_MANAGEMENT.TABLE.EDIT.PARTNER": "Partner",
    "STOCK_MANAGEMENT.TABLE.EDIT.RELAY_OWNER": "Właściciel przekaźnika",
    "STOCK_MANAGEMENT.TABLE.EDIT.SENSOR_OWNER": "Właściciel czujnika",
    "STOCK_MANAGEMENT.TABLE.EDIT.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.EDIT.SUBMIT": "Aktualizacja",
    "STOCK_MANAGEMENT.TABLE.EDIT.TIMESTAMP": "Znacznik czasu",
    "STOCK_MANAGEMENT.TABLE.EDIT.TITLE": "Zmodyfikuj wybrane akcje",
    "STOCK_MANAGEMENT.TABLE.FILTER": "Filtr",
    "STOCK_MANAGEMENT.TABLE.FILTER_SECTION": "Filtry, sortowanie i wyszukiwanie",
    "STOCK_MANAGEMENT.TABLE.MODIFY": "Modyfikuj wybrane",
    "STOCK_MANAGEMENT.TABLE.NO_DATA": "Brak danych o stanie magazynowym",
    "STOCK_MANAGEMENT.TABLE.PERSON": "Osoba",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_NAME": "Nazwa przekaźnika",
    "STOCK_MANAGEMENT.TABLE.RELAY.BUG_OWNER": "Właściciel przekaźnika",
    "STOCK_MANAGEMENT.TABLE.RELAY.COMMENT": "Komentarz",
    "STOCK_MANAGEMENT.TABLE.RELAY.CUSTOMER": "Klient",
    "STOCK_MANAGEMENT.TABLE.RELAY.DATE": "Ostatnia data",
    "STOCK_MANAGEMENT.TABLE.RELAY.IMEI": "IMEI",
    "STOCK_MANAGEMENT.TABLE.RELAY.PERSON": "Osoba",
    "STOCK_MANAGEMENT.TABLE.RELAY.SIM": "SIM ID",
    "STOCK_MANAGEMENT.TABLE.RELAY.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.RELAY.TIMESTAMP": "Ostatni czas",
    "STOCK_MANAGEMENT.TABLE.SEARCH_BAR.APPLY.FILTER": "Stosowanie filtrów, sortowanie i wyszukiwanie",
    "STOCK_MANAGEMENT.TABLE.SEARCH.PLACEHOLDER": "Szukaj czujników...",
    "STOCK_MANAGEMENT.TABLE.SELECT_ALL": "Wybierz wszystko",
    "STOCK_MANAGEMENT.TABLE.SELECT_WAYPOINT": "Wybierz",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_NAME": "Nazwa czujnika",
    "STOCK_MANAGEMENT.TABLE.SENSOR.BUG_OWNER": "Właściciel czujnika",
    "STOCK_MANAGEMENT.TABLE.SENSOR.COMMENT": "Komentarz",
    "STOCK_MANAGEMENT.TABLE.SENSOR.CUSTOMER": "Klient",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DATE": "Ostatnia data",
    "STOCK_MANAGEMENT.TABLE.SENSOR.DEVICE_ID": "Identyfikator czujnika",
    "STOCK_MANAGEMENT.TABLE.SENSOR.PERSON": "Osoba",
    "STOCK_MANAGEMENT.TABLE.SENSOR.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.SENSOR.TIMESTAMP": "Ostatni czas",
    "STOCK_MANAGEMENT.TABLE.SORT": "Sortuj",
    "STOCK_MANAGEMENT.TABLE.SORT.ASC": "Rosnąco",
    "STOCK_MANAGEMENT.TABLE.SORT.DESC": "Schodzenie",
    "STOCK_MANAGEMENT.TABLE.SORT.NONE": "Brak",
    "STOCK_MANAGEMENT.TABLE.STATUS": "Status",
    "STOCK_MANAGEMENT.TABLE.STATUSES.customer": "klient",
    "STOCK_MANAGEMENT.TABLE.STATUSES.faulty": "wadliwy",
    "STOCK_MANAGEMENT.TABLE.STATUSES.new": "nowy",
    "STOCK_MANAGEMENT.TABLE.STATUSES.refurb": "odnowiony",
    "STOCK_MANAGEMENT.TABLE.STATUSES.retired": "na emeryturze",
    "STOCK_MANAGEMENT.TABLE.STATUSES.returned": "zwrócony",
    "STOCK_MANAGEMENT.TABLE.STATUSES.stock": "zapas",
    "STOCK_MANAGEMENT.TABLE.TIMESTAMP": "Ostatni czas",
    "STOCK_MANAGEMENT.TABLE.TITLE": "Wszystkie akcje",
    "SUMMARY.DIALOG.SUBTITLE.CHANGE": "Wszystkie filtry zostaną usunięte?",
    "SUMMARY.DIALOG.SUBTITLE.CLOSE": "Czy zmiany zostaną usunięte?",
    "SUMMARY.DIALOG.TITLE.CHANGE": "Czy na pewno chcesz zmienić źródło danych?",
    "SUMMARY.DIALOG.TITLE.CLOSE": "Czy na pewno chcesz zamknąć ustawienia?",
    "SUMMARY.FORM.COLUMN.LABEL": "Kolumna",
    "SUMMARY.FORM.COLUMN.PLACEHOLDER": "Wybierz kolumnę",
    "SUMMARY.FORM.SOURCE.LABEL": "Źródło danych",
    "SUMMARY.FORM.SOURCE.PLACEHOLDER": "Wybierz źródło danych",
    "SUMMARY.FORM.TITLE.LABEL": "Tytuł",
    "SUMMARY.FORM.TITLE.PLACEHOLDER": "Wprowadź tytuł",
    "SUMMARY.FORM.TYPE.LABEL": "Typ",
    "SUMMARY.FORM.TYPE.PLACEHOLDER": "Wybierz typ",
    "SUMMARY.MODAL_TITLE": "Ustawienia",
    "SYSTEM_FIELDS.CELLS_FILLED": "Wypełnione komórki",
    "SYSTEM_FIELDS.DROPDOWN.1.PLACEHOLDER": "Wybierz materiał",
    "SYSTEM_FIELDS.DROPDOWN.2.PLACEHOLDER": "Wybierz typ zasobu",
    "SYSTEM_FIELDS.DROPDOWN.3.PLACEHOLDER": "Wybierz typ rury",
    "SYSTEM_FIELDS.DROPDOWN.4.PLACEHOLDER": "Wybierz status",
    "SYSTEM_FIELDS.DROPDOWN.5.PLACEHOLDER": "Wybierz jednostki",
    "SYSTEM_FIELDS.ERROR.NUMERIC_UNIQUE_FIELD": "Wprowadzone unikalne pole jest numeryczne i powinno być ciągiem znaków",
    "SYSTEM_FIELDS.ROW_1": "Pola rzędów",
    "SYSTEM_FIELDS.ROW_2": "Pola systemowe",
    "SYSTEM_FIELDS.TITLE": "Mapowanie komórek z polami systemowymi",
    "SYSTEM_FIELDS.UNIQUE_VALUES_NOT_FOUND": "Brak unikalnych wartości do zmapowania",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CHANGE": "Wszystkie filtry zostaną usunięte?",
    "TABLE_OF_RESULTS.DIALOG.SUBTITLE.CLOSE": "Czy zmiany zostaną usunięte?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CHANGE": "Czy na pewno chcesz zmienić źródło danych?",
    "TABLE_OF_RESULTS.DIALOG.TITLE.CLOSE": "Czy na pewno chcesz zamknąć ustawienia?",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.LABEL": "Kolumna do wyświetlenia",
    "TABLE_OF_RESULTS.FORM.COLUMNS_TO_SHOW.PLACEHOLDER": "Wybierz kolumny",
    "TABLE_OF_RESULTS.FORM.SOURCE.LABEL": "Źródło danych",
    "TABLE_OF_RESULTS.FORM.SOURCE.PLACEHOLDER": "Wybierz źródło danych",
    "TABLE_OF_RESULTS.MODAL_TITLE": "Ustawienia",
    "TOOLTIP.ADDRESS": "Adres",
    "TOOLTIP.ASSET_KEY": "Klucz aktywów",
    "TOOLTIP.COMPANY": "Firma",
    "TOOLTIP.CONSUMPTION_PROFILE_ID": "Identyfikator profilu konsumpcji",
    "TOOLTIP.DAYS_SINCE_LAST": "Dni od ostatniej aktualizacji",
    "TOOLTIP.DEPLOYED_BY": "Wdrożony przez",
    "TOOLTIP.DEPLOYMENT_ORDER": "Kolejność wdrażania",
    "TOOLTIP.DIAMETER": "Średnica",
    "TOOLTIP.DMA_ID": "Id DMA",
    "TOOLTIP.DMA_KEY": "Klucz DMA",
    "TOOLTIP.DMA_NAME": "Nazwa DMA",
    "TOOLTIP.ENGINEER": "Inżynier",
    "TOOLTIP.FIDO_RESULT": "Wynik Fido",
    "TOOLTIP.LATITUDE": "Szerokość geograficzna",
    "TOOLTIP.LEAK_SIZE": "Rozmiar wycieku",
    "TOOLTIP.LONGITUDE": "Długość geograficzna",
    "TOOLTIP.MATERIAL": "Materiał",
    "TOOLTIP.PIPE_TYPE": "Typ rury",
    "TOOLTIP.RECORDINGS_CNT": "Liczba nagrań",
    "TOOLTIP.SESSION_ID": "Id sesji",
    "TOOLTIP.STANDARDISED_MATERIAL": "Znormalizowany materiał",
    "TOOLTIP.STANDARISED_ASSET_TYPE": "Standaryzowany typ aktywów",
    "TOOLTIP.TOP_SOUND_ID": "Top Sound ID",
    "TOOLTIP.WAYPOINT_ID": "Identyfikator punktu trasy",
    "TOOLTIP.WAYPOINT_NAME": "Nazwa punktu trasy",
    "TOOLTIP.WHAT_3_WORDS": "Jakie 3 słowa",
    "TOP_SOUND_PAGE.AUDIO_INFORMATION": "Informacje audio",
    "TOP_SOUND_PAGE.COMPANY": "Firma",
    "TOP_SOUND_PAGE.DISTANCE_GRAPH_TITLE": "Wykresy odległości",
    "TOP_SOUND_PAGE.ENGINEER": "Inżynier",
    "TOP_SOUND_PAGE.HIGH_FREQUENCY": "Odcięcie wysokiej częstotliwości",
    "TOP_SOUND_PAGE.LOCATION": "Lokalizacja",
    "TOP_SOUND_PAGE.LOCATION_DETAILS": "Szczegóły lokalizacji",
    "TOP_SOUND_PAGE.LOW_FREQUENCY": "Odcięcie niskiej częstotliwości",
    "TOP_SOUND_PAGE.NUMBER_PATHS": "Liczba ścieżek",
    "TOP_SOUND_PAGE.POSTCODE": "Kod pocztowy",
    "TOP_SOUND_PAGE.PSDS_TITLE": "Profil widmowy",
    "TOP_SOUND_PAGE.SPACING": "Rozstaw",
    "TOP_SOUND_PAGE.STARTING_DISTANCE": "Odległość początkowa",
    "TOP_SOUND_PAGE.TIME_TOP_SOUNDING": "Czas górnego brzmienia",
    "TOP_SOUND_PAGE.TITLE": "Brzmienie górne",
    "TOP_SOUND_PAGE.WHAT3WORDS": "What3Words",
    "TOP_SOUNDING.GRAPH_ALT": "wykres odległości sondowania górnego",
    "TOP_SOUNDING.PSD_GRAPH_ALT": "wykres psd",
    "UNIT.GALLONS_DAY": "Galony/dzień",
    "UNIT.ML_DAY": "ML/dzień",
    "UPLOAD_HEALTH_CHECK.BTN": "Wgraj test kondycji",
    "UPLOAD_HEALTH_CHECK.MODAL.BTN.SUBMIT": "Prześlij",
    "UPLOAD_HEALTH_CHECK.MODAL.DESC": "Wprowadź adres URL w polu poniżej",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.DESC": "Spróbuj ponownie, adres URL nie został zaktualizowany",
    "UPLOAD_HEALTH_CHECK.MODAL.ERROR.TITLE": "Spróbuj ponownie!",
    "UPLOAD_HEALTH_CHECK.MODAL.INPUT.LABEL": "Adres URL oceny stanu zdrowia",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.DESC": "Adres URL kontroli kondycji został zaktualizowany",
    "UPLOAD_HEALTH_CHECK.MODAL.SUCCESS.TITLE": "Niesamowite!",
    "UPLOAD_HEALTH_CHECK.MODAL.TITLE": "Prześlij raport z oceny stanu zdrowia",
    "USER_DETAILS_PAGE.CRUMB": "Zarządzaj użytkownikiem",
    "USER_DETAILS_PAGE.DISCARD": "Odrzucenie",
    "USER_DETAILS_PAGE.FORM.BRANCH.LABEL": "Projekt",
    "USER_DETAILS_PAGE.FORM.BRANCH.PLACEHOLDER": "Wybierz projekt",
    "USER_DETAILS_PAGE.FORM.COMPANY.LABEL": "Firma",
    "USER_DETAILS_PAGE.FORM.COMPANY.PLACEHOLDER": "Wybierz firmę",
    "USER_DETAILS_PAGE.FORM.EMAIL.LABEL": "Adres e-mail",
    "USER_DETAILS_PAGE.FORM.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.LABEL": "Imię",
    "USER_DETAILS_PAGE.FORM.FIRST_NAME.PLACEHOLDER": "Wprowadź imię",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.LABEL": "Nazwisko",
    "USER_DETAILS_PAGE.FORM.LAST_NAME.PLACEHOLDER": "Wpisz nazwisko",
    "USER_DETAILS_PAGE.FORM.ROLE.LABEL": "Rola",
    "USER_DETAILS_PAGE.FORM.ROLE.PLACEHOLDER": "Wybierz rolę",
    "USER_DETAILS_PAGE.SUBMIT": "Zapisz",
    "USER_MANAGEMENT.DROP_DOWN.TITLE": "Grupy",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_COMPANY": "Dodaj firmę",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PARTNER": "Dodaj partnera",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_PROJECT": "Dodaj projekt",
    "USER_MANAGEMENT.ROUTE_TITLES.ADD_USER": "Dodaj użytkownika",
    "USER_MANAGEMENT.ROUTE_TITLES.COMPANY": "Firma",
    "USER_MANAGEMENT.ROUTE_TITLES.PARTNER": "Partner",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT": "Projekt",
    "USER_MANAGEMENT.ROUTE_TITLES.PROJECT_ARCHIVES": "Zarchiwizowany projekt",
    "USER_MANAGEMENT.ROUTE_TITLES.RESOURCES": "Zasoby",
    "USER_MANAGEMENT.ROUTE_TITLES.USER": "Użytkownik",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_COMPANIES": "Zobacz firmy",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_GIS_UPLOADS": "Wyświetl przesłane pliki GIS",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PARTNERS": "Wyświetl partnerów",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECT_ARCHIVES": "Wyświetl archiwum",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_PROJECTS": "Zobacz projekty",
    "USER_MANAGEMENT.ROUTE_TITLES.VIEW_USERS": "Wyświetlanie użytkowników",
    "USER_ROLE.COMPANY_ADMIN": "Administrator firmy",
    "USER_ROLE.COMPANY_BUG_DEPLOYMENT_ENGINEER": "Technik ds. czujników w firmie",
    "USER_ROLE.COMPANY_LEAK_ENGINEER": "Inżynier ds. nieszczelności w firmie",
    "USER_ROLE.COMPANY_USER": "Użytkownik firmy",
    "USER_ROLE.PARTNER_ADMIN": "Partner Admin",
    "USER_ROLE.PARTNER_BUG_DEPLOYMENT_ENGINEER": "Technik ds. czujników partnerskich",
    "USER_ROLE.PARTNER_LEAK_ENGINEER": "Partner Leak Engineer",
    "USER_ROLE.PARTNER_USER": "Użytkownik partnerski",
    "USER_ROLE.SUPER_ADMIN": "Super administrator",
    "USERS_PAGE.ADD_USER.ACTIONS": "Działania",
    "USERS_PAGE.ADD_USER.BUTTON": "Nowy użytkownik",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.LABEL": "Projekt",
    "USERS_PAGE.ADD_USER.FORM.BRANCH.PLACEHOLDER": "Wybierz projekt",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.LABEL": "Firma",
    "USERS_PAGE.ADD_USER.FORM.COMPANY.PLACEHOLDER": "Wybierz firmę",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.LABEL": "Adres e-mail",
    "USERS_PAGE.ADD_USER.FORM.EMAIL.PLACEHOLDER": "Wprowadź adres e-mail",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.LABEL": "Imię",
    "USERS_PAGE.ADD_USER.FORM.FIRST_NAME.PLACEHOLDER": "Wprowadź imię",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.LABEL": "Nazwisko",
    "USERS_PAGE.ADD_USER.FORM.LAST_NAME.PLACEHOLDER": "Wpisz nazwisko",
    "USERS_PAGE.ADD_USER.FORM.ROLE.LABEL": "Rola",
    "USERS_PAGE.ADD_USER.FORM.ROLE.PLACEHOLDER": "Wybierz rolę",
    "USERS_PAGE.ADD_USER.FORM.SUBMIT": "Dodaj użytkownika",
    "USERS_PAGE.ADD_USER.STATUS": "Status",
    "USERS_PAGE.CRUMB": "Użytkownicy",
    "USERS_PAGE.DELETE_USER.TITLE": "Czy na pewno chcesz usunąć tego użytkownika?",
    "USERS_PAGE.SUBTITLE": "Inne ważne informacje znajdują się tutaj",
    "USERS_PAGE.TABLE.ACTIONS": "Działania",
    "USERS_PAGE.TABLE.COMPANY": "Firma",
    "USERS_PAGE.TABLE.EMAIL": "E-mail",
    "USERS_PAGE.TABLE.ID": "ID",
    "USERS_PAGE.TABLE.NAME": "Nazwa",
    "USERS_PAGE.TABLE.ROLE": "Rola",
    "USERS_PAGE.TABLE.STATUS": "Status",
    "USERS_PAGE.TITLE.NO_USERS": "Nie ma użytkowników",
    "USERS_PAGE.TITLE.TOTAL_COUNT": "Całkowita liczba użytkowników:",
    "VALIDATION.BRANCHES.UNIQUE": "Nazwa projektu powinna być unikalna",
    "VALIDATION.EMAIL": "Nieprawidłowy adres e-mail",
    "VALIDATION.MAX": "Powinien zawierać mniej niż %1$s znaków",
    "VALIDATION.PASSWORD.CONFIRM": "Hasło i powtórzone hasło powinny być takie same",
    "VALIDATION.PASSWORD.LONG": "Hasło powinno mieć mniej niż 128 znaków",
    "VALIDATION.PASSWORD.SHORT": "Hasło powinno składać się z więcej niż 8 znaków",
    "VALIDATION.PASSWORD.SPECIAL": "Hasło musi zawierać co najmniej jeden znak specjalny",
    "VALIDATION.PHONE": "Telefon jest nieprawidłowy",
    "VALIDATION.REQUIRED": "Wymagane",
    "VIEW_COMPANIES.BUTTON.ADD": "Dodaj firmę",
    "VIEW_COMPANIES.DELETE_ICON": "Ikona usuwania",
    "VIEW_COMPANIES.EDIT_ICON": "Ikona edycji",
    "VIEW_COMPANIES.TITLE.ACTION": "Działanie",
    "VIEW_COMPANIES.TITLE.COMPANY_CODE": "Kod firmy",
    "VIEW_COMPANIES.TITLE.COUNTRY": "Kod kraju",
    "VIEW_COMPANIES.TITLE.CURRENCY": "Waluta",
    "VIEW_COMPANIES.TITLE.LIST": "Lista firm",
    "VIEW_COMPANIES.TITLE.NAME": "Nazwa",
    "VIEW_COMPANIES.TITLE.PAGE": "Zobacz firmy",
    "VIEW_COMPANIES.TITLE.PARTNER": "Partner",
    "VIEW_COMPANIES.TITLE.UNIT": "Jednostka",
    "VIEW_DRAFTS.DIALOG.DELETE.CANCEL": "Lekceważenie",
    "VIEW_DRAFTS.DIALOG.DELETE.CONFIRM": "Usuwać",
    "VIEW_DRAFTS.DIALOG.DELETE.TITLE": "Czy na pewno chcesz usunąć ten szkic?",
    "VIEW_DRAFTS.TITLE.PAGE": "Wyświetl wersje robocze",
    "VIEW_PARTNERS.BUTTON.ADD": "Dodaj partnera",
    "VIEW_PARTNERS.TITLE.ACTION": "Działanie",
    "VIEW_PARTNERS.TITLE.COUNTRY": "Kod kraju",
    "VIEW_PARTNERS.TITLE.LIST": "Lista partnerów",
    "VIEW_PARTNERS.TITLE.NAME": "Nazwa",
    "VIEW_PARTNERS.TITLE.PAGE": "Wyświetl partnerów",
    "VIEW_PARTNERS.TITLE.PARTNER_CODE": "Kod partnera",
    "VIEW_PROJECT_ARCHIVES.DESCRIPTION": "Aby ponownie aktywować projekt, skontaktuj się z pomocą techniczną.",
    "VIEW_PROJECTS.ACTION.APPROVE": "Zatwierdzić",
    "VIEW_PROJECTS.ACTION.ARCHIVE": "Archiwum",
    "VIEW_PROJECTS.ACTION.DECLINE": "Spadek",
    "VIEW_PROJECTS.ACTION.DELETE": "Usuwać",
    "VIEW_PROJECTS.ACTION.EDIT": "Redagować",
    "VIEW_PROJECTS.ACTION.REJECT": "Odrzucić",
    "VIEW_PROJECTS.ACTION.VIEW": "Pogląd",
    "VIEW_PROJECTS.ACTION.VIEW_REJECTION_NOTES": "Wyświetl notatki dotyczące odrzucenia",
    "VIEW_PROJECTS.BUTTON.ADD": "Dodaj projekt",
    "VIEW_PROJECTS.DIALOG.APPROVE.CANCEL": "Lekceważenie",
    "VIEW_PROJECTS.DIALOG.APPROVE.CONFIRM": "Zatwierdzić",
    "VIEW_PROJECTS.DIALOG.APPROVE.TITLE": "Czy na pewno chcesz zatwierdzić ten projekt?",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CANCEL": "Lekceważenie",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.CONFIRM": "Potwierdzać",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.DESCRIPTION": "Po przeniesieniu projektu do archiwum pliki, punkty nawigacyjne i sesje z nim powiązane będą nieaktywne i niedostępne. Aby ponownie aktywować projekt, możesz złożyć zgłoszenie do pomocy technicznej.",
    "VIEW_PROJECTS.DIALOG.ARCHIVE.TITLE": "Czy na pewno chcesz zarchiwizować ten projekt?",
    "VIEW_PROJECTS.DIALOG.DELETE.CANCEL": "Lekceważenie",
    "VIEW_PROJECTS.DIALOG.DELETE.CONFIRM": "Usuwać",
    "VIEW_PROJECTS.DIALOG.DELETE.TITLE": "Czy na pewno chcesz usunąć ten projekt?",
    "VIEW_PROJECTS.DIALOG.REJECT.CANCEL": "Lekceważenie",
    "VIEW_PROJECTS.DIALOG.REJECT.CONFIRM": "Odrzucić",
    "VIEW_PROJECTS.DIALOG.REJECT.TITLE": "Czy na pewno chcesz odrzucić ten projekt?",
    "VIEW_PROJECTS.FORM.FILTER.ALL": "Wszystko",
    "VIEW_PROJECTS.FORM.FILTER.APPROVED": "Zatwierdzony",
    "VIEW_PROJECTS.FORM.FILTER.SUBMITTED": "Złożony",
    "VIEW_PROJECTS.NOT_FOUND": "Nie znaleziono projektów",
    "VIEW_PROJECTS.TITLE.ACTION": "Działanie",
    "VIEW_PROJECTS.TITLE.AUTHOR": "Stworzone przez",
    "VIEW_PROJECTS.TITLE.COMPANY": "Firma",
    "VIEW_PROJECTS.TITLE.DMAS": "Wyświetlanie DMA",
    "VIEW_PROJECTS.TITLE.DMAS_SUBLIST_TITLE": "Lista DMA",
    "VIEW_PROJECTS.TITLE.END_DATE": "Data zakończenia",
    "VIEW_PROJECTS.TITLE.LIST": "Lista projektów",
    "VIEW_PROJECTS.TITLE.NAME": "Nazwa",
    "VIEW_PROJECTS.TITLE.NO_DMAS": "Brak DMA",
    "VIEW_PROJECTS.TITLE.PAGE": "Zobacz projekty",
    "VIEW_PROJECTS.TITLE.START_DATE": "Data rozpoczęcia",
    "VIEW_PROJECTS.TITLE.STATUS": "Status",
    "VIEW_USERS.ACTION.DELETE": "Usuwać",
    "VIEW_USERS.ACTION.EDIT": "Redagować",
    "VIEW_USERS.ACTION.FORGOT_PASSWORD": "Zresetuj hasło",
    "VIEW_USERS.BUTTON.ADD": "Dodaj użytkownika",
    "VIEW_USERS.BUTTON.INVITE": "Zaproś użytkownika",
    "VIEW_USERS.PAGINATION.TITLE": "Wiersze na stronę",
    "VIEW_USERS.ROW.ICON.DELETE.ALT": "Ikona usuwania",
    "VIEW_USERS.ROW.ICON.EDIT.ALT": "Ikona edycji",
    "VIEW_USERS.TITLE.LIST": "Lista użytkowników",
    "VIEW_USERS.TITLE.PAGE": "Wyświetlanie użytkowników",
    "VIEW_USERS.TITLE.ROW_FIVE": "Działanie",
    "VIEW_USERS.TITLE.ROW_FOUR": "Rola",
    "VIEW_USERS.TITLE.ROW_ONE": "Nazwa",
    "VIEW_USERS.TITLE.ROW_THREE": "Firma",
    "VIEW_USERS.TITLE.ROW_TWO": "Partner",
    "WAYPOINT_PAGE.ADD_JOB.ADDRESS": "Adres",
    "WAYPOINT_PAGE.ADD_JOB.DATE_EXTERNALLY": "Data zgłoszenia zewnętrznego",
    "WAYPOINT_PAGE.ADD_JOB.DATE_INTERNALLY": "Data podniesiona wewnętrznie",
    "WAYPOINT_PAGE.ADD_JOB.DESCRIPTION": "Dodaj zadanie do punktu kontrolnego",
    "WAYPOINT_PAGE.ADD_JOB.DISCARD": "Odrzucenie",
    "WAYPOINT_PAGE.ADD_JOB.ENGINEERING_NOTE": "Uwaga techniczna",
    "WAYPOINT_PAGE.ADD_JOB.ENVIRONMENTAL_NOTE": "Uwaga dotycząca środowiska",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.DESC": "Odśwież i spróbuj ponownie",
    "WAYPOINT_PAGE.ADD_JOB.ERROR.TITLE": "Coś poszło nie tak",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE": "Szacowany rozmiar wycieku",
    "WAYPOINT_PAGE.ADD_JOB.ESTIMATED_SIZE_UNIT": "Jednostka rozmiaru wycieku",
    "WAYPOINT_PAGE.ADD_JOB.FLOW_REDUCTION": "Uzgodniona redukcja przepływu (m3/godz.)",
    "WAYPOINT_PAGE.ADD_JOB.IMAGE_ALT": "Przesłany obraz %1$s",
    "WAYPOINT_PAGE.ADD_JOB.IMAGES": "Głoska bezdźwięczna",
    "WAYPOINT_PAGE.ADD_JOB.JOB_COMMENT": "Uwagi",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS": "Status pracy",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.CANCELLED": "Anulowane",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG": "Dry Dig",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.DRY_DIG_APPEALED": "Odwołanie od decyzji Dry Dig",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.NFA": "NFA (brak dalszych działań)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.PLACEHOLDER": "Wybierz status zadania",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_EXTERNALLY": "Podniesiony na zewnątrz",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RAISED_INTERNALLY": "Podniesiony wewnętrznie",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.REPAIRED": "Naprawiono",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.RFA": "RFA (wniosek o podjęcie dalszych działań)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_STATUS.VALIDATION": "Prosimy o podanie statusu pracy",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE": "Rodzaj pracy",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.ASSET_VALVE_HYDRANT_LEAK": "Nieszczelność zasobu (zawór/hydrant)",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CLIENT_METER_PRV_LEAK": "Nieszczelność licznika klienta/PRV",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.COMM_PIPE_LEAK": "Wyciek z rury komunikacyjnej",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_METER_LEAK": "Wyciek z licznika klienta",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.CUSTOMER_SIDE_LEAK": "Wyciek po stronie klienta",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.FERRULE_LEAK": "Nieszczelność tulei",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.MAINS_LEAK": "Wyciek z sieci",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.NETWORK_MAINTENANCE": "Konserwacja sieci",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.PLACEHOLDER": "Wybierz typ zadania",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RENEW_STOP_TAP_MSM": "Odnowić kran stopowy/MSM",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.RESOLVED_ONSITE": "Rozwiązany na miejscu",
    "WAYPOINT_PAGE.ADD_JOB.JOB_TYPE.VALIDATION": "Podaj rodzaj pracy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_ESTIMATE": "Szacunkowy rozmiar wycieku dla klienta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE": "Typ wycieku",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.ASSET_LEAK": "Wyciek aktywów",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CLIENT_METER_PRV_LEAK": "Nieszczelność licznika/ zaworu PRV klienta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMERCIAL_REPAIR": "Naprawa komercyjna",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.COMMUNICATION_PIPE": "Przewód komunikacyjny",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CSL": "CSL",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_METER_LEAK": "Wyciek z licznika klienta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.CUSTOMER_SIDE_LEAK": "Wyciek po stronie klienta",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.DECOMMISSION_FERRULE": "Zlikwidować tuleję",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXCAVATE_TRIAL_HOLE_PERMIT": "Wykopanie otworu próbnego (zezwolenie)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_INC_EXC": "Zewnętrzny miernik wycieków>40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_GT_40MM_NO_EXC": "Zewnętrzny miernik wycieków>40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_INC_EXC": "Zewnętrzny miernik wycieków<40mm Inc Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.EXTERNAL_LEAKING_METER_LT_40MM_NO_EXC": "Zewnętrzny miernik wycieków<40mm No Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FERRULE": "Okucie",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FH_STOPPED_ON_SITE": "F/H zatrzymany na miejscu",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_HYDRANT": "Hydrant przeciwpożarowy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FIRE_MAIN": "Główny ogień",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_NO_EXC": "Test przepływu na granicy nr Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.FLOW_TEST_AT_BOUNDARY_WITH_EXC": "Test przepływu na granicy z Exc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INST_MSM_TO_EXIST_COMM_PIPE_UNMTRD": "Inst MSM to Exist Comm Pipe UnMtrd",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_FERRULE_ONLY": "Zainstalować tylko tuleję",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_MSM_INC_METER": "Instalacja licznika MSM Inc",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SAMPLE_TAP": "Zainstaluj przykładowy kran",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_SLUICE_VALVE": "Instalacja zaworu śluzy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.INSTALL_WASHOUT_HYDRANT": "Instalacja hydrantu wymywalnego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_FIXED_ONSITE": "Nieszczelność usunięta na miejscu",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_FH": "Wyciek na F/H ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV": "Wyciek na wrzecionie SV",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.LEAK_ON_SPINDLE_OF_SV_FLANGE": "Wyciek na wrzecionie SV / kołnierzu. ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS": "Główne",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_BURST": "Rozerwanie sieci ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.MAINS_LEAK": "Wyciek z sieci",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NA_WO_STOPPED_ON_SITE": "Nie dotyczy - W/O zatrzymany na miejscu ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NETWORK_MAINTENANCE": "Konserwacja sieci",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.NO_LEAK": "Brak wycieku",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OSV_EXCHANGE": "OSV Exchange",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.OTHER": "Inne",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_FH": "Podanie FH",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PASSING_HYDRANT": "Przejeżdżający hydrant",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.PLACEHOLDER": "Wybierz typ wycieku",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMEDIAL_WORK_EXTERNAL": "Prace naprawcze na zewnątrz",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REMOVE_SLUICE_VAVLE": "Usunięcie śluzy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_LONGSIDE": "Renew Communication Pipe Longside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COMMUNICATION_PIPE_SHORTSIDE": "Renew Communication Pipe Shortside",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_COVER_FRAME_STANDARD": "Odnowiona pokrywa i ramka (standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FERRULE_ONLY": "Tylko odnowienie tulei",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT": "Odnowienie hydrantu przeciwpożarowego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_CHAMBER": "Odnowić komorę hydrantu przeciwpożarowego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_FIRE_HYDRANT_FRAME_COVER": "Odnowienie ramy i pokrywy hydrantu przeciwpożarowego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_GT_10M": "Odnowienie przeciekającej rury zasilającej >10m",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_LEAKING_SUPPLY_PIPE_LT_10M": "Odnowienie przeciekającej rury zasilającej <10m ",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_MSM_STOP_TAP_ASSEMBLY": "Odnowienie zespołu MSM/Stop Tap",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_SLUICE_VAVLE": "Odnowiona śluza Vavle",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RENEW_WASHOUT_HYDRANT": "Odnowienie hydrantu wypłukującego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPACK_SLUICE_VALVE": "Przepakowanie zaworu śluzy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_COMMUNICATION_PIPE": "Naprawa rury komunikacyjnej",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_EXTERNAL_LSP_NON_ELIGIBLE": "Naprawa zewnętrznego LSP - niekwalifikowalne",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_INTERNAL_LEAK_RECH": "Naprawa nieszczelności wewnętrznej (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LEAKING_SUPPLY_PIPE_RECH": "Naprawa nieszczelnej rury zasilającej (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LOP": "Naprawa LOP",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_LSP_ELIGIBLE": "Naprawa LSP - kwalifikuje się",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_GTE_200MM": "Główny trzpień naprawczy >= 200 mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_DOWEL_PIECE_LT_200MM": "Główny trzpień naprawczy <200 mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_GTE_200MM": "Główny element naprawczy [nie kołek] >= 200 mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAIN_NOT_DOWEL_LT_200MM": "Główny element naprawczy [nie kołek] <200mm",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_MAJOR_BURST": "Naprawa poważnego pęknięcia",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_NON_RETURN_VALVE": "Naprawa zaworu zwrotnego",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_RUNNING_OVERFLOW_RECH": "Naprawa działającego przelewu (Rech)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPAIR_SLUICE_VALVE": "Naprawa zaworu śluzy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.REPOSITION_MSM_STOP_TAP_ASSEMBLY": "Zmiana położenia zespołu MSM/Stop Tap",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.RESET_SURFACE_BOX_STANDARD": "Reset Surface Box (Standard)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SERVICE_LEAK": "Wyciek serwisowy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE": "Zawór śluzy",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.SLUICE_VALVE_VL": "Zawór śluzy (VL)",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_EXCHANGE": "Stop Tap Exchange",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK": "Zatrzymaj wyciek z kranu",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.STOP_TAP_LEAK_NO_7_FERRULE_EXCHANGE_NO_5": "Zatrzymaj wyciek z kranu nr 7\\n\\nWymiana tulei nr 5",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.VALIDATION": "Podaj typ wycieku",
    "WAYPOINT_PAGE.ADD_JOB.LEAK_TYPE.WO_FH": "WO / FH",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER": "Średnica rury",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_DIAMETER_UNIT": "Jednostka średnicy",
    "WAYPOINT_PAGE.ADD_JOB.PIPE_MATERIAL": "Materiał rury",
    "WAYPOINT_PAGE.ADD_JOB.REMOVE_IMAGE_ARIA": "Usuń obraz %1$s",
    "WAYPOINT_PAGE.ADD_JOB.REPAIR_DATE": "Data naprawy",
    "WAYPOINT_PAGE.ADD_JOB.ROAD_SPEED": "Prędkość drogowa",
    "WAYPOINT_PAGE.ADD_JOB.SELECT_UNIT.PLACEHOLDER": "Wybierz jednostkę",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT": "Dodaj nowe zadanie",
    "WAYPOINT_PAGE.ADD_JOB.SUBMIT.VALIDATION": "Walidacja nie powiodła się, sprawdź dane wejściowe.",
    "WAYPOINT_PAGE.ADD_JOB.SUCCESS": "Zadanie dodane pomyślnie",
    "WAYPOINT_PAGE.ADD_JOB.SURFACE_TYPE": "Typ powierzchni",
    "WAYPOINT_PAGE.ADD_JOB.TITLE": "Dodaj zadanie do punktu trasy",
    "WAYPOINT_PAGE.ADD_JOB.W3W": "What3Words",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER": "Numer referencyjny zlecenia pracy klienta/usługodawcy",
    "WAYPOINT_PAGE.ADD_JOB.WORK_ORDER.VALIDATION": "Prosimy o podanie numeru referencyjnego zlecenia klienta/usługodawcy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.ACTION": "Działanie",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.DATE": "Data",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.address": "Adres",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.agreed_flow_reduction": "Redukcja przepływu",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.comment": "Komentarz",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_externally": "Data zgłoszenia zewnętrznego",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.date_raised_internally": "Data podniesiona wewnętrznie",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.environmental_notes": "Uwagi dotyczące środowiska",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.estimate_leak_size": "Szacowany rozmiar wycieku",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.id": "ID",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_status": "Status pracy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.job_type": "Rodzaj pracy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.leak_type_id": "Identyfikator typu wycieku",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.material": "Materiał",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.pipe_diameter": "Średnica rury",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.repair_date": "Data naprawy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.road_speed": "Prędkość drogowa",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.surface_type": "Typ powierzchni",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.urls": "Adresy URL",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.w3w": "W3W",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.waypoint_id": "Identyfikator punktu trasy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.KEYS.work_order": "Numer referencyjny zlecenia pracy klienta/usługodawcy",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NEW": "Nowa wartość",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.NOTES": "Dodatkowe uwagi",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.OLD": "Poprzednia wartość",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.STATUS": "Status",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.TITLE": "Dzienniki zadań",
    "WAYPOINT_PAGE.JOB_LOG_TABLE.USER": "Użytkownik",
    "WAYPOINT_PAGE.JOB_TABLE.CREATED_DATE": "Data utworzenia",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_ERROR": "Data rozpoczęcia musi być wcześniejsza niż data zakończenia",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE": "Data Typ",
    "WAYPOINT_PAGE.JOB_TABLE.DATE_TYPE.PLACEHOLDER": "Wybierz typ daty",
    "WAYPOINT_PAGE.JOB_TABLE.END_DATE": "Data zakończenia",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Asset (Valve/Hydrant) Leak": "Nieszczelność zasobu (zawór/hydrant)",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Cancelled": "Anulowane",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Client Meter/PRV Leak": "Wyciek z licznika klienta/PRV",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Comm Pipe Leak": "Wyciek z rury komunikacyjnej",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Customer Meter Leak": "Wyciek z licznika klienta",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Ferrule Leak": "Nieszczelność tulei",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Leak Repair": "Naprawa nieszczelności",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Mains Leak": "Wyciek z sieci",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised externally": "Podniesiony na zewnątrz",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Raised internally": "Podniesiony wewnętrznie",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Repaired": "Naprawiono",
    "WAYPOINT_PAGE.JOB_TABLE.FILTER.Scheduled": "Zaplanowane",
    "WAYPOINT_PAGE.JOB_TABLE.FILTERS": "Filtry, sortowanie i wyszukiwanie",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.CREATED": "Data utworzenia",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.FLOW_REDUCTION": "Uzgodniona redukcja przepływu",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_COMMENTS": "Uwagi",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_STATUS": "Status pracy",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.JOB_TYPE": "Rodzaj pracy",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_SIZE": "Rozmiar wycieku",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.LEAK_TYPE": "Typ wycieku",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.REPAIR_DATE": "Data naprawy",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.UPDATED_DATE": "Data aktualizacji",
    "WAYPOINT_PAGE.JOB_TABLE.HEADER.WORK_ORDER": "Numer referencyjny zlecenia pracy klienta/usługodawcy",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA": "Brak pasujących ofert pracy",
    "WAYPOINT_PAGE.JOB_TABLE.NO_DATA_EXISTS": "Dla tego punktu trasy nie istnieją żadne zadania",
    "WAYPOINT_PAGE.JOB_TABLE.REPAIR_DATE": "Data naprawy",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.BUTTON": "Stosowanie filtrów, sortowanie i wyszukiwanie",
    "WAYPOINT_PAGE.JOB_TABLE.SEARCH.PLACEHOLDER": "Szukaj pracy...",
    "WAYPOINT_PAGE.JOB_TABLE.START_DATE": "Data rozpoczęcia",
    "WAYPOINT_PAGE.JOB_TABLE.TITLE": "Oferty pracy dla Waypoint",
    "WAYPOINT_PAGE.JOB_TABLE.UPDATED_DATE": "Data aktualizacji",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ACTUAL_LEAK_TYPE": "Rzeczywisty typ wycieku",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADD_JOB": "Dodaj pracę",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ADDRESS": "Adres",
    "WAYPOINT_PAGE.WAYPOINT_INFO.AI_PREDICTED_LEAK_SIZE": "Sztuczna inteligencja przewidziała rozmiar wycieku",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ASSIGNED_ENGINEER": "Przydzielony inżynier",
    "WAYPOINT_PAGE.WAYPOINT_INFO.BTN_MERGE": "Scal punkt trasy",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CANCEL": "Anuluj",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CNS": "CNS",
    "WAYPOINT_PAGE.WAYPOINT_INFO.COMMENT": "Uwaga techniczna",
    "WAYPOINT_PAGE.WAYPOINT_INFO.CURRENT_STATUS": "Status",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER": "Średnica",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DIAMETER_UNIT": "Jednostka średnicy",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_NAME": "Nazwa DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.DMA_REFERENCE": "Odniesienie DMA",
    "WAYPOINT_PAGE.WAYPOINT_INFO.EDIT_FIELDS": "Pola edycji",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ENVIRONMENTAL_NOTES": "Uwagi dotyczące środowiska",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE": "Uzgodniona redukcja przepływu",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT": "Szacunkowy rozmiar wycieku dla klienta",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_CLIENT_UNIT": "Jednostka szacowania rozmiaru wycieku klienta",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER": "Oszacowanie rozmiaru wycieku na miejscu",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_ENGINEER_UNIT": "Jednostka szacowania wielkości wycieku na miejscu",
    "WAYPOINT_PAGE.WAYPOINT_INFO.ESTIMATED_SIZE_UNIT": "Jednostka redukcji przepływu uzgodnionego",
    "WAYPOINT_PAGE.WAYPOINT_INFO.JOB_TYPE_CODE": "Kod pracy",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_SCHEDULED_ENGINEER": "Przydzielony inżynier",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LAST_UPDATE": "Dni od ostatniej aktualizacji",
    "WAYPOINT_PAGE.WAYPOINT_INFO.LEAK_TYPE": "Typ wycieku",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PIPE_MATERIAL": "Materiał rury",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.DATE": "Wybierz datę",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.ENGINEER": "Przydzielanie inżyniera",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.JOB_TYPE_CODE": "Wybierz kod zadania",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.LEAK_TYPE": "Wybierz typ wycieku",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.MATERIAL": "Materiał rury",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PLACEHOLDER.STATUS": "Wybierz status",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_LEAK_SIZE": "Oszacowanie typu wycieku na miejscu",
    "WAYPOINT_PAGE.WAYPOINT_INFO.PREDICTED_SIZE": "Przewidywany rozmiar",
    "WAYPOINT_PAGE.WAYPOINT_INFO.REPAIR_TIME": "Dig Date",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SUBMIT": "Zapisz",
    "WAYPOINT_PAGE.WAYPOINT_INFO.SURFACE_TYPE": "Typ powierzchni",
    "WAYPOINT_PAGE.WAYPOINT_INFO.TITLE": "Informacje o punkcie trasy",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WAYPOINT_NAME": "Nazwa punktu trasy",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT_3_WORDS": "Jakie 3 słowa",
    "WAYPOINT_PAGE.WAYPOINT_INFO.WHAT3WORDS": "What3Words",
    "WAYPOINT_SIZE_WIDGET.DAY": "Dzień",
    "WAYPOINT_SIZE_WIDGET.DAY_other": "Dni",
    "WAYPOINT_SIZE_WIDGET.NO_NAME": "Brak",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_A": "Najnowszy wyciek",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_B": "Najdłuższy wyciek",
    "WAYPOINT_SIZE_WIDGET.SUBTITLE_C": "Największy wyciek",
    "WAYPOINT_SIZE_WIDGET.TITLE": "Punkty trasy",
    "WIDGET_LAYOUT.CANCEL_TEXT": "Nie",
    "WIDGET_LAYOUT.CONFIRM_TEXT": "Tak",
    "WIDGET_LAYOUT.FILTERS": "Filtry",
    "WIDGET_LAYOUT.MAP_VIEW": "Widok mapy",
    "WIDGET_LAYOUT.REMOVE_WIDGET": "Usuń widżet",
    "WIDGET_LAYOUT.SETTINGS": "Ustawienia",
    "WIDGET_LAYOUT.SUBTITLE": "Wszystkie ustawienia zostaną usunięte",
    "WIDGET_LAYOUT.SUMMARY": "Podsumowanie",
    "WIDGET_LAYOUT.TABLE_OF_RESULTS": "Tabela wyników",
    "WIDGET_LAYOUT.TITLE": "Czy na pewno chcesz usunąć ten widżet?",
    "BROWSE_VIEW.RELAY.UPTIME": "Czas sprawności przekaźnika",
    "BROWSE_VIEW.WAYPOINT.EDIT": "redagować",
    "BROWSE_VIEW.WAYPOINT.MERGE_W": "Połącz punkty kontrolne",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA": "Głoska bezdźwięczna",
    "BROWSE_VIEW.WAYPOINT.SECTION.MEDIA_EMPTY": "Brak multimediów dla tego punktu kontrolnego",
    "BROWSE_VIEW.WAYPOINT.SHARE": "udział",
    "BROWSE.FILTERS.PREDICTED_SIZE.NO_PREDICTION": "Brak przewidywania",
    "BROWSE.FILTERS.UPTIME": "Czas sprawności",
    "BROWSE.FILTERS.UPTIME_PLACEHOLDER": "Wybierz czas sprawności",
    "BROWSE.FILTERS.UPTIME.AVERAGE": "Przeciętny",
    "BROWSE.FILTERS.UPTIME.GOOD": "Dobry",
    "BROWSE.FILTERS.UPTIME.HIGH": "Wysoki",
    "BROWSE.FILTERS.UPTIME.LOW": "Niski",
    "BROWSE.FILTERS.UPTIME.MEDIUM": "Średni",
    "BROWSE.FILTERS.UPTIME.POOR": "Słaby",
    "BROWSE.TABLE.COLUMNS.UPTIME": "Czas sprawności"
  }
}
